var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 550 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath-73);\n      }\n\n      .cls-2 {\n        fill: #c6c4db;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52 {\n        stroke-width: 0px;\n      }\n\n      .cls-53, .cls-30 {\n        fill: #f4f4fb;\n      }\n\n      .cls-54 {\n        clip-path: url(#clippath-234);\n      }\n\n      .cls-3 {\n        fill: #f7736a;\n      }\n\n      .cls-55 {\n        clip-path: url(#clippath-206);\n      }\n\n      .cls-4, .cls-56 {\n        fill: #f8f8fd;\n      }\n\n      .cls-57 {\n        clip-path: url(#clippath-72);\n      }\n\n      .cls-5 {\n        fill: #f2665d;\n      }\n\n      .cls-58 {\n        clip-path: url(#clippath-62);\n      }\n\n      .cls-59 {\n        clip-path: url(#clippath-186);\n      }\n\n      .cls-60 {\n        clip-path: url(#clippath-45);\n      }\n\n      .cls-61 {\n        clip-path: url(#clippath-208);\n      }\n\n      .cls-62, .cls-15, .cls-20, .cls-41 {\n        fill: #e7e6f1;\n      }\n\n      .cls-63 {\n        clip-path: url(#clippath-63);\n      }\n\n      .cls-64 {\n        clip-path: url(#clippath-188);\n      }\n\n      .cls-6 {\n        fill: #cccbf6;\n      }\n\n      .cls-65, .cls-21 {\n        fill: #e3e2f2;\n      }\n\n      .cls-7 {\n        fill: #ff5852;\n      }\n\n      .cls-66 {\n        clip-path: url(#clippath-170);\n      }\n\n      .cls-67 {\n        clip-path: url(#clippath-20);\n      }\n\n      .cls-68 {\n        clip-path: url(#clippath-135);\n      }\n\n      .cls-8 {\n        fill: #043299;\n      }\n\n      .cls-69 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-70 {\n        clip-path: url(#clippath-123);\n      }\n\n      .cls-71 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-72 {\n        clip-path: url(#clippath-157);\n      }\n\n      .cls-73 {\n        clip-path: url(#clippath-59);\n      }\n\n      .cls-74 {\n        clip-path: url(#clippath-78);\n      }\n\n      .cls-75 {\n        clip-path: url(#clippath-207);\n      }\n\n      .cls-76 {\n        clip-path: url(#clippath-199);\n      }\n\n      .cls-77 {\n        clip-path: url(#clippath-169);\n      }\n\n      .cls-78 {\n        clip-path: url(#clippath-93);\n      }\n\n      .cls-9, .cls-79 {\n        fill: #7579b6;\n      }\n\n      .cls-80 {\n        clip-path: url(#clippath-158);\n      }\n\n      .cls-81 {\n        clip-path: url(#clippath-89);\n      }\n\n      .cls-82 {\n        clip-path: url(#clippath-33);\n      }\n\n      .cls-10 {\n        fill: #000;\n      }\n\n      .cls-83 {\n        clip-path: url(#clippath-64);\n      }\n\n      .cls-84 {\n        clip-path: url(#clippath-233);\n      }\n\n      .cls-85 {\n        clip-path: url(#clippath-47);\n      }\n\n      .cls-86 {\n        clip-path: url(#clippath-220);\n      }\n\n      .cls-87 {\n        clip-path: url(#clippath-94);\n      }\n\n      .cls-88 {\n        clip-path: url(#clippath-77);\n      }\n\n      .cls-89 {\n        clip-path: url(#clippath-162);\n      }\n\n      .cls-90 {\n        clip-path: url(#clippath-121);\n      }\n\n      .cls-11, .cls-91 {\n        fill: #f9f9f9;\n      }\n\n      .cls-12 {\n        fill: #231869;\n      }\n\n      .cls-92 {\n        clip-path: url(#clippath-160);\n      }\n\n      .cls-93 {\n        clip-path: url(#clippath-116);\n      }\n\n      .cls-94 {\n        clip-path: url(#clippath-161);\n      }\n\n      .cls-13 {\n        fill: #f8f9f3;\n      }\n\n      .cls-95 {\n        clip-path: url(#clippath-151);\n      }\n\n      .cls-14 {\n        fill: #133aa5;\n      }\n\n      .cls-15 {\n        opacity: .5;\n      }\n\n      .cls-96 {\n        clip-path: url(#clippath-136);\n      }\n\n      .cls-97, .cls-47 {\n        fill: #f05850;\n      }\n\n      .cls-16 {\n        fill: #bfbeed;\n      }\n\n      .cls-98 {\n        clip-path: url(#clippath-132);\n      }\n\n      .cls-99 {\n        clip-path: url(#clippath-41);\n      }\n\n      .cls-100 {\n        clip-path: url(#clippath-32);\n      }\n\n      .cls-101 {\n        clip-path: url(#clippath-190);\n      }\n\n      .cls-102 {\n        clip-path: url(#clippath-197);\n      }\n\n      .cls-103 {\n        clip-path: url(#clippath-108);\n      }\n\n      .cls-104 {\n        clip-path: url(#clippath-163);\n      }\n\n      .cls-105 {\n        clip-path: url(#clippath-112);\n      }\n\n      .cls-106 {\n        clip-path: url(#clippath-87);\n      }\n\n      .cls-17 {\n        fill: #e0dde1;\n      }\n\n      .cls-18 {\n        fill: #f5f5fa;\n      }\n\n      .cls-107 {\n        clip-path: url(#clippath-217);\n      }\n\n      .cls-108 {\n        clip-path: url(#clippath-194);\n      }\n\n      .cls-109 {\n        clip-path: url(#clippath-142);\n      }\n\n      .cls-110 {\n        clip-path: url(#clippath-173);\n      }\n\n      .cls-111 {\n        clip-path: url(#clippath-236);\n      }\n\n      .cls-112 {\n        clip-path: url(#clippath-83);\n      }\n\n      .cls-113 {\n        clip-path: url(#clippath-128);\n      }\n\n      .cls-114 {\n        clip-path: url(#clippath-119);\n      }\n\n      .cls-115 {\n        clip-path: url(#clippath-114);\n      }\n\n      .cls-116 {\n        clip-path: url(#clippath-243);\n      }\n\n      .cls-117 {\n        clip-path: url(#clippath-185);\n      }\n\n      .cls-118 {\n        clip-path: url(#clippath-105);\n      }\n\n      .cls-119 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-120 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-121 {\n        clip-path: url(#clippath-88);\n      }\n\n      .cls-122 {\n        isolation: isolate;\n      }\n\n      .cls-123 {\n        clip-path: url(#clippath-115);\n      }\n\n      .cls-124 {\n        clip-path: url(#clippath-182);\n      }\n\n      .cls-125, .cls-23 {\n        fill: #cfcde2;\n      }\n\n      .cls-126 {\n        clip-path: url(#clippath-124);\n      }\n\n      .cls-127 {\n        clip-path: url(#clippath-225);\n      }\n\n      .cls-128 {\n        clip-path: url(#clippath-37);\n      }\n\n      .cls-129 {\n        clip-path: url(#clippath-46);\n      }\n\n      .cls-130 {\n        clip-path: url(#clippath-25);\n      }\n\n      .cls-131 {\n        clip-path: url(#clippath-98);\n      }\n\n      .cls-132, .cls-20 {\n        opacity: .2;\n      }\n\n      .cls-19 {\n        fill: #2d2331;\n      }\n\n      .cls-133 {\n        clip-path: url(#clippath-219);\n      }\n\n      .cls-134 {\n        clip-path: url(#clippath-172);\n      }\n\n      .cls-135 {\n        clip-path: url(#clippath-107);\n      }\n\n      .cls-136 {\n        clip-path: url(#clippath-164);\n      }\n\n      .cls-137 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-138 {\n        clip-path: url(#clippath-196);\n      }\n\n      .cls-139 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-140 {\n        clip-path: url(#clippath-153);\n      }\n\n      .cls-141 {\n        clip-path: url(#clippath-104);\n      }\n\n      .cls-142 {\n        clip-path: url(#clippath-76);\n      }\n\n      .cls-22, .cls-143 {\n        fill: #262028;\n      }\n\n      .cls-144 {\n        clip-path: url(#clippath-40);\n      }\n\n      .cls-145 {\n        clip-path: url(#clippath-117);\n      }\n\n      .cls-146 {\n        clip-path: url(#clippath-26);\n      }\n\n      .cls-147 {\n        clip-path: url(#clippath-81);\n      }\n\n      .cls-148 {\n        clip-path: url(#clippath-111);\n      }\n\n      .cls-149 {\n        clip-path: url(#clippath-181);\n      }\n\n      .cls-150 {\n        clip-path: url(#clippath-75);\n      }\n\n      .cls-24 {\n        fill: #444454;\n      }\n\n      .cls-25 {\n        fill: none;\n      }\n\n      .cls-151 {\n        clip-path: url(#clippath-189);\n      }\n\n      .cls-26 {\n        fill: #f2f2fc;\n      }\n\n      .cls-152 {\n        clip-path: url(#clippath-226);\n      }\n\n      .cls-153 {\n        clip-path: url(#clippath-167);\n      }\n\n      .cls-154 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-155 {\n        clip-path: url(#clippath-21);\n      }\n\n      .cls-27 {\n        fill: #2a1a30;\n      }\n\n      .cls-156 {\n        clip-path: url(#clippath-130);\n      }\n\n      .cls-157, .cls-40 {\n        fill: #edecf8;\n      }\n\n      .cls-158 {\n        clip-path: url(#clippath-34);\n      }\n\n      .cls-159 {\n        clip-path: url(#clippath-214);\n      }\n\n      .cls-160 {\n        clip-path: url(#clippath-176);\n      }\n\n      .cls-161 {\n        clip-path: url(#clippath-57);\n      }\n\n      .cls-162 {\n        clip-path: url(#clippath-102);\n      }\n\n      .cls-163 {\n        clip-path: url(#clippath-228);\n      }\n\n      .cls-164 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-165 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-166 {\n        clip-path: url(#clippath-138);\n      }\n\n      .cls-167 {\n        clip-path: url(#clippath-210);\n      }\n\n      .cls-168 {\n        clip-path: url(#clippath-38);\n      }\n\n      .cls-169 {\n        clip-path: url(#clippath-200);\n      }\n\n      .cls-170 {\n        clip-path: url(#clippath-36);\n      }\n\n      .cls-171 {\n        clip-path: url(#clippath-127);\n      }\n\n      .cls-172 {\n        clip-path: url(#clippath-27);\n      }\n\n      .cls-173 {\n        clip-path: url(#clippath-125);\n      }\n\n      .cls-174 {\n        clip-path: url(#clippath-109);\n      }\n\n      .cls-28 {\n        fill: #676bac;\n      }\n\n      .cls-29, .cls-175 {\n        fill: #fe443e;\n      }\n\n      .cls-176 {\n        clip-path: url(#clippath-149);\n      }\n\n      .cls-177 {\n        clip-path: url(#clippath-141);\n      }\n\n      .cls-178 {\n        clip-path: url(#clippath-101);\n      }\n\n      .cls-179 {\n        clip-path: url(#clippath-239);\n      }\n\n      .cls-180 {\n        clip-path: url(#clippath-60);\n      }\n\n      .cls-181 {\n        clip-path: url(#clippath-168);\n      }\n\n      .cls-182 {\n        clip-path: url(#clippath-44);\n      }\n\n      .cls-183 {\n        clip-path: url(#clippath-154);\n      }\n\n      .cls-184 {\n        clip-path: url(#clippath-122);\n      }\n\n      .cls-185 {\n        clip-path: url(#clippath-192);\n      }\n\n      .cls-186 {\n        clip-path: url(#clippath-139);\n      }\n\n      .cls-187 {\n        clip-path: url(#clippath-232);\n      }\n\n      .cls-188 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-189 {\n        clip-path: url(#clippath-134);\n      }\n\n      .cls-190 {\n        clip-path: url(#clippath-113);\n      }\n\n      .cls-191 {\n        clip-path: url(#clippath-178);\n      }\n\n      .cls-192 {\n        clip-path: url(#clippath-95);\n      }\n\n      .cls-193 {\n        clip-path: url(#clippath-221);\n      }\n\n      .cls-31 {\n        fill: #1499fc;\n      }\n\n      .cls-194 {\n        clip-path: url(#clippath-80);\n      }\n\n      .cls-195 {\n        clip-path: url(#clippath-242);\n      }\n\n      .cls-196 {\n        clip-path: url(#clippath-229);\n      }\n\n      .cls-197 {\n        clip-path: url(#clippath-241);\n      }\n\n      .cls-32 {\n        fill: #bfbfe4;\n      }\n\n      .cls-198 {\n        clip-path: url(#clippath-203);\n      }\n\n      .cls-199 {\n        clip-path: url(#clippath-120);\n      }\n\n      .cls-33 {\n        fill: #4281ee;\n      }\n\n      .cls-200 {\n        clip-path: url(#clippath-231);\n      }\n\n      .cls-201 {\n        clip-path: url(#clippath-147);\n      }\n\n      .cls-202 {\n        clip-path: url(#clippath-24);\n      }\n\n      .cls-203 {\n        clip-path: url(#clippath-211);\n      }\n\n      .cls-204 {\n        clip-path: url(#clippath-237);\n      }\n\n      .cls-205 {\n        clip-path: url(#clippath-222);\n      }\n\n      .cls-206 {\n        clip-path: url(#clippath-99);\n      }\n\n      .cls-207 {\n        clip-path: url(#clippath-166);\n      }\n\n      .cls-34 {\n        fill: #f0f0fa;\n      }\n\n      .cls-35 {\n        fill: #e43727;\n      }\n\n      .cls-208 {\n        clip-path: url(#clippath-30);\n      }\n\n      .cls-209 {\n        clip-path: url(#clippath-193);\n      }\n\n      .cls-210 {\n        clip-path: url(#clippath-179);\n      }\n\n      .cls-36, .cls-211 {\n        fill: #35353f;\n      }\n\n      .cls-212 {\n        clip-path: url(#clippath-79);\n      }\n\n      .cls-213 {\n        clip-path: url(#clippath-22);\n      }\n\n      .cls-214 {\n        clip-path: url(#clippath-96);\n      }\n\n      .cls-215 {\n        clip-path: url(#clippath-195);\n      }\n\n      .cls-216 {\n        clip-path: url(#clippath-150);\n      }\n\n      .cls-217 {\n        clip-path: url(#clippath-201);\n      }\n\n      .cls-218 {\n        clip-path: url(#clippath-215);\n      }\n\n      .cls-219 {\n        clip-path: url(#clippath-183);\n      }\n\n      .cls-220 {\n        clip-path: url(#clippath-103);\n      }\n\n      .cls-221 {\n        clip-path: url(#clippath-126);\n      }\n\n      .cls-222 {\n        clip-path: url(#clippath-137);\n      }\n\n      .cls-223 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-224 {\n        clip-path: url(#clippath-82);\n      }\n\n      .cls-225 {\n        clip-path: url(#clippath-52);\n      }\n\n      .cls-226 {\n        clip-path: url(#clippath-144);\n      }\n\n      .cls-227 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-228 {\n        clip-path: url(#clippath-204);\n      }\n\n      .cls-229 {\n        clip-path: url(#clippath-187);\n      }\n\n      .cls-230, .cls-49 {\n        fill: #0c2f90;\n      }\n\n      .cls-231 {\n        clip-path: url(#clippath-50);\n      }\n\n      .cls-232 {\n        clip-path: url(#clippath-152);\n      }\n\n      .cls-233 {\n        clip-path: url(#clippath-156);\n      }\n\n      .cls-234 {\n        clip-path: url(#clippath-48);\n      }\n\n      .cls-235 {\n        clip-path: url(#clippath-61);\n      }\n\n      .cls-236 {\n        clip-path: url(#clippath-180);\n      }\n\n      .cls-237 {\n        clip-path: url(#clippath-159);\n      }\n\n      .cls-238 {\n        clip-path: url(#clippath-198);\n      }\n\n      .cls-239 {\n        clip-path: url(#clippath-39);\n      }\n\n      .cls-240 {\n        clip-path: url(#clippath-19);\n      }\n\n      .cls-241 {\n        clip-path: url(#clippath-31);\n      }\n\n      .cls-242 {\n        clip-path: url(#clippath-218);\n      }\n\n      .cls-243 {\n        clip-path: url(#clippath-86);\n      }\n\n      .cls-244 {\n        clip-path: url(#clippath-54);\n      }\n\n      .cls-37 {\n        fill: #3b2e7b;\n      }\n\n      .cls-245 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-246 {\n        clip-path: url(#clippath-131);\n      }\n\n      .cls-247 {\n        clip-path: url(#clippath-91);\n      }\n\n      .cls-248 {\n        clip-path: url(#clippath-129);\n      }\n\n      .cls-249 {\n        clip-path: url(#clippath-202);\n      }\n\n      .cls-250 {\n        clip-path: url(#clippath-165);\n      }\n\n      .cls-251 {\n        clip-path: url(#clippath-213);\n      }\n\n      .cls-252 {\n        clip-path: url(#clippath-175);\n      }\n\n      .cls-253 {\n        clip-path: url(#clippath-155);\n      }\n\n      .cls-254 {\n        clip-path: url(#clippath-43);\n      }\n\n      .cls-255 {\n        clip-path: url(#clippath-171);\n      }\n\n      .cls-256 {\n        clip-path: url(#clippath-70);\n      }\n\n      .cls-257 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-38 {\n        fill: #05dcff;\n      }\n\n      .cls-258 {\n        clip-path: url(#clippath-177);\n      }\n\n      .cls-259 {\n        clip-path: url(#clippath-212);\n      }\n\n      .cls-39 {\n        fill: #98a4e0;\n      }\n\n      .cls-260 {\n        clip-path: url(#clippath-209);\n      }\n\n      .cls-261 {\n        clip-path: url(#clippath-133);\n      }\n\n      .cls-262 {\n        clip-path: url(#clippath-55);\n      }\n\n      .cls-263 {\n        clip-path: url(#clippath-235);\n      }\n\n      .cls-264 {\n        clip-path: url(#clippath-69);\n      }\n\n      .cls-42 {\n        fill: #fff;\n      }\n\n      .cls-265 {\n        clip-path: url(#clippath-140);\n      }\n\n      .cls-266 {\n        clip-path: url(#clippath-29);\n      }\n\n      .cls-43 {\n        fill: #13b7fd;\n      }\n\n      .cls-267 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-268 {\n        clip-path: url(#clippath-90);\n      }\n\n      .cls-269 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-270 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-271 {\n        clip-path: url(#clippath-240);\n      }\n\n      .cls-272 {\n        clip-path: url(#clippath-97);\n      }\n\n      .cls-273 {\n        clip-path: url(#clippath-216);\n      }\n\n      .cls-274 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-275 {\n        clip-path: url(#clippath-174);\n      }\n\n      .cls-276 {\n        clip-path: url(#clippath-58);\n      }\n\n      .cls-277 {\n        clip-path: url(#clippath-84);\n      }\n\n      .cls-278 {\n        clip-path: url(#clippath-148);\n      }\n\n      .cls-44 {\n        fill: #f7f7fc;\n      }\n\n      .cls-279 {\n        clip-path: url(#clippath-42);\n      }\n\n      .cls-280 {\n        clip-path: url(#clippath-244);\n      }\n\n      .cls-45 {\n        fill: #484a8a;\n      }\n\n      .cls-281 {\n        clip-path: url(#clippath-65);\n      }\n\n      .cls-46 {\n        fill: #aa3a37;\n      }\n\n      .cls-282 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-283 {\n        clip-path: url(#clippath-118);\n      }\n\n      .cls-284 {\n        clip-path: url(#clippath-23);\n      }\n\n      .cls-285 {\n        clip-path: url(#clippath-191);\n      }\n\n      .cls-48 {\n        fill: #19121b;\n      }\n\n      .cls-286 {\n        clip-path: url(#clippath-100);\n      }\n\n      .cls-287 {\n        clip-path: url(#clippath-92);\n      }\n\n      .cls-288 {\n        clip-path: url(#clippath-74);\n      }\n\n      .cls-289 {\n        clip-path: url(#clippath-56);\n      }\n\n      .cls-290 {\n        clip-path: url(#clippath-53);\n      }\n\n      .cls-291 {\n        clip-path: url(#clippath-49);\n      }\n\n      .cls-292 {\n        clip-path: url(#clippath-205);\n      }\n\n      .cls-293 {\n        clip-path: url(#clippath-224);\n      }\n\n      .cls-294 {\n        clip-path: url(#clippath-110);\n      }\n\n      .cls-295 {\n        clip-path: url(#clippath-146);\n      }\n\n      .cls-296 {\n        clip-path: url(#clippath-67);\n      }\n\n      .cls-297 {\n        clip-path: url(#clippath-51);\n      }\n\n      .cls-298 {\n        clip-path: url(#clippath-145);\n      }\n\n      .cls-50 {\n        fill: #dad7ee;\n      }\n\n      .cls-51 {\n        fill: #0cf;\n      }\n\n      .cls-299 {\n        clip-path: url(#clippath-28);\n      }\n\n      .cls-300 {\n        clip-path: url(#clippath-71);\n      }\n\n      .cls-301 {\n        clip-path: url(#clippath-184);\n      }\n\n      .cls-302 {\n        clip-path: url(#clippath-85);\n      }\n\n      .cls-303 {\n        clip-path: url(#clippath-106);\n      }\n\n      .cls-304 {\n        clip-path: url(#clippath-68);\n      }\n\n      .cls-305 {\n        clip-path: url(#clippath-238);\n      }\n\n      .cls-306 {\n        clip-path: url(#clippath-143);\n      }\n\n      .cls-307 {\n        clip-path: url(#clippath-35);\n      }\n\n      .cls-308 {\n        clip-path: url(#clippath-227);\n      }\n\n      .cls-52 {\n        fill: #185bcc;\n      }\n\n      .cls-309 {\n        clip-path: url(#clippath-66);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M445.09,165.59l-1.31.13c2.15-1.25,5.64-1.25,7.81,0l-1.29-.13c-1.44-.83-3.77-.83-5.2,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M404.56,193.67v-3.86c0,.82.55,1.65,1.64,2.28v3.86c-1.1-.63-1.64-1.45-1.64-2.28Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M407.5,190.46l-1.3,1.64c-2.16-1.25-2.17-3.27-.03-4.52l1.31-.13c-1.43.83-1.42,2.18.02,3.01Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M536.05,215.1l1.29.13c2.16,1.25,2.18,3.27.03,4.52l-1.3-1.64c1.43-.83,1.42-2.18-.02-3.01Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M538.97,217.51v3.86c-.01.81-.55,1.62-1.61,2.24v-3.86c1.08-.62,1.61-1.43,1.61-2.24Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M498.46,239.97l1.3,1.64c-2.15,1.25-5.64,1.25-7.81,0l1.3-1.64c1.44.83,3.78.83,5.21,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M499.76,241.61v3.86c-2.16,1.25-5.66,1.25-7.82,0v-3.86c2.17,1.25,5.67,1.25,7.82,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M517.6,218.88v1.62c0,.36-.24.72-.72,1v-1.62c.48-.28.72-.64.72-1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M492.08,223.09v-1.62c0,.36.24.73.73,1.01v1.62c-.49-.28-.73-.64-.73-1.01Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M504.36,227.15v1.62c-.96.55-2.5.55-3.46,0v-1.62c.96.55,2.51.55,3.46,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M513.97,312.71l3.49-2.03c2.18-1.27,5.2-1.09,8.53.84l-3.5,2.03c-3.33-1.92-6.35-2.1-8.53-.84Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M534.45,339.9l-3.49,2.03c2.15-1.25,3.49-3.91,3.5-7.69.02-7.61-5.33-16.87-11.95-20.69l3.5-2.03c6.62,3.82,11.97,13.09,11.95,20.69-.01,3.78-1.35,6.44-3.5,7.69Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M511.54,315.6l2.44-1.42c2.02-1.18,4.83-1.01,7.92.78l-2.44,1.42c-3.09-1.79-5.9-1.95-7.92-.78Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M529.74,341.32l-2.44,1.42c2-1.16,3.24-3.63,3.25-7.14.02-7.06-4.95-15.67-11.1-19.22l2.44-1.42c6.15,3.55,11.12,12.16,11.1,19.22,0,3.51-1.25,5.98-3.25,7.14Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M450.54,335.22l.03-9.94c.01-4.54,2.99-9.08,8.94-12.53l-.03,9.94c-5.95,3.46-8.93,7.99-8.94,12.53Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M471.47,338.51l2.44-1.42c2.02-1.18,4.83-1.01,7.92.78l-2.44,1.42c-3.09-1.79-5.9-1.95-7.92-.78Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M489.68,364.23l-2.44,1.42c2-1.16,3.24-3.63,3.25-7.14.02-7.06-4.95-15.67-11.1-19.22l2.44-1.42c6.15,3.55,11.12,12.16,11.1,19.22,0,3.51-1.25,5.98-3.25,7.14Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M466.96,339.48l3.49-2.03c2.18-1.27,5.2-1.09,8.53.84l-3.5,2.03c-3.33-1.92-6.35-2.1-8.53-.84Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M487.44,366.67l-3.49,2.03c2.15-1.25,3.49-3.91,3.5-7.69.02-7.61-5.33-16.87-11.95-20.7l3.5-2.03c6.62,3.82,11.97,13.09,11.95,20.7-.01,3.78-1.35,6.44-3.5,7.69Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M330.32,74.59l4.61.74c-.54-.09-1.13.02-1.69.34l-4.61-.74c.56-.33,1.15-.43,1.69-.34Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M166.74,176.47l-4.61-.74c-.57-2.11.31-4.6,1.97-5.55l4.61.74c-1.65.95-2.53,3.44-1.97,5.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M486.36,288.75v-5.07c-.01.81-.55,1.62-1.61,2.24v5.07c1.08-.62,1.62-1.43,1.61-2.24Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M314.11,380v5.07c2.13,1.23,5.56,1.23,7.68,0v-5.07c-2.14,1.23-5.57,1.22-7.68,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M372.46,235.79v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M360.01,237.25v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M363.03,239.39v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M368.74,242.35v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M385.23,243.23v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M375.8,246.84v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M359.47,243.29v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M347.02,244.75v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M350.04,246.9v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M357.89,248.61v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M374.38,249.49v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M364.95,253.11v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M346.47,250.79v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M334.02,252.25v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M337.04,254.4v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M347.44,254.65v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M363.92,255.53v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M354.49,259.14v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M336.58,260.91v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M353.07,261.8v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M343.64,265.41v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M333.48,258.29v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M321.03,259.76v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M324.05,261.9v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.69.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M325.73,267.18v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M342.22,268.06v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M332.79,271.67v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M320.48,265.8v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M308.03,267.26v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M311.05,269.41v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M314.88,273.44v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M331.37,274.33v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M321.94,277.94v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M307.49,273.3v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M295.03,274.77v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.42-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M298.05,276.91v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M304.03,279.71v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M320.52,280.59v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M311.09,284.2v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M294.49,280.8v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M282.04,282.27v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M285.06,284.41v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M293.18,285.97v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-66"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M309.67,286.86v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M300.24,290.47v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M281.5,288.3v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-69"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M269.04,289.77v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M272.06,291.92v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M282.33,292.24v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-72"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M298.82,293.12v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-73"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M289.38,296.73v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M271.48,298.5v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M287.96,299.39v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-76"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M278.53,303v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M268.5,295.81v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M256.05,297.27v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M259.07,299.42v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-80"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M260.62,304.77v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-81"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M277.11,305.65v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-82"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M267.68,309.26v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-83"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M255.51,303.31v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-84"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M243.05,304.78v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-85"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M246.07,306.92v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-86"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M249.77,311.03v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-87"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M266.26,311.92v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-88"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M256.83,315.53v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M242.51,310.81v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-90"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M230.06,312.28v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-91"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M233.08,314.42v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-92"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M238.92,317.3v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-93"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M255.41,318.18v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-94"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M245.98,321.79v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-95"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M395.84,249.4v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-96"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M363.08,257.91v.89c0,.24.16.49.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-97"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M370.13,262.4v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.68.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-98"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M352.62,263.95v.89c0,.24.16.49.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-99"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M369.12,264.83v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-100"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M359.68,268.44v.89c.65.37,1.68.37,2.33,0v-.89c-.65.37-1.68.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M406.46,255.56v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-102"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M379.11,260.95v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-103"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M386.17,265.44v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-104"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M368.66,266.98v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-105"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M385.15,267.87v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-106"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M375.72,271.48v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-107"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M341.77,270.21v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-108"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M358.26,271.1v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-109"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M348.82,274.71v.89c.65.37,1.69.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-110"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M357.81,273.25v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-111"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M374.3,274.13v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-112"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M364.87,277.74v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-113"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M330.92,276.48v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-114"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M347.41,277.36v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-115"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M337.97,280.97v.89c.65.37,1.69.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-116"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M346.96,279.51v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-117"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M363.45,280.4v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-118"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M354.01,284.01v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-119"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M320.07,282.74v.89c0,.24.16.49.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-120"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M336.56,283.63v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-121"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M327.12,287.24v.89c.64.37,1.69.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M336.11,285.78v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-123"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M352.6,286.66v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-124"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M343.16,290.27v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-125"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M309.22,289.01v.89c0,.24.16.49.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-126"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M325.71,289.89v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-127"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M316.27,293.5v.89c.65.37,1.69.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-128"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M325.25,292.04v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-129"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M341.74,292.93v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-130"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M332.31,296.54v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-131"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M298.36,295.27v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-132"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M314.86,296.16v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-133"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M305.42,299.77v.89c.65.37,1.69.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-134"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M314.4,298.31v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-135"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M330.89,299.19v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-136"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M321.46,302.8v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-137"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M287.51,301.54v.89c0,.24.16.49.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-138"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M304,302.42v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M294.57,306.03v.89c.65.37,1.69.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M303.55,304.57v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-141"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M320.04,305.46v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-142"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M310.61,309.07v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M276.66,307.8v.89c0,.24.16.49.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-144"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M293.15,308.69v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M283.72,312.3v.89c.65.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-146"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M265.81,314.07v.89c0,.24.16.49.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-147"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M282.3,314.96v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-148"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M272.86,318.56v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M271.45,321.22v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-150"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M249.53,323.47v.89c0,.24.16.49.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-151"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M256.59,327.96v.89c.65.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-152"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M292.7,310.84v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-153"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M309.19,311.72v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-154"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M299.76,315.33v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-155"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M281.85,317.1v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-156"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M298.34,317.99v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-157"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M288.91,321.6v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-158"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M287.49,324.25v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-159"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M260.15,329.63v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-160"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M267.2,334.13v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-161"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M417.07,261.73v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-162"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M384.7,270.02v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-163"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M391.76,274.51v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-164"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M373.85,276.28v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-165"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M390.34,277.17v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-166"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M380.9,280.77v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-167"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M411.19,267.02v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-168"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M427.68,267.9v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-169"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M418.24,271.51v.89c.64.37,1.69.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-170"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M400.34,273.28v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-171"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M416.83,274.17v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-172"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M407.39,277.77v.89c.64.37,1.69.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-173"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M389.88,279.32v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-174"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M406.37,280.2v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-175"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M396.94,283.81v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-176"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M362.99,282.55v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-177"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M379.48,283.43v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-178"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M370.05,287.04v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-179"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M352.14,288.81v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-180"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M368.63,289.69v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-181"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M359.2,293.3v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-182"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M341.29,295.08v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.42-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-183"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M357.78,295.96v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-184"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M348.35,299.57v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-185"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M330.44,301.35v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-186"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M346.93,302.22v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-187"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M337.49,305.84v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-188"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M319.59,307.61v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-189"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M336.08,308.49v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M326.64,312.1v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-191"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M308.74,313.87v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.42-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-192"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M325.23,314.75v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-193"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M315.79,318.37v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-194"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M297.88,320.14v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-195"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M314.37,321.02v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-196"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M304.94,324.63v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-197"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M287.03,326.41v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-198"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M303.52,327.29v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-199"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M294.09,330.9v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-200"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M379.03,285.58v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-201"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M395.52,286.47v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-202"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M386.09,290.07v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-203"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M384.67,292.73v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-204"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M357.33,298.11v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-205"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M364.38,302.6v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-206"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M362.97,305.26v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-207"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M313.92,323.17v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-208"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M320.98,327.66v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-209"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M303.07,329.44v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-210"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M319.56,330.32v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-211"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M310.13,333.93v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-212"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M292.67,333.55v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-213"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M270.76,335.8v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-214"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M277.81,340.29v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-215"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M308.71,336.59v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-216"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M281.37,341.97v.89c0,.24.16.49.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-217"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M288.42,346.46v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-218"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M71.96,208.28l57.95-33.68c-.32.19-.77.16-1.26-.12l-57.95,33.68c.49.28.94.31,1.26.12Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-219"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M72.58,209.35l57.95-33.68c.48-.28.77-.86.77-1.7l-57.95,33.68c0,.83-.3,1.42-.77,1.7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-220"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M73.36,203.93l57.95-33.68c0-1.68-1.18-3.73-2.64-4.57l-57.95,33.68c1.46.84,2.64,2.89,2.64,4.57Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-221"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M24.78,169.98l57.95-33.68c-.98-.56-1.77-1.94-1.77-3.06l-57.95,33.68c0,1.12.79,2.5,1.77,3.06Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-222"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M80.42,129.3l-55.05,31.99c.36-.21.86-.18,1.41.14l55.05-31.99c-.55-.32-1.05-.35-1.41-.14Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-224"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M80.88,127.3l-57.95,33.68c.48-.28,1.15-.24,1.88.18l57.95-33.68c-.73-.42-1.4-.46-1.88-.18Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-225"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M77.1,187.99l57.95-33.68c-.32.19-.77.16-1.26-.12l-57.95,33.68c.49.28.94.31,1.26.12Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-226"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M77.72,189.05l57.95-33.68c.48-.28.77-.86.77-1.7l-57.95,33.68c0,.83-.3,1.42-.77,1.7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-227"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M78.5,180.46l57.95-33.68c0-1.68-1.18-3.73-2.64-4.57l-57.95,33.68c1.46.84,2.64,2.89,2.64,4.57Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-228"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M24.49,148.41l57.95-33.68c-.98-.56-1.77-1.94-1.77-3.06l-57.95,33.68c0,1.12.79,2.5,1.77,3.06Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-229"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M80.12,107.73l-55.05,31.99c.36-.21.86-.18,1.41.14l55.05-31.99c-.55-.32-1.05-.35-1.41-.14Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-231"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M80.58,105.73l-57.95,33.68c.48-.28,1.15-.24,1.88.18l57.95-33.68c-.73-.42-1.4-.46-1.88-.18Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-232"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M82.14,211.86l.14-53.52c0,.11.01.23.04.34.03.12.07.24.13.35l-.14,53.52c-.06-.12-.11-.24-.13-.35-.03-.12-.04-.23-.04-.34Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-233"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M309.23,155.21l6.55-3.81c.83-.48,1.35-1.51,1.35-2.96l-6.55,3.81c0,1.45-.52,2.47-1.35,2.96Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-234"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M297.55,119.89l-6.55,3.81c.84-.49,2-.42,3.28.32l6.55-3.81c-1.28-.74-2.44-.8-3.28-.32Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-235"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M310.62,138.76l6.55-3.81c0-2.91-2.06-6.5-4.6-7.97l-6.55,3.81c2.54,1.46,4.61,5.05,4.6,7.97Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-236"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M230.91,190.85l6.55-3.81c.83-.48,1.35-1.51,1.35-2.96l-6.55,3.81c0,1.45-.52,2.47-1.35,2.96Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-237"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M219.23,155.53l-6.55,3.81c.84-.49,2-.42,3.28.32l6.55-3.81c-1.28-.74-2.44-.8-3.28-.32Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-238"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M232.3,174.4l6.55-3.81c0-2.92-2.06-6.5-4.6-7.97l-6.55,3.81c2.54,1.46,4.61,5.05,4.6,7.97Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-239"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M371.45,19.74l-3.71-2.16c-1.17-.68-2.79-.59-4.57.44l3.71,2.16c1.78-1.03,3.4-1.12,4.57-.44Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-240"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M316.06,82.34l3.71,2.16c-1.15-.67-1.87-2.09-1.88-4.11l-3.71-2.16c0,2.02.72,3.44,1.88,4.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-241"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M324.23,44.81l-3.71-2.16c-3.53,2.04-6.42,7.03-6.4,11.09l3.71,2.16c-.01-4.06,2.87-9.05,6.4-11.09Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-242"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M16.86,432.01l-.07,6.95c0,.65.43,1.3,1.28,1.79l.07-6.95c-.85-.5-1.28-1.15-1.28-1.8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-243"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M117.69,438.94l.07-6.95c0,.66-.43,1.32-1.3,1.82l-.07,6.95c.87-.5,1.3-1.16,1.3-1.82Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-244"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M64.02,460.47l-.07,6.95c1.72,1,4.51,1,6.24,0l.07-6.95c-1.73,1-4.52,1-6.24,0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "435.11 269.58 394.77 245.9 465.02 205.43 464.66 204.8 393.32 245.9 393.86 246.21 435.11 270.42 435.11 269.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "435.11 280.06 400.65 259.78 482.3 211.3 481.93 210.67 399.22 259.78 399.75 260.09 435.11 280.91 435.11 280.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "435.11 291.6 382.39 260.77 475.8 207.59 475.44 206.96 380.94 260.76 381.48 261.08 435.11 292.44 435.11 291.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M440.48,233.78v.67c0,.58.82,1.05,1.83,1.05h1.15c.77,0,1.46-.28,1.72-.7l1.96-3.15-5.45,1.13c-.72.15-1.21.55-1.21.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M413.65,232.72v.67c0,.58.82,1.05,1.82,1.05h1.15c.77,0,1.46-.28,1.72-.7l1.96-3.15-5.45,1.13c-.72.15-1.21.55-1.21.99Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "270.88 462.87 270.64 462.74 96.53 361.98 97 361.17 270.88 461.79 447.04 358.38 356.19 306.04 356.66 305.23 448.91 358.38 448.22 358.79 270.88 462.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M265.07,480.06l-.24-.14c-1.84-1.07-183.88-107.06-186.99-108.21l.14-.37-.08-.55h0c1.14,0,102.32,58.77,187.17,108.17l174.37-102.65-105.6-62.7.48-.81,106.96,63.51-.68.4-175.53,103.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "286.88 481.74 286.64 481.6 94.62 368.4 95.1 367.59 286.88 480.65 463.05 377.61 342.25 308.84 342.72 308.02 464.93 377.6 464.23 378.01 286.88 481.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "317.56 435.2 316.62 435.2 316.62 416.72 371.66 384.94 372.13 385.76 317.56 417.26 317.56 435.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 325.15,
    y: 458.44,
    width: 22.53,
    height: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M352.8,462.07c-1.27,0-2.53-.28-3.52-.85-1.03-.59-1.59-1.41-1.59-2.3s.57-1.71,1.59-2.3h0c1.97-1.14,5.06-1.14,7.04,0,1.03.59,1.6,1.41,1.6,2.3s-.57,1.71-1.6,2.3c-.99.57-2.25.85-3.52.85ZM352.8,456.7c-1.1,0-2.21.24-3.05.73h0c-.72.42-1.13.95-1.13,1.49s.4,1.07,1.13,1.49c1.68.97,4.41.97,6.1,0,.72-.42,1.12-.95,1.12-1.49s-.4-1.07-1.12-1.49c-.84-.49-1.94-.73-3.05-.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 279.02,
    y: 433.3,
    width: 0.94,
    height: 23.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M279.81,433.55c-1.27,0-2.53-.28-3.52-.85-1.03-.59-1.6-1.41-1.6-2.3s.57-1.71,1.6-2.3h0c1.97-1.14,5.06-1.14,7.04,0,1.03.59,1.59,1.41,1.59,2.3s-.57,1.71-1.6,2.3c-.98.57-2.25.85-3.52.85ZM279.81,428.17c-1.1,0-2.21.24-3.05.73h0c-.73.42-1.12.95-1.12,1.49s.4,1.07,1.12,1.49c1.68.97,4.42.97,6.09,0,.73-.42,1.13-.95,1.13-1.49s-.4-1.07-1.12-1.49c-.84-.49-1.94-.73-3.05-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M368.88,382.19c-2.35,1.35-2.35,3.55,0,4.91,2.35,1.35,6.15,1.35,8.5,0,2.35-1.35,2.35-3.55,0-4.91-2.35-1.35-6.15-1.35-8.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M411.41,356.84v.86c0,.75-1.06,1.36-2.36,1.36h-1.49c-1,0-1.88-.36-2.22-.9l-2.53-4.07,7.05,1.46c.94.19,1.56.71,1.56,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M447.33,355.74v.86c0,.75-1.06,1.36-2.36,1.36h-1.49c-1,0-1.88-.36-2.22-.9l-2.53-4.07,7.05,1.46c.94.19,1.56.71,1.56,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M230.17,441.42v-.97c0-.85,1.19-1.54,2.67-1.54h1.69c1.13,0,2.13.41,2.51,1.02l2.86,4.6-7.97-1.65c-1.06-.22-1.77-.8-1.77-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M249.44,472.92v-.97c0-.85,1.19-1.54,2.67-1.54h1.69c1.13,0,2.13.41,2.51,1.02l2.86,4.6-7.97-1.65c-1.06-.22-1.77-.8-1.77-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M302.41,446.19h-1.66c-1.45,0-2.63-.68-2.63-1.52v-.96c0-.64.7-1.21,1.74-1.43l7.86-1.63-2.82,4.54c-.38.6-1.37,1.01-2.48,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M398.02,403.98h-1.66c-1.45,0-2.63-.68-2.63-1.52v-.96c0-.64.7-1.21,1.74-1.43l7.86-1.63-2.82,4.54c-.38.6-1.37,1.01-2.48,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M361.74,439.7h-1.66c-1.45,0-2.63-.68-2.63-1.52v-.96c0-.64.7-1.21,1.74-1.43l7.86-1.63-2.82,4.54c-.38.6-1.37,1.01-2.48,1.01Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M445.09,165.59l-1.31.13c2.15-1.25,5.64-1.25,7.81,0l-1.29-.13c-1.44-.83-3.77-.83-5.2,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-227"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M445.09,165.59l-1.31.13c1.62-.94,4.01-1.17,6.01-.69l-.7.1c-1.34-.32-2.93-.17-4.01.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M449.1,165.12l.7-.1c.65.16,1.26.39,1.79.69l-1.29-.13c-.35-.2-.76-.36-1.2-.46h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "445.09 165.59 435.35 171.24 418.8 180.86 407.48 187.44 406.17 187.57 418.1 180.64 434.96 170.84 443.78 165.72 445.09 165.59"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M404.56,193.67v-3.86c0,.82.55,1.65,1.64,2.28v3.86c-1.1-.63-1.64-1.45-1.64-2.28Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-164"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M406.2,192.09v3.86c-1.1-.63-1.64-1.45-1.64-2.28v-3.86c0,.82.55,1.65,1.64,2.28h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M407.5,190.46l-1.3,1.64c-2.16-1.25-2.17-3.27-.03-4.52l1.31-.13c-1.43.83-1.42,2.18.02,3.01Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-119"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M407.5,190.46l-1.3,1.64c-.89-.52-1.42-1.17-1.58-1.84l1.83-1.03c.11.45.46.88,1.05,1.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M406.45,189.23l-1.83,1.03c-.22-.95.29-1.95,1.55-2.68l1.31-.13c-.84.49-1.18,1.15-1.04,1.79h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "450.29 165.59 451.59 165.72 537.34 215.23 536.05 215.1 450.29 165.59"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M536.05,215.1l1.29.13c2.16,1.25,2.18,3.27.03,4.52l-1.3-1.64c1.43-.83,1.42-2.18-.02-3.01Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-245"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M536.05,215.1l1.29.13c.36.21.66.44.9.68l-1.6-.36c-.16-.16-.36-.32-.6-.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M536.65,215.55l1.6.36c.5.51.75,1.08.73,1.65l-1.84-.91c.01-.38-.15-.76-.48-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M537.13,216.66l1.84.91c-.03.79-.56,1.58-1.6,2.18l-1.3-1.64c.69-.4,1.05-.93,1.07-1.46h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M538.97,217.51v3.86c-.01.81-.55,1.62-1.61,2.24v-3.86c1.08-.62,1.61-1.43,1.61-2.24Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-165"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M538.97,217.51v3.86c-.01.25-.06.51-.17.75v-3.86c.12-.25.17-.5.17-.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M538.82,218.26v3.86c-.24.55-.72,1.06-1.46,1.49v-3.86c.75-.43,1.23-.94,1.46-1.49h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "536.07 218.11 537.37 219.75 499.76 241.61 498.46 239.97 536.07 218.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "537.37 219.75 537.36 223.61 499.75 245.46 499.76 241.61 537.37 219.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "493.25 239.97 491.95 241.61 406.2 192.09 407.5 190.46 493.25 239.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "491.95 241.61 491.94 245.46 406.19 195.95 406.2 192.09 491.95 241.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M536.05,215.1c1.44.83,1.45,2.18.02,3.01l-37.61,21.86c-1.43.83-3.77.83-5.21,0l-85.75-49.51c-1.44-.83-1.45-2.18-.02-3.01l37.61-21.86c1.43-.83,3.76-.83,5.2,0l85.75,49.51Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M498.46,239.97l1.3,1.64c-2.15,1.25-5.64,1.25-7.81,0l1.3-1.64c1.44.83,3.78.83,5.21,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-274"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M498.46,239.97l1.3,1.64c-1.41.82-3.39,1.1-5.2.85l.43-1.92c1.21.17,2.53-.02,3.47-.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M494.99,240.53l-.43,1.92c-.94-.13-1.83-.41-2.57-.83l1.29-1.64c.49.28,1.09.46,1.71.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M493.28,239.98l-1.29,1.64s-.02-.01-.04-.02l1.3-1.64s.02,0,.02.01h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M499.76,241.61v3.86c-2.16,1.25-5.66,1.25-7.82,0v-3.86c2.17,1.25,5.67,1.25,7.82,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M499.76,241.61v3.86c-1.11.64-2.56.95-4.01.94v-3.86c1.46.02,2.91-.3,4.01-.94h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M495.76,242.54v3.86c-1.39-.01-2.76-.33-3.82-.94v-3.86c1.07.61,2.44.92,3.82.94h0Z"
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M533.94,213.74l-15.25-8.8-25.15-14.52-10.67-6.15-10.97-6.33-14.47-8.35-6.92-3.99c-1.44-.83-5.14,1.02-5.14,1.02l-35.14,21.47s-3.62,1.73-2.51,2.37l53.97,31.15.33.19,29.12,16.81c.69.4,1.59.61,2.49.62.98.02,1.97-.19,2.71-.62l3.26-1.89.61-.35.11-.07,2.28-1.33.21-.12,1.78-1.03.13-.07,5.92-3.44.25-.14,13.47-7.82,9.59-5.57c1.43-.83,1.42-2.18-.02-3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M450.53,165.59c-1.44-.83-3.77-.83-5.2,0l-.67.39-6.47,3.76-30.46,17.71c-1.43.83-1.43,2.18.02,3.02l1.5.87,42.94-24.79-1.64-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M432.02,176.78l-3.74,2.16c-.47.27-1.23.27-1.69,0h0c-.47-.27-.47-.71,0-.98l3.74-2.16c.47-.27,1.23-.27,1.69,0h0c.47.27.47.71,0,.98Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M441.8,196.48c-3.04,1.75-3.05,4.58-.04,6.3l18.76,10.74c3.01,1.73,7.91,1.71,10.95-.04l20.07-11.59c3.04-1.75,3.05-4.58.04-6.3l-18.76-10.74c-3.01-1.73-7.91-1.71-10.95.04l-20.07,11.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M454.09,198.69l15.6,9.01c-.7.15-1.39.39-1.98.73-1.76,1.02-2.06,2.49-.66,3.3,1.39.81,3.95.63,5.71-.38,1.75-1.01,2.05-2.48.68-3.28h0l-15.09-8.71,5.82-7.9,14.16,8.18c-.7.15-1.39.39-1.98.73-1.76,1.02-2.06,2.49-.66,3.3,1.39.81,3.95.63,5.71-.38,1.75-1.01,2.05-2.48.68-3.28h0s-20.36-11.76-20.36-11.76l-7.64,10.45Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M517.6,218.88v1.62c0,.36-.24.72-.72,1v-1.62c.48-.28.72-.64.72-1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-154"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M517.6,218.88v1.62c0,.36-.24.72-.72,1v-1.62c.48-.28.72-.64.72-1h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M492.08,223.09v-1.62c0,.36.24.73.73,1.01v1.62c-.49-.28-.73-.64-.73-1.01Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-257"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M492.81,222.48v1.62c-.49-.28-.73-.64-.73-1.01v-1.62c0,.36.24.73.73,1.01h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "516.89 219.88 516.88 221.49 504.36 228.77 504.36 227.15 516.89 219.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "500.9 227.15 500.9 228.77 492.8 224.1 492.81 222.48 500.9 227.15"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M504.36,227.15v1.62c-.96.55-2.5.55-3.46,0v-1.62c.96.55,2.51.55,3.46,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-223"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M504.36,227.15v1.62c-.96.55-2.5.55-3.46,0v-1.62c.96.55,2.51.55,3.46,0h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M516.87,217.87c.96.55.96,1.45.01,2.01l-12.52,7.28c-.95.55-2.5.55-3.46,0l-8.1-4.67c-.96-.55-.96-1.45-.01-2l12.52-7.28c.95-.55,2.5-.55,3.46,0l8.1,4.67Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M508.21,217.48l-8.62,1.33c-.71.11-.89,1.06-.27,1.42l6.31,3.64c.39.23.89.07,1.08-.34l2.31-4.98c.26-.56-.21-1.17-.81-1.08Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M504.9,311.69c-5.47-3.16-12.48-4.88-19.63-5.18-8.61-.35-17.41,1.37-23.96,5.17l-.03,9.94c6.54-3.8,15.35-5.53,23.96-5.17,7.15.29,14.16,2.02,19.63,5.18l7.57,4.37.03-9.94-7.57-4.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "513.35 315.56 513.32 325.5 512.45 326.01 512.48 316.07 513.35 315.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M460.44,311.19c12.46-7.24,32.79-7.24,45.33,0l7.57,4.37-.87.51-7.57-4.37c-12.06-6.96-31.61-6.96-43.58,0l-.88-.51Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M513.97,312.71l3.49-2.03c2.18-1.27,5.2-1.09,8.53.84l-3.5,2.03c-3.33-1.92-6.35-2.1-8.53-.84Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-282"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M513.97,312.71l3.49-2.03c2.18-1.27,5.2-1.09,8.53.84l-3.5,2.03c-3.33-1.92-6.35-2.1-8.53-.84h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M534.45,339.9l-3.49,2.03c2.15-1.25,3.49-3.91,3.5-7.69.02-7.61-5.33-16.87-11.95-20.69l3.5-2.03c6.62,3.82,11.97,13.09,11.95,20.69-.01,3.78-1.35,6.44-3.5,7.69Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M522.5,313.55l3.5-2.03c.95.55,1.87,1.2,2.75,1.95l-3.49,2.03c-.88-.75-1.8-1.41-2.75-1.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M525.25,315.5l3.49-2.03c2,1.69,3.8,3.85,5.27,6.24l-3.49,2.03c-1.47-2.38-3.28-4.54-5.27-6.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M530.52,321.74l3.49-2.03c1.3,2.11,2.34,4.4,3.03,6.69l-3.49,2.03c-.68-2.29-1.72-4.58-3.03-6.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M533.55,328.43l3.49-2.03c.58,1.97.91,3.94.9,5.81,0,1-.1,1.92-.28,2.76l-3.5,2.03c.18-.84.27-1.76.28-2.76,0-1.87-.31-3.85-.9-5.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M534.17,337l3.5-2.03c-.5,2.33-1.64,4.01-3.22,4.93l-3.49,2.03c1.58-.92,2.72-2.6,3.22-4.93h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M522.5,313.55c6.62,3.82,11.97,13.09,11.95,20.69-.02,7.61-5.41,10.68-12.03,6.85-6.62-3.82-11.97-13.09-11.95-20.7.02-7.61,5.41-10.67,12.03-6.85Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M511.54,315.6l2.44-1.42c2.02-1.18,4.83-1.01,7.92.78l-2.44,1.42c-3.09-1.79-5.9-1.95-7.92-.78Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-188"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M511.54,315.6l2.44-1.42c2.02-1.18,4.83-1.01,7.92.78l-2.44,1.42c-3.09-1.79-5.9-1.95-7.92-.78h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M529.74,341.32l-2.44,1.42c2-1.16,3.24-3.63,3.25-7.14.02-7.06-4.95-15.67-11.1-19.22l2.44-1.42c6.15,3.55,11.12,12.16,11.1,19.22,0,3.51-1.25,5.98-3.25,7.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M519.46,316.38l2.44-1.42c.88.51,1.73,1.12,2.55,1.81l-2.44,1.42c-.82-.69-1.67-1.31-2.55-1.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M522.01,318.19l2.44-1.42c1.86,1.57,3.53,3.58,4.9,5.79l-2.44,1.42c-1.37-2.21-3.04-4.22-4.9-5.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M526.91,323.98l2.44-1.42c1.21,1.96,2.18,4.08,2.81,6.21l-2.44,1.42c-.63-2.13-1.6-4.25-2.81-6.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M529.72,330.2l2.44-1.42c.54,1.83.84,3.66.84,5.4,0,.93-.09,1.78-.26,2.56l-2.44,1.42c.17-.78.25-1.63.26-2.56,0-1.74-.29-3.57-.84-5.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M530.3,338.16l2.44-1.42c-.46,2.16-1.52,3.72-2.99,4.58l-2.44,1.42c1.47-.85,2.53-2.42,2.99-4.58h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M519.46,316.38c6.15,3.55,11.12,12.16,11.1,19.22-.02,7.06-5.02,9.91-11.17,6.37-6.15-3.55-11.12-12.16-11.1-19.22.02-7.06,5.02-9.91,11.17-6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M519.45,318.4c5.18,2.99,9.36,10.24,9.35,16.19s-4.23,8.35-9.41,5.36c-5.18-2.99-9.36-10.24-9.35-16.19s4.23-8.35,9.41-5.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M519.44,321.89c3.5,2.02,6.33,6.92,6.32,10.94-.01,4.02-2.86,5.64-6.36,3.62-3.5-2.02-6.33-6.92-6.32-10.94.01-4.02,2.86-5.64,6.36-3.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "461.32 311.69 461.29 321.63 459.48 322.69 459.51 312.74 461.32 311.69"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M450.54,335.22l.03-9.94c.01-4.54,2.99-9.08,8.94-12.53l-.03,9.94c-5.95,3.46-8.93,7.99-8.94,12.53Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-269"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M459.51,312.74l-.03,9.94c-4.75,2.76-7.6,6.21-8.57,9.8l.03-9.94c.96-3.59,3.82-7.04,8.57-9.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M450.94,322.54l-.03,9.94c-.24.91-.37,1.82-.37,2.74l.03-9.94c0-.92.13-1.83.37-2.74h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M458.78,338.5l-.03,9.94c-6.31-3.64-9.46-8.44-9.45-13.22l.03-9.94c-.01,4.79,3.14,9.58,9.45,13.22h0Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "466.36 342.87 466.33 352.81 458.75 348.44 458.78 338.5 466.36 342.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M461.32,311.69l-1.81,1.05c-11.97,6.96-11.91,18.29.14,25.25l7.57,4.37-.87.51-7.57-4.37c-12.54-7.24-12.61-19.02-.15-26.26l1.81-1.05.88.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "467.23 342.36 467.2 352.3 466.33 352.81 466.36 342.87 467.23 342.36"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M471.47,338.51l2.44-1.42c2.02-1.18,4.83-1.01,7.92.78l-2.44,1.42c-3.09-1.79-5.9-1.95-7.92-.78Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-137"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M471.47,338.51l2.44-1.42c2.02-1.18,4.83-1.01,7.92.78l-2.44,1.42c-3.09-1.79-5.9-1.95-7.92-.78h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M489.68,364.23l-2.44,1.42c2-1.16,3.24-3.63,3.25-7.14.02-7.06-4.95-15.67-11.1-19.22l2.44-1.42c6.15,3.55,11.12,12.16,11.1,19.22,0,3.51-1.25,5.98-3.25,7.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M479.4,339.28l2.44-1.42c.88.51,1.73,1.12,2.55,1.81l-2.44,1.42c-.82-.69-1.67-1.31-2.55-1.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M481.95,341.1l2.44-1.42c1.86,1.57,3.53,3.58,4.9,5.79l-2.44,1.42c-1.37-2.21-3.04-4.22-4.9-5.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M486.85,346.89l2.44-1.42c1.21,1.96,2.18,4.08,2.81,6.21l-2.44,1.42c-.63-2.13-1.6-4.25-2.81-6.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M489.66,353.1l2.44-1.42c.54,1.83.84,3.66.84,5.4,0,.93-.09,1.78-.26,2.56l-2.44,1.42c.17-.78.25-1.63.26-2.56,0-1.74-.29-3.57-.84-5.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M490.24,361.07l2.44-1.42c-.46,2.16-1.52,3.72-2.99,4.58l-2.44,1.42c1.47-.85,2.53-2.42,2.99-4.58h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M479.4,339.28c6.15,3.55,11.12,12.16,11.1,19.22-.02,7.06-5.02,9.91-11.17,6.37-6.15-3.55-11.12-12.16-11.1-19.22.02-7.06,5.02-9.91,11.17-6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M479.39,341.3c5.18,2.99,9.36,10.24,9.35,16.19s-4.23,8.35-9.41,5.36c-5.18-2.99-9.36-10.24-9.35-16.19.02-5.95,4.23-8.35,9.41-5.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M479.38,344.79c3.5,2.02,6.33,6.92,6.32,10.94-.01,4.02-2.86,5.64-6.36,3.62-3.5-2.02-6.33-6.92-6.32-10.94.01-4.02,2.86-5.64,6.36-3.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M466.96,339.48l3.49-2.03c2.18-1.27,5.2-1.09,8.53.84l-3.5,2.03c-3.33-1.92-6.35-2.1-8.53-.84Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-270"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M466.96,339.48l3.49-2.03c2.18-1.27,5.2-1.09,8.53.84l-3.5,2.03c-3.33-1.92-6.35-2.1-8.53-.84h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M487.44,366.67l-3.49,2.03c2.15-1.25,3.49-3.91,3.5-7.69.02-7.61-5.33-16.87-11.95-20.7l3.5-2.03c6.62,3.82,11.97,13.09,11.95,20.7-.01,3.78-1.35,6.44-3.5,7.69Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-267"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M475.49,340.32l3.5-2.03c.95.55,1.87,1.2,2.75,1.95l-3.49,2.03c-.88-.75-1.8-1.41-2.75-1.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M478.24,342.27l3.49-2.03c2,1.69,3.8,3.85,5.27,6.24l-3.5,2.03c-1.47-2.38-3.28-4.54-5.27-6.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M483.52,348.51l3.5-2.03c1.3,2.11,2.34,4.4,3.02,6.69l-3.49,2.03c-.68-2.29-1.72-4.58-3.03-6.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M486.54,355.2l3.49-2.03c.58,1.97.91,3.94.9,5.81,0,1-.1,1.92-.28,2.76l-3.49,2.03c.18-.84.27-1.76.28-2.76,0-1.87-.32-3.85-.9-5.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M487.17,363.77l3.49-2.03c-.5,2.33-1.64,4.01-3.22,4.93l-3.49,2.03c1.58-.92,2.72-2.6,3.22-4.93h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M475.49,340.32c6.62,3.82,11.97,13.09,11.95,20.7-.02,7.61-5.41,10.68-12.03,6.85-6.62-3.82-11.97-13.09-11.95-20.7.02-7.61,5.41-10.67,12.03-6.85Z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M314.11,380l-112.15-65.08c-1.05-.61-1.58-1.41-1.58-2.21l.02,5.07c0,.8.53,1.6,1.58,2.21l112.15,65.08v-5.07Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "203.07 319.06 204.37 316.42 166.74 176.47 162.13 175.73 200.52 318.42 203.07 319.06"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M330.32,74.59l4.61.74c-.54-.09-1.13.02-1.69.34l-4.61-.74c.56-.33,1.15-.43,1.69-.34Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-240"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M333.24,75.67l-4.61-.74c.56-.33,1.15-.43,1.69-.34l4.61.74c-.54-.09-1.13.02-1.69.34h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "168.71 170.92 164.1 170.18 328.63 74.93 333.24 75.67 168.71 170.92"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M166.74,176.47l-4.61-.74c-.57-2.11.31-4.6,1.97-5.55l4.61.74c-1.65.95-2.53,3.44-1.97,5.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M166.74,176.47l-4.61-.74c-.57-2.11.31-4.6,1.97-5.55l4.61.74c-1.65.95-2.53,3.44-1.97,5.55h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M333.24,75.67c1.65-.95,3.45-.02,4.02,2.09l37.63,139.95-170.64,98.53-37.5-139.77c-.57-2.11.31-4.59,1.97-5.55l164.53-95.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "204.36 302.93 206.56 311.13 370.83 216.04 368.63 207.84 204.36 302.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "170.91 178.59 204.36 302.94 368.63 207.84 368.63 207.84 335.19 83.49 334.49 83.89 333.62 84.4 327.92 87.69 170.91 178.59"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M249.99,125.09c1.25-.72,2.62-.02,3.05,1.59.43,1.6-.24,3.49-1.49,4.21-1.25.72-2.62.01-3.05-1.59-.43-1.6.24-3.48,1.49-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M243.87,130.18c.71-.41,1.49,0,1.73.9.24.91-.14,1.98-.85,2.39-.71.41-1.49,0-1.73-.9-.24-.91.13-1.98.85-2.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M486.36,288.75v-5.07c-.01.81-.55,1.62-1.61,2.24v5.07c1.08-.62,1.62-1.43,1.61-2.24Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-155"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M484.74,285.91v5.07c1.08-.62,1.62-1.43,1.61-2.24v-5.07c-.01.81-.55,1.62-1.61,2.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "321.78 380 321.8 385.07 484.76 290.98 484.74 285.91 321.78 380"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M314.11,380v5.07c2.13,1.23,5.56,1.23,7.68,0v-5.07c-2.14,1.23-5.57,1.22-7.68,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-213"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M314.11,380v5.07c2.13,1.23,5.56,1.23,7.68,0v-5.07c-2.14,1.23-5.57,1.22-7.68,0h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M484.74,285.91l-162.96,94.08c-2.13,1.23-5.56,1.23-7.67,0l-109.86-63.76,170.65-98.53,109.88,63.76c2.11,1.23,2.1,3.22-.03,4.44Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M222.09,313.41c.3,1.27,1.36,2.56,3.16,3.6l57.03,33.01c3.94,2.27,9.88,2.52,13.29.55l136.81-78.98c1.23-.72,1.97-1.62,2.21-2.59.43-1.72-.65-3.63-3.16-5.08l-57.04-33.01c-3.93-2.28-9.88-2.52-13.29-.55l-136.82,78.99c-1.85,1.07-2.57,2.57-2.2,4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M222.09,313.41c.3,1.27,1.36,2.56,3.16,3.6l57.03,33.01c3.94,2.27,9.88,2.52,13.29.55l136.81-78.98c1.23-.72,1.97-1.62,2.21-2.59-.29-1.28-1.36-2.56-3.16-3.6l-57.04-33.02c-3.93-2.27-9.88-2.51-13.29-.55l-136.82,78.99c-1.24.71-1.97,1.62-2.2,2.59Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M372.46,235.79v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-284"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M371.98,235.57v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M360.01,237.25v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-202"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M360.01,237.25v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M360.19,237.67v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.15-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "360.49 237.92 360.49 238.81 363.03 240.29 363.03 239.39 360.49 237.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "365.35 239.39 365.36 240.29 371.98 236.46 371.98 235.57 365.35 239.39"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M363.03,239.39v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M363.03,239.39v.89c.23.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M363.85,239.65v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M360.5,236.57c-.64.37-.65.97,0,1.34l2.54,1.48c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.34l-2.54-1.48c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M368.74,242.35v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-146"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M368.74,242.35v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M368.92,242.78v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M385.23,243.23v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-172"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M384.74,243.02v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "369.22 243.02 369.22 243.91 375.8 247.73 375.8 246.84 369.22 243.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "378.12 246.84 378.12 247.73 384.74 243.91 384.74 243.02 378.12 246.84"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M375.8,246.84v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-299"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M375.8,246.84v.89c.23.13.52.22.82.26v-.89c-.3-.04-.58-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M376.61,247.1v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M369.23,241.67c-.64.37-.65.98,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.98.01-1.35l-6.58-3.82c-.64-.37-1.69-.37-2.33,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M359.47,243.29v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-266"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M358.98,243.07v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M347.02,244.75v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-208"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M347.02,244.75v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M347.19,245.18v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "347.49 245.42 347.5 246.31 350.04 247.79 350.04 246.9 347.49 245.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "352.36 246.9 352.36 247.79 358.98 243.97 358.98 243.07 352.36 246.9"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M350.04,246.9v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-241"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M350.04,246.9v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M350.85,247.16v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M347.5,244.08c-.64.37-.65.97,0,1.34l2.54,1.48c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.34l-2.54-1.48c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M357.89,248.61v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-100"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M357.89,248.61v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M358.06,249.04v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M374.38,249.49v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M373.89,249.28v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "358.37 249.28 358.37 250.18 364.95 254 364.95 253.11 358.37 249.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "367.27 253.1 367.27 254 373.89 250.18 373.89 249.28 367.27 253.1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M364.95,253.11v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-158"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M364.95,253.11v.89c.23.13.52.22.82.26v-.89c-.3-.04-.58-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M365.76,253.36v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M358.38,247.94c-.64.37-.65.98,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97.01-1.35l-6.58-3.82c-.64-.37-1.69-.37-2.33,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M346.47,250.79v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-307"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M345.99,250.58v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M334.02,252.25v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M334.02,252.25v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M334.2,252.68v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "334.5 252.92 334.5 253.82 337.04 255.29 337.04 254.4 334.5 252.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "339.36 254.4 339.37 255.29 345.99 251.47 345.99 250.58 339.36 254.4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M337.04,254.4v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M337.04,254.4v.89c.23.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M337.86,254.66v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M334.51,251.58c-.64.37-.65.97,0,1.35l2.54,1.48c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.34l-2.54-1.48c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M347.44,254.65v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-168"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M347.44,254.65v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M347.61,255.08v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M363.92,255.53v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-239"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M363.44,255.32v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "347.92 255.32 347.92 256.21 354.49 260.03 354.49 259.14 347.92 255.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "356.82 259.14 356.82 260.03 363.44 256.21 363.44 255.32 356.82 259.14"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M354.49,259.14v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-144"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M354.49,259.14v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M355.31,259.4v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M347.92,253.97c-.65.37-.65.98,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.33,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M336.58,260.91v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M336.58,260.91v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M336.76,261.34v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M353.07,261.8v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-279"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M352.59,261.58v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "337.06 261.58 337.07 262.48 343.64 266.3 343.64 265.41 337.06 261.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "345.96 265.41 345.97 266.3 352.59 262.47 352.59 261.58 345.96 265.41"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M343.64,265.41v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-254"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M343.64,265.41v.89c.23.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M344.46,265.66v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M337.07,260.24c-.64.37-.65.97,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.34l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M333.48,258.29v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-182"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M332.99,258.08v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M321.03,259.76v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M321.03,259.76v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M321.2,260.18v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.16-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "321.5 260.43 321.51 261.32 324.05 262.8 324.05 261.9 321.5 260.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "326.37 261.9 326.37 262.8 332.99 258.97 332.99 258.08 326.37 261.9"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M324.05,261.9v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.69.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-129"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M324.05,261.9v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M324.86,262.16v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M321.51,259.08c-.64.37-.65.97,0,1.34l2.54,1.48c.64.37,1.68.37,2.32,0l6.62-3.82c.65-.37.65-.98.01-1.35l-2.54-1.48c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M325.73,267.18v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M325.73,267.18v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M325.91,267.6v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M342.22,268.06v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-234"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M341.73,267.85v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "326.21 267.85 326.22 268.74 332.79 272.56 332.79 271.67 326.21 267.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "335.11 271.67 335.11 272.56 341.74 268.74 341.73 267.85 335.11 271.67"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M332.79,271.67v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-291"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M332.79,271.67v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M333.61,271.93v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M326.22,266.5c-.64.37-.65.97,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M320.48,265.8v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-231"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M319.99,265.58v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M308.03,267.26v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-297"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M308.03,267.26v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M308.2,267.69v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "308.51 267.93 308.51 268.82 311.05 270.3 311.05 269.41 308.51 267.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "313.37 269.41 313.38 270.3 320 266.48 319.99 265.58 313.37 269.41"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M311.05,269.41v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-225"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M311.05,269.41v.89c.23.13.52.22.82.26v-.89c-.3-.04-.58-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M311.86,269.66v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M308.52,266.58c-.64.37-.65.98-.01,1.35l2.54,1.48c.64.37,1.68.37,2.32,0l6.62-3.82c.65-.37.65-.98.01-1.35l-2.54-1.48c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M314.88,273.44v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-290"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M314.88,273.44v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M315.06,273.87v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M331.37,274.33v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-244"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M330.88,274.11v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "315.36 274.11 315.36 275.01 321.94 278.83 321.94 277.94 315.36 274.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "324.26 277.94 324.26 278.83 330.89 275.01 330.88 274.11 324.26 277.94"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M321.94,277.94v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-262"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M321.94,277.94v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M322.75,278.19v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M315.37,272.77c-.64.37-.65.97,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.34l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M307.49,273.3v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-289"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M307,273.09v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M295.03,274.77v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.42-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M295.03,274.77v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M295.21,275.19v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "295.51 275.43 295.51 276.33 298.06 277.8 298.05 276.91 295.51 275.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "300.38 276.91 300.38 277.8 307 273.98 307 273.09 300.38 276.91"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M298.05,276.91v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-276"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M298.05,276.91v.89c.23.13.52.22.82.26v-.89c-.3-.04-.58-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M298.87,277.17v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M295.52,274.09c-.64.37-.65.98-.01,1.35l2.54,1.48c.64.37,1.68.37,2.32,0l6.62-3.82c.65-.37.65-.98.01-1.35l-2.54-1.48c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M304.03,279.71v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M304.03,279.71v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M304.2,280.14v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M320.52,280.59v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-180"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M320.03,280.38v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "304.51 280.38 304.51 281.27 311.09 285.09 311.09 284.2 304.51 280.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "313.41 284.2 313.41 285.09 320.03 281.27 320.03 280.38 313.41 284.2"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M311.09,284.2v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M311.09,284.2v.89c.23.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M311.9,284.46v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M304.51,279.03c-.64.37-.65.97,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.33,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M294.49,280.8v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M294,280.59v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M282.04,282.27v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M282.04,282.27v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M282.21,282.69v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "282.51 282.94 282.52 283.83 285.06 285.31 285.06 284.41 282.51 282.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "287.38 284.41 287.39 285.3 294 281.48 294 280.59 287.38 284.41"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M285.06,284.41v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M285.06,284.41v.89c.23.13.52.22.82.26v-.89c-.3-.04-.58-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M285.87,284.67v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M282.53,281.59c-.64.37-.65.98-.01,1.35l2.54,1.48c.64.37,1.68.37,2.33,0l6.62-3.82c.64-.37.65-.98.01-1.35l-2.54-1.48c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M293.18,285.97v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-281"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M293.18,285.97v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M293.35,286.4v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M309.67,286.86v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-309"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M309.18,286.64v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "293.66 286.64 293.66 287.54 300.24 291.36 300.24 290.47 293.66 286.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "302.56 290.47 302.56 291.36 309.18 287.54 309.18 286.64 302.56 290.47"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M300.24,290.47v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-296"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M300.24,290.47v.89c.23.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M301.05,290.72v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M293.66,285.3c-.64.37-.65.97,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.34l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M281.5,288.3v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-304"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M281.01,288.09v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M269.04,289.77v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M269.04,289.77v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M269.22,290.2v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "269.52 290.44 269.52 291.33 272.07 292.81 272.06 291.92 269.52 290.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "274.39 291.91 274.39 292.81 281.01 288.99 281.01 288.09 274.39 291.91"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M272.06,291.92v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-256"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M272.06,291.92v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M272.88,292.17v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M269.53,289.09c-.64.37-.65.98-.01,1.35l2.54,1.48c.64.37,1.68.37,2.33,0l6.62-3.82c.64-.37.65-.98.01-1.35l-2.54-1.48c-.64-.37-1.68-.37-2.33,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M282.33,292.24v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-300"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M282.33,292.24v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M282.5,292.67v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M298.82,293.12v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M298.33,292.91v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "282.81 292.91 282.81 293.8 289.39 297.62 289.38 296.73 282.81 292.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "291.71 296.73 291.71 297.62 298.33 293.8 298.33 292.91 291.71 296.73"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M289.38,296.73v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M289.38,296.73v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M290.2,296.99v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M282.81,291.56c-.64.37-.65.97,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.34l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M271.48,298.5v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-288"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M271.48,298.5v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M271.65,298.93v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M287.96,299.39v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M287.48,299.17v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "271.96 299.17 271.96 300.07 278.53 303.89 278.53 303 271.96 299.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "280.85 303 280.86 303.89 287.48 300.07 287.48 299.17 280.85 303"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M278.53,303v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-142"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M278.53,303v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M279.35,303.25v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M271.96,297.83c-.64.37-.65.97,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M268.5,295.81v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M268.01,295.59v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M256.05,297.27v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M256.05,297.27v.89c0,.15.06.29.18.42v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M256.22,297.7v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "256.52 297.94 256.53 298.83 259.07 300.31 259.07 299.42 256.52 297.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "261.39 299.42 261.39 300.31 268.01 296.49 268.01 295.59 261.39 299.42"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M259.07,299.42v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-212"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M259.07,299.42v.89c.23.13.52.22.82.26v-.89c-.3-.04-.58-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M259.88,299.68v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M256.54,296.59c-.64.37-.65.98-.01,1.35l2.54,1.48c.64.37,1.68.37,2.33,0l6.62-3.82c.64-.37.65-.98.01-1.35l-2.54-1.48c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M260.62,304.77v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-194"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M260.62,304.77v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M260.8,305.2v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M277.11,305.65v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-147"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M276.63,305.44v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "261.1 305.44 261.11 306.33 267.68 310.15 267.68 309.26 261.1 305.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "270 309.26 270.01 310.15 276.63 306.33 276.63 305.44 270 309.26"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M267.68,309.26v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-224"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M267.68,309.26v.89c.23.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M268.5,309.52v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M261.11,304.09c-.64.37-.65.97,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M255.51,303.31v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M255.02,303.1v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M243.05,304.78v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-277"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M243.05,304.78v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M243.23,305.2v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "243.53 305.44 243.53 306.34 246.08 307.81 246.07 306.92 243.53 305.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "248.4 306.92 248.4 307.81 255.02 303.99 255.02 303.1 248.4 306.92"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M246.07,306.92v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-302"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M246.07,306.92v.89c.23.13.52.22.82.26v-.89c-.3-.04-.58-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M246.89,307.18v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M243.54,304.1c-.64.37-.65.98-.01,1.35l2.54,1.48c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.98.01-1.35l-2.54-1.48c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M249.77,311.03v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-243"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M249.77,311.03v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M249.95,311.46v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M266.26,311.92v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-106"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M265.77,311.7v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "250.25 311.7 250.26 312.6 256.83 316.42 256.83 315.53 250.25 311.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "259.15 315.53 259.15 316.42 265.78 312.6 265.77 311.7 259.15 315.53"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M256.83,315.53v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-121"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M256.83,315.53v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M257.65,315.78v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M250.26,310.36c-.64.37-.65.97,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.34l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M242.51,310.81v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M242.02,310.6v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M230.06,312.28v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-268"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M230.06,312.28v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M230.23,312.71v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "230.53 312.95 230.54 313.84 233.08 315.32 233.08 314.42 230.53 312.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "235.4 314.42 235.4 315.32 242.02 311.49 242.02 310.6 235.4 314.42"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M233.08,314.42v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-247"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M233.08,314.42v.89c.23.13.52.22.82.26v-.89c-.3-.04-.58-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M233.89,314.68v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M230.55,311.6c-.64.37-.65.98-.01,1.35l2.54,1.48c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.98.01-1.35l-2.54-1.48c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M238.92,317.3v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-287"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M238.92,317.3v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M239.1,317.73v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M255.41,318.18v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M254.92,317.97v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "239.4 317.97 239.4 318.86 245.98 322.68 245.98 321.79 239.4 317.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "248.3 321.79 248.3 322.68 254.93 318.86 254.92 317.97 248.3 321.79"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M245.98,321.79v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-87"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M245.98,321.79v.89c.23.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M246.79,322.05v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M239.41,316.62c-.64.37-.65.97,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.34l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M395.84,249.4v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-192"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M395.36,249.19v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M363.08,257.91v.89c0,.24.16.49.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-214"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M363.08,257.91v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M363.25,258.34v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "363.56 258.58 363.56 259.48 370.13 263.3 370.13 262.4 363.56 258.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "372.46 262.41 372.46 263.3 395.36 250.08 395.36 249.19 372.46 262.41"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M370.13,262.4v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.68.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-272"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M370.13,262.4v.89c.24.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M370.95,262.66v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M363.56,257.24c-.64.37-.64.98,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l22.9-13.22c.64-.37.65-.98,0-1.35l-6.58-3.82c-.64-.37-1.69-.37-2.33,0l-22.9,13.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M352.62,263.95v.89c0,.24.16.49.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-131"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M352.62,263.95v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M352.8,264.37v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M369.12,264.83v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-206"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M368.63,264.62v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "353.1 264.62 353.11 265.51 359.68 269.33 359.68 268.44 353.1 264.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "362 268.44 362.01 269.33 368.63 265.51 368.63 264.62 362 268.44"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M359.68,268.44v.89c.65.37,1.68.37,2.33,0v-.89c-.65.37-1.68.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-286"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M359.68,268.44v.89c.24.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M360.5,268.7v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M353.11,263.27c-.64.37-.64.98,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M406.46,255.56v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-178"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M405.97,255.35v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M379.11,260.95v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-162"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M379.11,260.95v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M379.29,261.38v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "379.59 261.62 379.59 262.51 386.17 266.33 386.17 265.44 379.59 261.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "388.5 265.44 388.5 266.33 405.97 256.24 405.97 255.35 388.5 265.44"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M386.17,265.44v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-220"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M386.17,265.44v.89c.23.13.52.22.82.26v-.89c-.3-.04-.58-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M386.98,265.7v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M379.6,260.27c-.64.37-.65.98-.01,1.35l6.58,3.82c.64.37,1.68.37,2.33,0l17.47-10.09c.64-.37.65-.98.01-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-17.47,10.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M368.66,266.98v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M368.66,266.98v.89c0,.15.06.29.18.42v-.89c-.12-.13-.18-.28-.18-.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M368.83,267.41v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.15-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M385.15,267.87v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-118"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M384.66,267.65v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "369.14 267.65 369.14 268.54 375.72 272.37 375.72 271.48 369.14 267.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "378.04 271.47 378.05 272.37 384.67 268.54 384.66 267.65 378.04 271.47"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M375.72,271.48v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-303"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M375.72,271.48v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M376.53,271.73v.89c.53.06,1.1-.02,1.51-.26v-.89c-.42.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M369.15,266.3c-.65.37-.65.98-.01,1.35l6.58,3.82c.64.37,1.68.37,2.33,0l6.62-3.82c.64-.37.65-.97,0-1.34l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M341.77,270.21v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M341.77,270.21v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M341.95,270.64v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M358.26,271.1v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-103"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M357.78,270.88v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "342.25 270.88 342.25 271.78 348.83 275.6 348.82 274.71 342.25 270.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "351.15 274.71 351.16 275.6 357.78 271.77 357.78 270.88 351.15 274.71"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M348.82,274.71v.89c.65.37,1.69.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-174"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M348.82,274.71v.89c.24.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M349.64,274.96v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M342.26,269.53c-.64.37-.65.98,0,1.35l6.58,3.82c.64.37,1.69.37,2.33,0l6.62-3.82c.64-.37.65-.97,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M357.81,273.25v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-294"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M357.81,273.25v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M357.98,273.67v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M374.3,274.13v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M373.81,273.92v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "358.29 273.92 358.29 274.81 364.87 278.63 364.87 277.74 358.29 273.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "367.19 277.74 367.19 278.63 373.81 274.81 373.81 273.92 367.19 277.74"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M364.87,277.74v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-105"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M364.87,277.74v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M365.68,278v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M358.29,272.57c-.64.37-.65.97,0,1.34l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.34l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M330.92,276.48v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M330.92,276.48v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M331.09,276.91v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M347.41,277.36v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-115"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M346.92,277.15v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "331.4 277.15 331.4 278.04 337.98 281.86 337.97 280.97 331.4 277.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "340.3 280.97 340.3 281.86 346.92 278.04 346.92 277.15 340.3 280.97"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M337.97,280.97v.89c.65.37,1.69.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-123"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M337.97,280.97v.89c.24.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M338.79,281.23v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M331.4,275.8c-.64.37-.65.98,0,1.35l6.58,3.82c.64.37,1.69.37,2.33,0l6.62-3.82c.64-.37.65-.97,0-1.35l-6.58-3.82c-.64-.37-1.69-.37-2.33,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M346.96,279.51v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-93"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M346.96,279.51v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M347.13,279.94v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M363.45,280.4v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M362.96,280.18v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "347.43 280.18 347.44 281.07 354.02 284.9 354.01 284.01 347.43 280.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "356.34 284.01 356.34 284.9 362.96 281.07 362.96 280.18 356.34 284.01"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M354.01,284.01v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-283"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M354.01,284.01v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M354.83,284.26v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M347.44,278.84c-.64.37-.65.97,0,1.34l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M320.07,282.74v.89c0,.24.16.49.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M320.07,282.74v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M320.24,283.17v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M336.56,283.63v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-199"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M336.07,283.41v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "320.54 283.41 320.55 284.31 327.12 288.13 327.12 287.24 320.54 283.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "329.45 287.24 329.45 288.13 336.07 284.31 336.07 283.41 329.45 287.24"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M327.12,287.24v.89c.64.37,1.69.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-90"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M327.12,287.24v.89c.24.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M327.94,287.49v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M320.55,282.07c-.64.37-.65.98,0,1.35l6.58,3.82c.64.37,1.69.37,2.33,0l6.62-3.82c.64-.37.65-.98,0-1.35l-6.58-3.82c-.64-.37-1.69-.37-2.33,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M336.11,285.78v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-184"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M336.11,285.78v.89c0,.15.06.29.18.42v-.89c-.12-.13-.18-.28-.18-.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M336.28,286.2v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M352.6,286.66v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M352.11,286.45v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "336.58 286.45 336.59 287.34 343.17 291.16 343.16 290.27 336.58 286.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "345.48 290.27 345.49 291.16 352.11 287.34 352.11 286.45 345.48 290.27"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M343.16,290.27v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-126"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M343.16,290.27v.89c.23.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M343.98,290.53v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M336.59,285.1c-.64.37-.65.97,0,1.34l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.34l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M309.22,289.01v.89c0,.24.16.49.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M309.22,289.01v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M309.39,289.44v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M325.71,289.89v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-221"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M325.22,289.68v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "309.69 289.68 309.7 290.57 316.27 294.39 316.27 293.5 309.69 289.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "318.6 293.5 318.6 294.39 325.22 290.57 325.22 289.68 318.6 293.5"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M316.27,293.5v.89c.65.37,1.69.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M316.27,293.5v.89c.24.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M317.09,293.76v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M309.7,288.33c-.64.37-.65.98,0,1.35l6.58,3.82c.64.37,1.68.37,2.33,0l6.62-3.82c.64-.37.65-.98,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.33,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M325.25,292.04v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-113"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M325.25,292.04v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M325.43,292.47v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M341.74,292.93v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-248"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M341.26,292.71v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "325.73 292.71 325.73 293.6 332.31 297.43 332.31 296.54 325.73 292.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "334.63 296.54 334.64 297.43 341.26 293.61 341.26 292.71 334.63 296.54"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M332.31,296.54v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-156"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M332.31,296.54v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M333.13,296.79v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M325.74,291.37c-.64.37-.65.97,0,1.34l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.34l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M298.36,295.27v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-246"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M298.36,295.27v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M298.54,295.7v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.16-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M314.86,296.16v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-98"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M314.37,295.94v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "298.84 295.94 298.84 296.84 305.42 300.66 305.42 299.77 298.84 295.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "307.75 299.77 307.75 300.66 314.37 296.84 314.37 295.94 307.75 299.77"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M305.42,299.77v.89c.65.37,1.69.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-261"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M305.42,299.77v.89c.23.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M306.24,300.02v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M298.85,294.6c-.64.37-.65.98,0,1.35l6.58,3.82c.64.37,1.69.37,2.33,0l6.62-3.82c.64-.37.65-.98,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.33,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M314.4,298.31v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-189"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M314.4,298.31v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M314.58,298.73v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M330.89,299.19v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M330.4,298.98v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "314.88 298.98 314.88 299.87 321.46 303.69 321.46 302.8 314.88 298.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "323.78 302.8 323.78 303.69 330.41 299.87 330.4 298.98 323.78 302.8"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M321.46,302.8v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-96"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M321.46,302.8v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M322.28,303.06v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M314.89,297.63c-.64.37-.65.97,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M287.51,301.54v.89c0,.24.16.49.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-222"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M287.51,301.54v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M287.69,301.97v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M304,302.42v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-166"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M303.52,302.21v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "287.99 302.21 287.99 303.1 294.57 306.92 294.57 306.03 287.99 302.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "296.9 306.03 296.9 306.92 303.52 303.1 303.52 302.21 296.9 306.03"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M294.57,306.03v.89c.65.37,1.69.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-186"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M294.57,306.03v.89c.24.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M295.39,306.29v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M288,300.86c-.64.37-.65.98,0,1.35l6.58,3.82c.64.37,1.69.37,2.33,0l6.62-3.82c.64-.37.65-.97,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.33,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M303.55,304.57v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-265"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M303.55,304.57v.89c0,.15.06.29.18.42v-.89c-.12-.13-.18-.28-.18-.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M303.73,305v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.15-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M320.04,305.46v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-177"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M319.55,305.24v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "304.03 305.24 304.03 306.13 310.61 309.96 310.61 309.07 304.03 305.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "312.93 309.07 312.93 309.96 319.56 306.13 319.55 305.24 312.93 309.07"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M310.61,309.07v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-109"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M310.61,309.07v.89c.23.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M311.42,309.32v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M304.04,303.9c-.64.37-.65.97,0,1.34l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.34l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M276.66,307.8v.89c0,.24.16.49.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-306"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M276.66,307.8v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M276.84,308.23v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M293.15,308.69v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-226"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M292.66,308.47v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "277.14 308.47 277.14 309.37 283.72 313.19 283.72 312.3 277.14 308.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "286.04 312.3 286.05 313.19 292.67 309.37 292.66 308.47 286.04 312.3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M283.72,312.3v.89c.65.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-298"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M283.72,312.3v.89c.24.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M284.54,312.56v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M277.15,307.13c-.65.37-.65.98,0,1.35l6.58,3.82c.64.37,1.68.37,2.33,0l6.62-3.82c.64-.37.65-.97,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M265.81,314.07v.89c0,.24.16.49.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-295"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M265.81,314.07v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M265.98,314.5v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M282.3,314.96v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-201"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M281.81,314.74v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "266.29 314.74 266.29 315.63 272.87 319.45 272.86 318.56 266.29 314.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "275.19 318.56 275.2 319.45 281.82 315.63 281.81 314.74 275.19 318.56"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M272.86,318.56v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-278"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M272.86,318.56v.89c.24.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M273.68,318.82v.89c.53.07,1.1-.02,1.51-.26v-.89c-.42.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M266.3,313.39c-.65.37-.65.98,0,1.35l6.58,3.82c.64.37,1.68.37,2.33,0l6.62-3.82c.64-.37.65-.97,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M271.45,321.22v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-176"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M270.96,321v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M249.53,323.47v.89c0,.24.16.49.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-216"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M249.53,323.47v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M249.71,323.89v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "250.01 324.14 250.01 325.03 256.59 328.85 256.59 327.96 250.01 324.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "258.91 327.96 258.92 328.85 270.96 321.9 270.96 321 258.91 327.96"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M256.59,327.96v.89c.65.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-95"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M256.59,327.96v.89c.24.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M257.41,328.22v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M250.02,322.79c-.64.37-.64.97,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l12.05-6.96c.64-.37.65-.97,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.33,0l-12.05,6.96Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M292.7,310.84v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-232"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M292.7,310.84v.89c0,.15.06.29.18.42v-.89c-.12-.13-.18-.28-.18-.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M292.87,311.26v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.15-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M309.19,311.72v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M308.7,311.51v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "293.18 311.51 293.18 312.4 299.76 316.22 299.76 315.33 293.18 311.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "302.08 315.33 302.08 316.22 308.7 312.4 308.7 311.51 302.08 315.33"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M299.76,315.33v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-183"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M299.76,315.33v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M300.57,315.59v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M293.18,310.16c-.64.37-.65.97,0,1.34l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.34l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M281.85,317.1v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-253"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M281.85,317.1v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M282.02,317.53v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.15-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M298.34,317.99v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-233"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M297.85,317.77v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "282.33 317.77 282.33 318.66 288.91 322.49 288.91 321.6 282.33 317.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "291.23 321.6 291.23 322.49 297.85 318.67 297.85 317.77 291.23 321.6"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M288.91,321.6v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M288.91,321.6v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M289.72,321.85v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M282.33,316.43c-.64.37-.65.97,0,1.34l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.34l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M287.49,324.25v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M287,324.04v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M260.15,329.63v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-237"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M260.15,329.63v.89c0,.15.06.29.18.42v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M260.32,330.06v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "260.62 330.3 260.63 331.2 267.21 335.02 267.2 334.13 260.62 330.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "269.52 334.13 269.53 335.02 287 324.93 287 324.04 269.52 334.13"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M267.2,334.13v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M267.2,334.13v.89c.23.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M268.02,334.38v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M260.63,328.96c-.64.37-.65.97,0,1.34l6.58,3.82c.64.37,1.68.37,2.32,0l17.47-10.09c.64-.37.65-.97,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-17.48,10.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M417.07,261.73v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M416.58,261.52v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M384.7,270.02v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M384.7,270.02v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M384.87,270.44v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "385.17 270.68 385.18 271.58 391.76 275.4 391.76 274.51 385.17 270.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "394.08 274.51 394.08 275.4 416.58 262.41 416.58 261.52 394.08 274.51"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M391.76,274.51v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-104"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M391.76,274.51v.89c.23.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M392.57,274.77v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M385.18,269.34c-.64.37-.65.97,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l22.5-12.99c.64-.37.65-.98.01-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.33,0l-22.5,12.99Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M373.85,276.28v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-136"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M373.85,276.28v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M374.02,276.71v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.15-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M390.34,277.17v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-250"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M389.85,276.95v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "374.32 276.95 374.33 277.84 380.91 281.67 380.9 280.77 374.32 276.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "383.23 280.77 383.23 281.67 389.85 277.84 389.85 276.95 383.23 280.77"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M380.9,280.77v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-207"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M380.9,280.77v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M381.72,281.03v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M374.33,275.6c-.64.37-.65.97,0,1.34l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.34l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M411.19,267.02v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M411.19,267.02v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M411.36,267.44v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M427.68,267.9v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-181"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M427.19,267.69v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "411.67 267.69 411.67 268.58 418.25 272.4 418.24 271.51 411.67 267.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "420.57 271.51 420.57 272.4 427.19 268.58 427.19 267.69 420.57 271.51"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M418.24,271.51v.89c.64.37,1.69.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M418.24,271.51v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M419.06,271.77v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M411.67,266.34c-.64.37-.65.98,0,1.35l6.58,3.82c.64.37,1.69.37,2.33,0l6.62-3.82c.64-.37.65-.98,0-1.35l-6.58-3.82c-.64-.37-1.69-.37-2.33,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M400.34,273.28v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M400.34,273.28v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M400.51,273.71v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M416.83,274.17v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-255"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M416.34,273.95v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "400.81 273.95 400.82 274.84 407.39 278.67 407.39 277.77 400.81 273.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "409.72 277.77 409.72 278.67 416.34 274.84 416.34 273.95 409.72 277.77"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M407.39,277.77v.89c.64.37,1.69.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M407.39,277.77v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M408.21,278.03v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M400.82,272.6c-.64.37-.65.97,0,1.35l6.58,3.82c.64.37,1.69.37,2.33,0l6.62-3.82c.64-.37.65-.98,0-1.35l-6.58-3.82c-.64-.37-1.69-.37-2.33,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M389.88,279.32v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M389.88,279.32v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M390.06,279.74v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M406.37,280.2v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-275"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M405.89,279.99v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "390.36 279.99 390.36 280.88 396.94 284.7 396.94 283.81 390.36 279.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "399.27 283.81 399.27 284.7 405.89 280.88 405.89 279.99 399.27 283.81"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M396.94,283.81v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-252"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M396.94,283.81v.89c.24.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M397.76,284.07v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M390.37,278.64c-.65.37-.65.98,0,1.35l6.58,3.82c.64.37,1.68.37,2.33,0l6.62-3.82c.64-.37.64-.97,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M362.99,282.55v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-160"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M362.99,282.55v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M363.17,282.97v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.15-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M379.48,283.43v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M378.99,283.22v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "363.47 283.21 363.47 284.11 370.06 287.93 370.05 287.04 363.47 283.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "372.37 287.04 372.38 287.93 379 284.11 378.99 283.22 372.37 287.04"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M370.05,287.04v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M370.05,287.04v.89c.23.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M370.87,287.3v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M363.48,281.87c-.64.37-.65.97,0,1.34l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.65-.37.65-.98.01-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.33,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M352.14,288.81v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-210"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M352.14,288.81v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M352.32,289.24v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M368.63,289.69v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-236"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M368.14,289.48v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "352.62 289.48 352.62 290.37 359.2 294.2 359.2 293.3 352.62 289.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "361.52 293.3 361.53 294.2 368.15 290.37 368.14 289.48 361.52 293.3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M359.2,293.3v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M359.2,293.3v.89c.23.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M360.02,293.56v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M352.63,288.13c-.64.37-.65.97,0,1.34l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.65-.37.65-.98.01-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.33,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M341.29,295.08v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.42-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M341.29,295.08v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M341.47,295.51v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M357.78,295.96v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-219"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M357.29,295.75v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "341.77 295.75 341.77 296.64 348.35 300.46 348.35 299.57 341.77 295.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "350.67 299.57 350.67 300.46 357.29 296.64 357.29 295.75 350.67 299.57"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M348.35,299.57v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-301"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M348.35,299.57v.89c.23.13.52.22.82.26v-.89c-.3-.04-.58-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M349.16,299.83v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M341.78,294.4c-.64.37-.65.97-.01,1.35l6.58,3.82c.64.37,1.68.37,2.33,0l6.62-3.82c.65-.37.65-.98.01-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.33,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M330.44,301.35v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-117"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M330.44,301.35v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M330.61,301.77v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M346.93,302.22v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M346.44,302.01v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "330.91 302.01 330.92 302.91 337.5 306.73 337.49 305.84 330.91 302.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "339.82 305.83 339.82 306.73 346.44 302.91 346.44 302.01 339.82 305.83"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M337.49,305.84v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-229"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M337.49,305.84v.89c.23.13.52.22.82.26v-.89c-.3-.04-.58-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M338.31,306.09v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M330.93,300.67c-.64.37-.65.98-.01,1.35l6.58,3.82c.64.37,1.68.37,2.33,0l6.62-3.82c.64-.37.65-.98.01-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.33,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M319.59,307.61v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M319.59,307.61v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M319.76,308.04v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M336.08,308.49v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-151"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M335.59,308.28v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "320.06 308.28 320.07 309.17 326.65 312.99 326.64 312.1 320.06 308.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "328.97 312.1 328.97 312.99 335.59 309.17 335.59 308.28 328.97 312.1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M326.64,312.1v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M326.64,312.1v.89c.23.13.52.22.82.26v-.89c-.3-.04-.58-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M327.46,312.36v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M320.07,306.93c-.64.37-.65.98-.01,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.98.01-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M308.74,313.87v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.42-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-285"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M308.74,313.87v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M308.91,314.3v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M325.23,314.75v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-185"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M324.74,314.54v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "309.21 314.54 309.21 315.43 315.79 319.26 315.79 318.37 309.21 314.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "318.12 318.36 318.12 319.26 324.74 315.43 324.74 314.54 318.12 318.36"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M315.79,318.37v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-209"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M315.79,318.37v.89c.23.13.52.22.82.26v-.89c-.3-.04-.58-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M316.61,318.62v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M309.22,313.2c-.64.37-.65.98-.01,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.98.01-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M297.88,320.14v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-108"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M297.88,320.14v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M298.06,320.57v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M314.37,321.02v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-215"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M313.89,320.81v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "298.36 320.81 298.36 321.7 304.94 325.52 304.94 324.63 298.36 320.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "307.27 324.63 307.27 325.52 313.89 321.7 313.89 320.81 307.27 324.63"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M304.94,324.63v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M304.94,324.63v.89c.23.13.52.22.82.26v-.89c-.3-.04-.58-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M305.75,324.89v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M298.37,319.46c-.64.37-.65.98-.01,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.98.01-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M287.03,326.41v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-102"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M287.03,326.41v.89c0,.15.06.29.18.42v-.89c-.12-.13-.18-.28-.18-.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M287.21,326.83v.89c.08.09.18.17.3.24v-.89c-.13-.07-.23-.15-.3-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M303.52,327.29v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-238"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M303.03,327.07v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "287.51 327.07 287.51 327.96 294.09 331.79 294.09 330.9 287.51 327.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "296.41 330.89 296.42 331.79 303.04 327.97 303.03 327.07 296.41 330.89"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M294.09,330.9v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M294.09,330.9v.89c.23.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M294.9,331.15v.89c.53.06,1.1-.02,1.51-.26v-.89c-.42.24-.99.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M287.52,325.73c-.65.37-.65.97-.01,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.65-.97,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M379.03,285.58v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-169"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M379.03,285.58v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M379.21,286.01v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M395.52,286.47v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-217"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M395.04,286.25v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "379.51 286.25 379.51 287.14 386.09 290.97 386.09 290.07 379.51 286.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "388.41 290.08 388.41 290.97 395.04 287.14 395.04 286.25 388.41 290.08"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M386.09,290.07v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-249"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M386.09,290.07v.89c.24.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M386.91,290.33v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M379.51,284.9c-.64.37-.65.97,0,1.35l6.58,3.82c.64.37,1.68.37,2.33,0l6.62-3.82c.64-.37.64-.98,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M384.67,292.73v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-198"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M384.18,292.52v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M357.33,298.11v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-228"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M357.33,298.11v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M357.5,298.54v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "357.81 298.78 357.81 299.67 364.39 303.5 364.38 302.6 357.81 298.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "366.71 302.61 366.71 303.5 384.19 293.41 384.18 292.52 366.71 302.61"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M364.38,302.6v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-292"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M364.38,302.6v.89c.24.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M365.2,302.86v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M357.81,297.43c-.64.37-.65.97,0,1.35l6.58,3.82c.64.37,1.68.37,2.33,0l17.47-10.09c.64-.37.64-.98,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-17.47,10.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M362.97,305.26v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M362.48,305.05v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M313.92,323.17v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M313.92,323.17v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M314.1,323.6v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "314.4 323.84 314.4 324.73 320.98 328.56 320.98 327.66 314.4 323.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "323.3 327.67 323.31 328.56 362.48 305.94 362.48 305.05 323.3 327.67"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M320.98,327.66v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M320.98,327.66v.89c.24.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M321.8,327.92v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M314.41,322.5c-.64.37-.65.97,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l39.18-22.62c.64-.37.64-.98,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-39.18,22.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M303.07,329.44v.89c0,.24.16.48.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-260"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M303.07,329.44v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M303.24,329.86v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M319.56,330.32v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-167"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M319.08,330.11v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "303.55 330.11 303.55 331 310.13 334.82 310.13 333.93 303.55 330.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "312.45 333.93 312.45 334.82 319.08 331 319.08 330.11 312.45 333.93"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M310.13,333.93v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-203"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M310.13,333.93v.89c.24.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M310.95,334.19v.89c.53.06,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M303.55,328.76c-.64.37-.65.97,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l6.62-3.82c.64-.37.64-.98,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-6.62,3.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M292.67,333.55v-.89c0,.24-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-259"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M292.18,333.34v.89c.33-.19.49-.43.49-.68v-.89c0,.24-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M270.76,335.8v.89c0,.24.16.48.48.67v-.89c-.32-.18-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-251"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M270.76,335.8v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M270.93,336.23v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.15-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "271.23 336.47 271.24 337.36 277.82 341.19 277.81 340.29 271.23 336.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "280.14 340.29 280.14 341.19 292.19 334.23 292.18 333.34 280.14 340.29"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M277.81,340.29v.89c.64.37,1.68.37,2.32,0v-.89c-.65.37-1.68.37-2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-159"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M277.81,340.29v.89c.23.14.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M278.63,340.55v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M271.24,335.12c-.64.37-.65.97,0,1.34l6.58,3.82c.64.37,1.68.37,2.32,0l12.05-6.96c.64-.37.65-.97,0-1.34l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-12.05,6.96Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M308.71,336.59v-.89c0,.25-.16.49-.49.68v.89c.33-.19.49-.43.49-.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-218"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M308.22,336.37v.89c.33-.19.49-.43.49-.68v-.89c0,.25-.16.49-.49.68h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M281.37,341.97v.89c0,.24.16.49.48.67v-.89c-.32-.19-.48-.43-.48-.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-273"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M281.37,341.97v.89c0,.15.06.29.18.43v-.89c-.12-.13-.18-.28-.18-.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M281.54,342.39v.89c.08.09.18.17.31.24v-.89c-.13-.07-.23-.16-.31-.24h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "281.85 342.64 281.85 343.53 288.43 347.35 288.42 346.46 281.85 342.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "290.75 346.46 290.75 347.35 308.23 337.26 308.22 336.37 290.75 346.46"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M288.42,346.46v.89c.64.37,1.68.37,2.33,0v-.89c-.65.37-1.69.37-2.33,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M288.42,346.46v.89c.24.13.52.22.82.26v-.89c-.3-.04-.59-.12-.82-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M289.24,346.72v.89c.53.07,1.1-.02,1.51-.26v-.89c-.41.24-.98.32-1.51.26h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M281.85,341.29c-.64.37-.65.97,0,1.35l6.58,3.82c.64.37,1.68.37,2.32,0l17.47-10.09c.64-.37.64-.97,0-1.35l-6.58-3.82c-.64-.37-1.68-.37-2.32,0l-17.48,10.09Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M418.5,317.17c-.03.12-.07.23-.13.34-.06.11-.11.22-.19.33-.26.4-.67.77-1.23,1.09l-36.65,21.28c-2.15,1.24-5.62,1.24-7.76,0l-20.18-11.64c-.55-.32-.97-.7-1.22-1.09-.08-.11-.14-.22-.2-.34-.05-.1-.09-.22-.13-.33-.26-.97.26-1.99,1.54-2.73l36.65-21.3c2.15-1.22,5.62-1.22,7.75,0l20.19,11.66c1.28.74,1.79,1.76,1.54,2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M418.37,317.51c-.06.11-.11.22-.19.33-.26.4-.67.77-1.23,1.09l-36.65,21.28c-2.15,1.24-5.62,1.24-7.76,0l-20.18-11.64c-.55-.32-.97-.7-1.22-1.09-.08-.11-.14-.22-.2-.34.24-.52.7-1.01,1.41-1.43l36.65-21.3c2.15-1.23,5.62-1.23,7.75,0l20.19,11.66c.71.41,1.18.91,1.41,1.43Z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "80.37 306.7 80.36 261.09 94.92 252.69 94.92 203.07 95.63 203.07 95.63 253.1 81.08 261.5 81.08 306.7 80.37 306.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "126.96 280.21 126.25 280.21 126.25 235.43 111.69 243.83 111.69 193.39 112.41 193.39 112.41 242.59 126.96 234.19 126.96 280.21"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 103.48,
    y: 197.93,
    width: 0.71,
    height: 94.04
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "91.59 235.05 95.15 228.9 98.7 230.95 95.15 240.59 91.59 235.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "100.26 270.65 103.81 264.5 107.36 266.55 103.81 276.19 100.26 270.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "123.01 246 126.56 239.85 130.11 241.9 126.56 251.54 123.01 246"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "80.57 285.97 70.4 280.18 70.39 261.28 71.11 261.28 71.11 279.77 80.92 285.35 80.57 285.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M67.55,263.12c0,2.03,1.43,2.84,3.2,1.82,1.77-1.02,3.2-3.49,3.2-5.52s-1.43-2.84-3.2-1.82c-1.77,1.02-3.2,3.49-3.2,5.52Z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "70.7 208.16 128.65 174.48 87.59 150.78 29.64 184.45 70.7 208.16"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M71.96,208.28l57.95-33.68c-.32.19-.77.16-1.26-.12l-57.95,33.68c.49.28.94.31,1.26.12Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-242"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M71.96,208.28l57.95-33.68c-.32.19-.77.16-1.26-.12l-57.95,33.68c.49.28.94.31,1.26.12h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M72.58,209.35l57.95-33.68c.48-.28.77-.86.77-1.7l-57.95,33.68c0,.83-.3,1.42-.77,1.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-133"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M72.58,209.35l57.95-33.68c.48-.28.77-.86.77-1.7l-57.95,33.68c0,.83-.3,1.42-.77,1.7h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "73.35 207.65 131.3 173.98 130.43 173.47 72.48 207.15 73.35 207.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "70.7 208.16 29.64 184.45 29.63 185.46 70.69 209.17 70.7 208.16"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "73.04 207.58 33.35 184.66 33.38 177.89 73.04 200.79 73.04 207.58"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "73.35 207.65 131.3 173.98 131.31 170.25 73.36 203.93 73.35 207.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "70.72 199.35 128.67 165.68 87.61 141.97 29.66 175.65 70.72 199.35"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M73.36,203.93l57.95-33.68c0-1.68-1.18-3.73-2.64-4.57l-57.95,33.68c1.46.84,2.64,2.89,2.64,4.57h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M29.66,175.65v1s41.06,23.71,41.06,23.71c.98.57,1.77,1.94,1.77,3.06v3.73s.86.5.86.5v-3.73c.02-1.68-1.17-3.73-2.63-4.57l-41.06-23.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M70.69,209.17c1.46.84,2.65.16,2.66-1.51l-.87-.5c0,1.12-.8,1.58-1.78,1.01v1.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-193"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M24.78,169.98l57.95-33.68c-.98-.56-1.77-1.94-1.77-3.06l-57.95,33.68c0,1.12.79,2.5,1.77,3.06h0Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "23.02 166.92 80.97 133.25 80.98 129.52 23.03 163.19 23.02 166.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M23.03,163.18l57.95-33.68c0-.56.2-.95.52-1.14l-57.95,33.68c-.32.18-.52.58-.52,1.13h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "23.03 163.19 80.98 129.52 80.1 129.01 22.15 162.69 23.03 163.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "65.84 193.69 123.79 160.01 82.73 136.31 24.78 169.98 65.84 193.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "65.84 194.7 123.79 161.02 123.79 160.01 65.84 193.69 65.84 194.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M22.15,162.69v3.73c-.02,1.68,1.17,3.73,2.63,4.57l41.06,23.71v-1.01s-41.06-23.71-41.06-23.71c-.98-.56-1.77-1.94-1.77-3.06v-3.73s-.87-.51-.87-.51Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M80.42,129.3l-55.05,31.99c.36-.21.86-.18,1.41.14l55.05-31.99c-.55-.32-1.05-.35-1.41-.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-205"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M26.78,161.43l55.05-31.99c-.55-.32-1.05-.35-1.41-.14l-55.05,31.99c.36-.21.86-.18,1.41.14h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "65.9 191.91 120.96 159.91 120.98 152.04 65.92 184.03 65.9 191.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "65.92 184.03 120.98 152.04 81.83 129.44 26.78 161.43 65.92 184.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M26.78,161.43c-1.09-.63-1.98-.12-1.98,1.13v3.33c-.01,1.25.87,2.78,1.96,3.41l39.15,22.6.02-7.88-39.15-22.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M80.88,127.3l-57.95,33.68c.48-.28,1.15-.24,1.88.18l57.95-33.68c-.73-.42-1.4-.46-1.88-.18Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-293"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M24.81,161.16l57.95-33.68c-.73-.42-1.4-.46-1.88-.18l-57.95,33.68c.48-.28,1.15-.24,1.88.18h0Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "65.87 185.87 123.82 152.2 123.82 151.19 65.87 184.87 65.87 185.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "65.87 184.87 123.82 151.19 82.76 127.48 24.81 161.16 65.87 184.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M24.81,161.16c-1.46-.84-2.65-.16-2.66,1.51l.88.51c0-1.12.8-1.58,1.78-1.01l41.06,23.71v-1.01s-41.06-23.71-41.06-23.71Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "75.84 187.86 133.79 154.19 92.73 130.48 34.78 164.16 75.84 187.86"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M77.1,187.99l57.95-33.68c-.32.19-.77.16-1.26-.12l-57.95,33.68c.49.28.94.31,1.26.12Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-127"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M77.1,187.99l57.95-33.68c-.32.19-.77.16-1.26-.12l-57.95,33.68c.49.28.94.31,1.26.12h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M77.72,189.05l57.95-33.68c.48-.28.77-.86.77-1.7l-57.95,33.68c0,.83-.3,1.42-.77,1.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-152"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M77.72,189.05l57.95-33.68c.48-.28.77-.86.77-1.7l-57.95,33.68c0,.83-.3,1.42-.77,1.7h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "78.49 187.36 136.44 153.68 135.57 153.17 77.62 186.85 78.49 187.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "75.84 187.86 34.78 164.16 34.78 165.16 75.83 188.87 75.84 187.86"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "78.18 187.28 38.49 164.36 38.52 154.42 78.18 177.32 78.18 187.28"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "78.49 187.36 136.44 153.68 136.45 146.78 78.5 180.46 78.49 187.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "133.81 142.21 75.86 175.88 71.03 173.09 52.83 162.59 34.8 152.18 92.75 118.5 133.81 142.21"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-308"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M78.5,180.46l57.95-33.68c0-1.68-1.18-3.73-2.64-4.57l-57.95,33.68c1.46.84,2.64,2.89,2.64,4.57h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M34.8,152.18v1s41.06,23.71,41.06,23.71c.98.56,1.77,1.94,1.77,3.06v6.9s.86.5.86.5v-6.9c.02-1.68-1.17-3.73-2.63-4.57l-41.06-23.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M75.83,188.87c1.46.84,2.65.16,2.66-1.51l-.87-.5c0,1.12-.8,1.58-1.78,1.01v1.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-163"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M24.49,148.41l57.95-33.68c-.98-.56-1.77-1.94-1.77-3.06l-57.95,33.68c0,1.12.79,2.5,1.77,3.06h0Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "22.72 145.35 80.67 111.68 80.68 107.94 22.73 141.62 22.72 145.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M22.73,141.61l57.95-33.68c0-.56.2-.95.52-1.14l-57.95,33.68c-.32.18-.52.58-.52,1.13h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "22.73 141.62 80.68 107.94 79.8 107.44 21.85 141.12 22.73 141.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "65.55 172.12 123.5 138.44 82.44 114.73 24.49 148.41 65.55 172.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "65.54 173.12 123.49 139.45 123.5 138.44 65.55 172.12 65.54 173.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M21.85,141.12v3.73c-.02,1.68,1.17,3.73,2.63,4.57l41.06,23.71v-1.01s-41.06-23.71-41.06-23.71c-.98-.56-1.77-1.94-1.77-3.06v-3.73s-.87-.51-.87-.51Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M80.12,107.73l-55.05,31.99c.36-.21.86-.18,1.41.14l55.05-31.99c-.55-.32-1.05-.35-1.41-.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-196"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M26.48,139.86l55.05-31.99c-.55-.32-1.05-.35-1.41-.14l-55.05,31.99c.36-.21.86-.18,1.41.14h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "65.6 170.34 120.66 138.34 120.68 130.47 65.63 162.46 65.6 170.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "65.63 162.46 120.68 130.47 81.53 107.86 26.48 139.86 65.63 162.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M26.48,139.86c-1.09-.63-1.98-.12-1.98,1.13v3.33c-.01,1.25.87,2.78,1.96,3.41l39.15,22.6.02-7.88-39.15-22.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M80.58,105.73l-57.95,33.68c.48-.28,1.15-.24,1.88.18l57.95-33.68c-.73-.42-1.4-.46-1.88-.18Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-200"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M24.51,139.59l57.95-33.68c-.73-.42-1.4-.46-1.88-.18l-57.95,33.68c.48-.28,1.15-.24,1.88.18h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "65.57 164.3 123.52 130.63 123.52 129.62 65.57 163.3 65.57 164.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "123.52 129.62 65.57 163.3 24.51 139.59 82.46 105.91 104.74 118.78 122.94 129.28 123.52 129.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M24.51,139.59c-1.46-.84-2.65-.16-2.66,1.51l.88.51c0-1.12.8-1.58,1.78-1.01l41.06,23.71v-1.01s-41.06-23.71-41.06-23.71Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "142.31 82.01 96.35 108.54 96.36 199.71 156.09 165.22 156.09 89.97 142.31 82.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "142.31 97.92 156.09 89.97 142.31 82.01 142.31 97.92"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M114.24,104.45l-13.36,7.72-.14,6.23.76-.44.43-2.34c.58-2.37,1.56-3.72,2.95-4.65l1.46-.84v16.82l-1.19.68h0c-.74.43-1.24.61-1.24,1.53l7.3-4.22c0-.46-.14-.64-.43-.53-.09.03-.18.07-.27.12l-1.84,1.06v-16.82s1.57-.91,1.57-.91c1.46-.84,2.43-.69,2.92,1.07,0,.08,0,.14.03.17l.43,1.84.76-.44-.14-6.08Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "152.07 111.65 100.84 141.22 100.84 137.4 152.07 107.83 152.07 111.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "152.07 118.7 100.84 148.26 100.84 144.44 152.07 114.87 152.07 118.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "152.07 125.74 100.84 155.31 100.84 151.48 152.07 121.92 152.07 125.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "129.94 145.56 100.84 162.35 100.84 158.53 129.94 141.74 129.94 145.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "129.94 173.72 100.84 190.51 100.84 186.69 129.94 169.9 129.94 173.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "152.07 139.83 100.84 169.39 100.84 165.57 152.07 136.01 152.07 139.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "152.07 146.87 100.84 176.44 100.84 172.62 152.07 143.05 152.07 146.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "144.69 158.18 100.84 183.48 100.84 179.66 144.69 154.35 144.69 158.18"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M91.73,155.8c-.4,0-.8-.09-1.08-.26-.02,0-.04-.02-.2-.04-.16-.01-.46,0-.82.06-.72.12-1.7.44-2.55.94-.65.38-1.12.78-1.41,1.14-.23.29-.32.55-.32.72l-.14,53.52c0-.16.09-.42.32-.72.28-.36.76-.77,1.41-1.14.85-.5,1.82-.82,2.55-.94.36-.06.66-.07.82-.06.17.02.19.04.2.04.29.16.68.26,1.08.26s.8-.1,1.09-.26l.14-53.52c-.28.16-.68.26-1.09.26Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M92.82,155.54c-.21.12-.48.2-.77.24l-.14,53.52c.29-.04.56-.12.77-.24l30.22-17.56.14-53.52-30.22,17.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M85.76,157.53l-.14,53.52s-.06.07-.09.11c-.23.29-.32.55-.32.72l.14-53.52c0-.16.09-.42.32-.72.03-.04.06-.07.09-.11h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-187"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M82.45,159.04l-.14,53.52c-.06-.12-.11-.24-.13-.35-.03-.12-.04-.23-.04-.34l.14-53.52c0,.12.01.23.04.35.03.12.07.24.13.35h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "55.22 177.39 55.07 230.91 52.9 229.66 53.04 176.13 55.22 177.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.03,137.98l-30.22,17.56c-.28.16-.68.26-1.09.26s-.8-.09-1.08-.26c-.02,0-.04-.02-.2-.04-.16-.01-.46,0-.82.06-.72.12-1.7.44-2.55.94-.65.38-1.12.78-1.41,1.14-.29.36-.35.67-.31.81.02.1.06.11.07.12.29.16.46.39.45.63,0,.24-.16.46-.44.63l-29.14,16.93-1.08.63-2.18-1.26,29.41-17.09c-.06-.12-.11-.24-.13-.35-.09-.4-.01-.8.18-1.2.39-.78,1.22-1.56,2.4-2.25.88-.51,1.86-.91,2.86-1.18,1-.26,2.03-.41,3.08-.33.2.02.41.04.61.08l29.41-17.09,2.18,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M85.71,159.61c-.07.08-.16.16-.28.22l-29.14,16.93-1.08.63-.14,53.52,1.08-.63,29.14-16.93c.11-.06.2-.14.28-.22.11-.12.17-.26.17-.41l.14-53.52c0,.14-.06.28-.17.41Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "62.74 233.23 56.26 229.46 56.12 178.59 62.6 182.36 62.74 233.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M62.6,182.36l-6.48-3.77,65.2-37.64,6.48,3.77s-9.74,7.19-17.18,11.31c-9.18,5.09-15.36,7.47-15.36,7.47,0,0-5.26,4.32-16.84,11.52-7.35,4.57-15.83,7.34-15.83,7.34Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "62.6 182.36 62.74 233.23 95.27 214.44 95.27 163.5 62.6 182.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "127.8 144.71 95.27 163.5 95.27 214.44 127.94 195.58 127.8 144.71"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M65.37,236.36s9.89-5.23,17.21-12.78c6.67-6.87,8.1-11.13,8.1-11.13l4.58-48.95s-5.61,8.2-14.51,14.22c-7.79,5.26-15.38,7.57-15.38,7.57v51.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M69.96,238.47s9.89-5.23,17.21-12.78c6.67-6.87,8.1-11.13,8.1-11.13v-51.07s-1.9,5.72-9.8,13.25c-6.83,6.52-15.52,10.65-15.52,10.65v51.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M126.16,150.97c-2.66,3.07-6.5,6.9-10.63,9.03-7.68,3.96-20.27,3.5-20.27,3.5v51.24s8.25.77,18.99-4.73c4.43-2.27,8.85-6.19,11.9-9.22v-49.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M124.54,154.33c-2.38,2.75-5.82,6.17-9.51,8.08-6.87,3.54-18.13,3.28-18.13,3.28v45.7s7.38.69,17-4.24c3.96-2.03,7.92-5.54,10.65-8.25v-44.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M58.81,210.79c.14,1.48.2,2.97.25,4.45.06,1.48.07,2.97.08,4.45,0,1.48-.02,2.97-.08,4.45l-.09,2.23c-.05.74-.09,1.48-.16,2.23-.07-.74-.11-1.48-.16-2.23l-.09-2.23c-.06-1.48-.07-2.97-.08-4.45,0-1.48.02-2.97.08-4.45.05-1.48.12-2.97.25-4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M58.09,181.91c.14,1.53.2,3.07.25,4.6.06,1.53.07,3.07.08,4.6,0,1.53-.02,3.07-.08,4.6l-.09,2.3c-.05.77-.09,1.53-.16,2.3-.08-.77-.11-1.53-.16-2.3l-.09-2.3c-.06-1.53-.07-3.07-.08-4.6,0-1.53.02-3.07.08-4.6.05-1.53.12-3.07.25-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M60.75,192.32c.26,2.66.32,5.33.33,7.99,0,2.66-.07,5.33-.33,7.99-.26-2.66-.32-5.33-.33-7.99.01-2.66.07-5.33.33-7.99Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M85.56,180.02c-5.1,4.86-11.23,8.37-13.9,9.78v8.06c2.92-1.69,10-6.06,15.57-11.81,3.7-3.81,5.76-6.81,6.85-8.69v-8c-1.27,2.32-3.8,6.15-8.52,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M85.56,190.33c-5.1,4.86-11.23,8.37-13.9,9.78v1.99c2.92-1.69,10-6.06,15.57-11.81,3.7-3.81,5.76-6.81,6.85-8.69v-1.93c-1.27,2.32-3.8,6.15-8.52,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M85.56,193.95c-5.1,4.86-11.23,8.37-13.9,9.78v1.99c2.92-1.69,10-6.06,15.57-11.81,3.7-3.81,5.76-6.81,6.85-8.69v-1.93c-1.27,2.32-3.8,6.15-8.52,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M85.56,197.64c-5.1,4.86-11.23,8.37-13.9,9.78v1.99c2.92-1.69,10-6.06,15.57-11.81,3.7-3.81,5.76-6.81,6.85-8.69v-1.93c-1.27,2.32-3.8,6.15-8.52,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M85.56,201.29c-5.1,4.86-11.23,8.37-13.9,9.78v1.99c2.92-1.69,10-6.06,15.57-11.81,3.7-3.81,5.76-6.81,6.85-8.69v-1.93c-1.27,2.32-3.8,6.15-8.52,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M85.56,204.99c-5.1,4.86-11.23,8.37-13.9,9.78v1.99c2.92-1.69,10-6.06,15.57-11.81,3.7-3.81,5.76-6.81,6.85-8.69v-1.93c-1.27,2.32-3.8,6.15-8.52,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M85.56,208.63c-5.1,4.86-11.23,8.37-13.9,9.78v1.99c2.92-1.69,10-6.06,15.57-11.81,3.7-3.81,5.76-6.81,6.85-8.69v-1.93c-1.27,2.32-3.8,6.15-8.52,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M85.56,212.25c-5.1,4.86-11.23,8.37-13.9,9.78v1.99c2.92-1.69,10-6.06,15.57-11.81,3.7-3.81,5.76-6.81,6.85-8.69v-1.93c-1.27,2.32-3.8,6.15-8.52,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M85.56,215.95c-5.1,4.86-11.23,8.37-13.9,9.78v1.99c2.92-1.69,10-6.06,15.57-11.81,3.7-3.81,5.76-6.81,6.85-8.69v-1.93c-1.27,2.32-3.8,6.15-8.52,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M85.56,219.59c-5.1,4.86-11.23,8.37-13.9,9.78v1.99c2.92-1.69,10-6.06,15.57-11.81,3.7-3.81,5.76-6.81,6.85-8.69v-1.93c-1.27,2.32-3.8,6.15-8.52,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M85.56,223.29c-5.1,4.86-11.23,8.37-13.9,9.78v1.99c2.92-1.69,10-6.06,15.57-11.81,3.7-3.81,5.76-6.81,6.85-8.69v-1.93c-1.27,2.32-3.8,6.15-8.52,10.66Z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "205.64 399.13 129.49 443.39 53.6 399.58 129.76 355.32 205.64 399.13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "129.76 355.32 129.49 443.39 53.6 399.58 53.88 311.51 129.76 355.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "57.75 397.19 57.99 318.66 125.62 357.7 125.37 436.23 57.75 397.19"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "205.92 311.06 205.64 399.13 129.49 443.39 129.76 355.32 205.92 311.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "133.89 357.7 201.76 318.26 201.51 396.74 133.65 436.18 133.89 357.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "205.92 311.06 129.76 355.32 53.88 311.51 130.03 267.25 205.92 311.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "175.47 311.1 170.65 313.9 129.74 337.68 89.14 314.23 84.33 311.46 130.05 284.89 175.47 311.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "170.65 313.9 129.74 337.68 89.14 314.23 130.05 290.46 170.65 313.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M135.75,317.66l-7.18,4.15,2.81,3.07-5.6,3.23-13.76-17.16,4.93-2.84,29.77,7.91-5.63,3.25-5.33-1.61ZM125.78,318.75l4.67-2.7-9.88-3,5.21,5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M153.88,311.88l-5.22,3.02-21.74-12.55,5.22-3.02,21.74,12.55Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "136.42 358.83 134.87 359.73 134.87 357.93 136.42 357.03 136.42 358.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "140.19 356.65 138.63 357.55 138.63 355.75 140.19 354.85 140.19 356.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "143.96 354.48 142.4 355.38 142.4 353.58 143.96 352.68 143.96 354.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "147.73 352.3 146.17 353.2 146.17 351.4 147.73 350.5 147.73 352.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "151.5 350.13 149.94 351.03 149.94 349.23 151.5 348.33 151.5 350.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "155.26 347.95 153.71 348.85 153.71 347.05 155.26 346.15 155.26 347.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "159.03 345.78 157.47 346.68 157.47 344.88 159.03 343.98 159.03 345.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "162.8 343.6 161.24 344.5 161.24 342.7 162.8 341.8 162.8 343.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "166.57 341.42 165.01 342.32 165.01 340.52 166.57 339.62 166.57 341.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "170.34 339.25 168.78 340.15 168.78 338.35 170.34 337.45 170.34 339.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "174.1 337.07 172.55 337.97 172.55 336.17 174.1 335.27 174.1 337.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "177.87 334.9 176.31 335.8 176.31 334 177.87 333.1 177.87 334.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "181.64 332.72 180.08 333.62 180.08 331.82 181.64 330.92 181.64 332.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "185.41 330.55 183.85 331.45 183.85 329.65 185.41 328.75 185.41 330.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.18 328.37 187.62 329.27 187.62 327.47 189.18 326.57 189.18 328.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "192.94 326.2 191.39 327.1 191.39 325.3 192.94 324.4 192.94 326.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "196.71 324.02 195.15 324.92 195.15 323.12 196.71 322.22 196.71 324.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "200.48 321.85 198.92 322.75 198.92 320.95 200.48 320.05 200.48 321.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "136.42 363.49 134.87 364.39 134.87 362.59 136.42 361.69 136.42 363.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "140.19 361.32 138.63 362.22 138.63 360.42 140.19 359.52 140.19 361.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "143.96 359.14 142.4 360.04 142.4 358.24 143.96 357.34 143.96 359.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "147.73 356.97 146.17 357.87 146.17 356.07 147.73 355.17 147.73 356.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "151.5 354.79 149.94 355.69 149.94 353.89 151.5 352.99 151.5 354.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "155.26 352.61 153.71 353.52 153.71 351.71 155.26 350.82 155.26 352.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "159.03 350.44 157.47 351.34 157.47 349.54 159.03 348.64 159.03 350.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "162.8 348.26 161.24 349.16 161.24 347.36 162.8 346.46 162.8 348.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "166.57 346.09 165.01 346.99 165.01 345.19 166.57 344.29 166.57 346.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "170.34 343.91 168.78 344.81 168.78 343.01 170.34 342.11 170.34 343.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "174.1 341.74 172.55 342.64 172.55 340.84 174.1 339.94 174.1 341.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "177.87 339.56 176.31 340.46 176.31 338.66 177.87 337.76 177.87 339.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "181.64 337.39 180.08 338.29 180.08 336.49 181.64 335.59 181.64 337.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "185.41 335.21 183.85 336.11 183.85 334.31 185.41 333.41 185.41 335.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.18 333.04 187.62 333.94 187.62 332.14 189.18 331.24 189.18 333.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "192.94 330.86 191.39 331.76 191.39 329.96 192.94 329.06 192.94 330.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "196.71 328.69 195.15 329.58 195.15 327.79 196.71 326.89 196.71 328.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "200.48 326.51 198.92 327.41 198.92 325.61 200.48 324.71 200.48 326.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "136.42 368.16 134.87 369.06 134.87 367.26 136.42 366.36 136.42 368.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "140.19 365.98 138.63 366.88 138.63 365.08 140.19 364.18 140.19 365.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "143.96 363.81 142.4 364.71 142.4 362.91 143.96 362.01 143.96 363.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "147.73 361.63 146.17 362.53 146.17 360.73 147.73 359.83 147.73 361.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "151.5 359.46 149.94 360.35 149.94 358.55 151.5 357.65 151.5 359.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "155.26 357.28 153.71 358.18 153.71 356.38 155.26 355.48 155.26 357.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "159.03 355.1 157.47 356 157.47 354.2 159.03 353.3 159.03 355.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "162.8 352.93 161.24 353.83 161.24 352.03 162.8 351.13 162.8 352.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "166.57 350.75 165.01 351.65 165.01 349.85 166.57 348.95 166.57 350.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "170.34 348.58 168.78 349.48 168.78 347.68 170.34 346.78 170.34 348.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "174.1 346.4 172.55 347.3 172.55 345.5 174.1 344.6 174.1 346.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "177.87 344.23 176.31 345.13 176.31 343.33 177.87 342.43 177.87 344.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "181.64 342.05 180.08 342.95 180.08 341.15 181.64 340.25 181.64 342.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "185.41 339.88 183.85 340.78 183.85 338.98 185.41 338.08 185.41 339.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "189.18 337.7 187.62 338.6 187.62 336.8 189.18 335.9 189.18 337.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "192.94 335.53 191.39 336.42 191.39 334.62 192.94 333.73 192.94 335.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "196.71 333.35 195.15 334.25 195.15 332.45 196.71 331.55 196.71 333.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "200.48 331.17 198.92 332.07 198.92 330.27 200.48 329.37 200.48 331.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "136.42 372.82 134.87 373.72 134.87 371.92 136.42 371.02 136.42 372.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "140.19 370.65 138.63 371.55 138.63 369.75 140.19 368.85 140.19 370.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "143.96 368.47 142.4 369.37 142.4 367.57 143.96 366.67 143.96 368.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "147.73 366.29 146.17 367.19 146.17 365.39 147.73 364.49 147.73 366.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "151.5 364.12 149.94 365.02 149.94 363.22 151.5 362.32 151.5 364.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "155.26 361.94 153.71 362.84 153.71 361.04 155.26 360.14 155.26 361.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "159.03 359.77 157.47 360.67 157.47 358.87 159.03 357.97 159.03 359.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "162.8 357.59 161.24 358.49 161.24 356.69 162.8 355.79 162.8 357.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "166.57 355.42 165.01 356.32 165.01 354.52 166.57 353.62 166.57 355.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "170.34 353.24 168.78 354.14 168.78 352.34 170.34 351.44 170.34 353.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "174.1 351.07 172.55 351.97 172.55 350.17 174.1 349.27 174.1 351.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "177.87 348.89 176.31 349.79 176.31 347.99 177.87 347.09 177.87 348.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "181.64 346.72 180.08 347.62 180.08 345.82 181.64 344.92 181.64 346.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "185.41 344.54 183.85 345.44 183.85 343.64 185.41 342.74 185.41 344.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "189.18 342.36 187.62 343.26 187.62 341.46 189.18 340.56 189.18 342.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "192.94 340.19 191.39 341.09 191.39 339.29 192.94 338.39 192.94 340.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "196.71 338.01 195.15 338.91 195.15 337.11 196.71 336.21 196.71 338.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "200.48 335.84 198.92 336.74 198.92 334.94 200.48 334.04 200.48 335.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "136.42 377.49 134.87 378.38 134.87 376.59 136.42 375.68 136.42 377.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "140.19 375.31 138.63 376.21 138.63 374.41 140.19 373.51 140.19 375.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "143.96 373.13 142.4 374.03 142.4 372.23 143.96 371.33 143.96 373.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "147.73 370.96 146.17 371.86 146.17 370.06 147.73 369.16 147.73 370.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "151.5 368.78 149.94 369.68 149.94 367.88 151.5 366.98 151.5 368.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "155.26 366.61 153.71 367.51 153.71 365.71 155.26 364.81 155.26 366.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "159.03 364.43 157.47 365.33 157.47 363.53 159.03 362.63 159.03 364.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "162.8 362.26 161.24 363.16 161.24 361.36 162.8 360.46 162.8 362.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "166.57 360.08 165.01 360.98 165.01 359.18 166.57 358.28 166.57 360.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "170.34 357.91 168.78 358.81 168.78 357.01 170.34 356.11 170.34 357.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "174.1 355.73 172.55 356.63 172.55 354.83 174.1 353.93 174.1 355.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "177.87 353.56 176.31 354.46 176.31 352.65 177.87 351.76 177.87 353.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "181.64 351.38 180.08 352.28 180.08 350.48 181.64 349.58 181.64 351.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "185.41 349.2 183.85 350.1 183.85 348.3 185.41 347.4 185.41 349.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "189.18 347.03 187.62 347.93 187.62 346.13 189.18 345.23 189.18 347.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "192.94 344.85 191.39 345.75 191.39 343.95 192.94 343.05 192.94 344.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "196.71 342.68 195.15 343.58 195.15 341.78 196.71 340.88 196.71 342.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "200.48 340.5 198.92 341.4 198.92 339.6 200.48 338.7 200.48 340.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "136.42 382.15 134.87 383.05 134.87 381.25 136.42 380.35 136.42 382.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "140.19 379.97 138.63 380.87 138.63 379.07 140.19 378.17 140.19 379.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "143.96 377.8 142.4 378.7 142.4 376.9 143.96 376 143.96 377.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "147.73 375.62 146.17 376.52 146.17 374.72 147.73 373.82 147.73 375.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "151.5 373.45 149.94 374.35 149.94 372.55 151.5 371.65 151.5 373.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "155.26 371.27 153.71 372.17 153.71 370.37 155.26 369.47 155.26 371.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "159.03 369.1 157.47 370 157.47 368.2 159.03 367.3 159.03 369.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "162.8 366.92 161.24 367.82 161.24 366.02 162.8 365.12 162.8 366.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "166.57 364.75 165.01 365.65 165.01 363.85 166.57 362.95 166.57 364.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "170.34 362.57 168.78 363.47 168.78 361.67 170.34 360.77 170.34 362.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "174.1 360.4 172.55 361.29 172.55 359.49 174.1 358.59 174.1 360.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "177.87 358.22 176.31 359.12 176.31 357.32 177.87 356.42 177.87 358.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "181.64 356.04 180.08 356.94 180.08 355.14 181.64 354.24 181.64 356.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "185.41 353.87 183.85 354.77 183.85 352.97 185.41 352.07 185.41 353.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.18 351.69 187.62 352.59 187.62 350.79 189.18 349.89 189.18 351.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "192.94 349.52 191.39 350.42 191.39 348.62 192.94 347.72 192.94 349.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "196.71 347.34 195.15 348.24 195.15 346.44 196.71 345.54 196.71 347.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "200.48 345.17 198.92 346.07 198.92 344.27 200.48 343.37 200.48 345.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "136.42 386.81 134.87 387.71 134.87 385.91 136.42 385.01 136.42 386.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "140.19 384.64 138.63 385.54 138.63 383.74 140.19 382.84 140.19 384.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "143.96 382.46 142.4 383.36 142.4 381.56 143.96 380.66 143.96 382.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "147.73 380.29 146.17 381.19 146.17 379.39 147.73 378.49 147.73 380.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "151.5 378.11 149.94 379.01 149.94 377.21 151.5 376.31 151.5 378.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "155.26 375.94 153.71 376.84 153.71 375.04 155.26 374.14 155.26 375.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "159.03 373.76 157.47 374.66 157.47 372.86 159.03 371.96 159.03 373.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "162.8 371.59 161.24 372.49 161.24 370.69 162.8 369.79 162.8 371.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "166.57 369.41 165.01 370.31 165.01 368.51 166.57 367.61 166.57 369.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "170.34 367.23 168.78 368.14 168.78 366.33 170.34 365.43 170.34 367.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "174.1 365.06 172.55 365.96 172.55 364.16 174.1 363.26 174.1 365.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "177.87 362.88 176.31 363.78 176.31 361.98 177.87 361.08 177.87 362.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "181.64 360.71 180.08 361.61 180.08 359.81 181.64 358.91 181.64 360.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "185.41 358.53 183.85 359.43 183.85 357.63 185.41 356.73 185.41 358.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.18 356.36 187.62 357.26 187.62 355.46 189.18 354.56 189.18 356.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "192.94 354.18 191.39 355.08 191.39 353.28 192.94 352.38 192.94 354.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "196.71 352.01 195.15 352.91 195.15 351.11 196.71 350.21 196.71 352.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "200.48 349.83 198.92 350.73 198.92 348.93 200.48 348.03 200.48 349.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "136.42 391.48 134.87 392.38 134.87 390.58 136.42 389.68 136.42 391.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "140.19 389.3 138.63 390.2 138.63 388.4 140.19 387.5 140.19 389.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "143.96 387.13 142.4 388.03 142.4 386.23 143.96 385.33 143.96 387.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "147.73 384.95 146.17 385.85 146.17 384.05 147.73 383.15 147.73 384.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "151.5 382.78 149.94 383.68 149.94 381.88 151.5 380.98 151.5 382.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "155.26 380.6 153.71 381.5 153.71 379.7 155.26 378.8 155.26 380.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "159.03 378.43 157.47 379.33 157.47 377.53 159.03 376.62 159.03 378.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "162.8 376.25 161.24 377.15 161.24 375.35 162.8 374.45 162.8 376.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "166.57 374.07 165.01 374.97 165.01 373.17 166.57 372.27 166.57 374.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "170.34 371.9 168.78 372.8 168.78 371 170.34 370.1 170.34 371.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "174.1 369.72 172.55 370.62 172.55 368.82 174.1 367.92 174.1 369.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "177.87 367.55 176.31 368.45 176.31 366.65 177.87 365.75 177.87 367.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "181.64 365.37 180.08 366.27 180.08 364.47 181.64 363.57 181.64 365.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "185.41 363.2 183.85 364.1 183.85 362.3 185.41 361.4 185.41 363.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.18 361.02 187.62 361.92 187.62 360.12 189.18 359.22 189.18 361.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "192.95 358.85 191.39 359.75 191.39 357.95 192.95 357.05 192.95 358.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "196.71 356.67 195.15 357.57 195.15 355.77 196.71 354.87 196.71 356.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "200.48 354.5 198.92 355.4 198.92 353.6 200.48 352.7 200.48 354.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "136.42 396.14 134.87 397.04 134.87 395.24 136.42 394.34 136.42 396.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "140.19 393.97 138.63 394.87 138.63 393.07 140.19 392.17 140.19 393.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "143.96 391.79 142.4 392.69 142.4 390.89 143.96 389.99 143.96 391.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "147.73 389.62 146.17 390.52 146.17 388.72 147.73 387.82 147.73 389.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "151.5 387.44 149.94 388.34 149.94 386.54 151.5 385.64 151.5 387.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "155.26 385.26 153.71 386.17 153.71 384.37 155.26 383.46 155.26 385.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "159.03 383.09 157.47 383.99 157.47 382.19 159.03 381.29 159.03 383.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "162.8 380.91 161.24 381.81 161.24 380.01 162.8 379.11 162.8 380.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "166.57 378.74 165.01 379.64 165.01 377.84 166.57 376.94 166.57 378.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "170.34 376.56 168.78 377.46 168.78 375.66 170.34 374.76 170.34 376.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "174.1 374.39 172.55 375.29 172.55 373.49 174.1 372.59 174.1 374.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "177.87 372.21 176.31 373.11 176.31 371.31 177.87 370.41 177.87 372.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "181.64 370.04 180.08 370.94 180.08 369.14 181.64 368.24 181.64 370.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "185.41 367.86 183.85 368.76 183.85 366.96 185.41 366.06 185.41 367.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "189.18 365.69 187.62 366.59 187.62 364.79 189.18 363.89 189.18 365.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "192.95 363.51 191.39 364.41 191.39 362.61 192.95 361.71 192.95 363.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "196.71 361.34 195.15 362.24 195.15 360.43 196.71 359.53 196.71 361.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "200.48 359.16 198.92 360.06 198.92 358.26 200.48 357.36 200.48 359.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "136.42 400.81 134.87 401.71 134.87 399.91 136.42 399.01 136.42 400.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "140.19 398.63 138.63 399.53 138.63 397.73 140.19 396.83 140.19 398.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "143.96 396.45 142.4 397.36 142.4 395.56 143.96 394.66 143.96 396.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "147.73 394.28 146.17 395.18 146.17 393.38 147.73 392.48 147.73 394.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "151.5 392.1 149.94 393 149.94 391.2 151.5 390.3 151.5 392.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "155.26 389.93 153.71 390.83 153.71 389.03 155.26 388.13 155.26 389.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "159.03 387.75 157.47 388.65 157.47 386.85 159.03 385.95 159.03 387.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "162.8 385.58 161.24 386.48 161.24 384.68 162.8 383.78 162.8 385.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "166.57 383.4 165.01 384.3 165.01 382.5 166.57 381.6 166.57 383.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "170.34 381.23 168.78 382.13 168.78 380.33 170.34 379.43 170.34 381.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "174.1 379.05 172.55 379.95 172.55 378.15 174.1 377.25 174.1 379.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "177.87 376.88 176.31 377.78 176.31 375.98 177.87 375.08 177.87 376.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "181.64 374.7 180.08 375.6 180.08 373.8 181.64 372.9 181.64 374.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "185.41 372.53 183.85 373.43 183.85 371.63 185.41 370.73 185.41 372.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "189.18 370.35 187.62 371.25 187.62 369.45 189.18 368.55 189.18 370.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "192.95 368.17 191.39 369.08 191.39 367.27 192.95 366.38 192.95 368.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "196.71 366 195.15 366.9 195.15 365.1 196.71 364.2 196.71 366"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "200.48 363.82 198.92 364.72 198.92 362.92 200.48 362.02 200.48 363.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "136.42 405.47 134.87 406.37 134.87 404.57 136.42 403.67 136.42 405.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "140.19 403.29 138.63 404.19 138.63 402.4 140.19 401.49 140.19 403.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "143.96 401.12 142.4 402.02 142.4 400.22 143.96 399.32 143.96 401.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "147.73 398.94 146.17 399.84 146.17 398.04 147.73 397.14 147.73 398.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "151.5 396.77 149.94 397.67 149.94 395.87 151.5 394.97 151.5 396.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "155.26 394.59 153.71 395.49 153.71 393.69 155.26 392.79 155.26 394.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "159.03 392.42 157.47 393.32 157.47 391.52 159.03 390.62 159.03 392.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "162.8 390.24 161.24 391.14 161.24 389.34 162.8 388.44 162.8 390.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "166.57 388.07 165.01 388.97 165.01 387.17 166.57 386.27 166.57 388.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "170.34 385.89 168.78 386.79 168.78 384.99 170.34 384.09 170.34 385.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "174.1 383.72 172.55 384.62 172.55 382.82 174.1 381.92 174.1 383.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "177.87 381.54 176.31 382.44 176.31 380.64 177.87 379.74 177.87 381.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "181.64 379.37 180.08 380.27 180.08 378.47 181.64 377.57 181.64 379.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "185.41 377.19 183.85 378.09 183.85 376.29 185.41 375.39 185.41 377.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.18 375.02 187.62 375.91 187.62 374.11 189.18 373.21 189.18 375.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "192.95 372.84 191.39 373.74 191.39 371.94 192.95 371.04 192.95 372.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "196.71 370.66 195.15 371.56 195.15 369.76 196.71 368.86 196.71 370.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "200.48 368.49 198.92 369.39 198.92 367.59 200.48 366.69 200.48 368.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "136.42 410.13 134.87 411.03 134.87 409.23 136.42 408.34 136.42 410.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "140.19 407.96 138.63 408.86 138.63 407.06 140.19 406.16 140.19 407.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "143.96 405.78 142.4 406.68 142.4 404.88 143.96 403.98 143.96 405.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "147.73 403.61 146.17 404.51 146.17 402.71 147.73 401.81 147.73 403.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "151.5 401.43 149.94 402.33 149.94 400.53 151.5 399.63 151.5 401.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "155.26 399.26 153.71 400.16 153.71 398.36 155.26 397.46 155.26 399.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "159.03 397.08 157.47 397.98 157.47 396.18 159.03 395.28 159.03 397.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "162.8 394.91 161.24 395.81 161.24 394.01 162.8 393.11 162.8 394.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "166.57 392.73 165.01 393.63 165.01 391.83 166.57 390.93 166.57 392.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "170.34 390.56 168.78 391.46 168.78 389.66 170.34 388.76 170.34 390.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "174.11 388.38 172.55 389.28 172.55 387.48 174.11 386.58 174.11 388.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "177.87 386.21 176.31 387.1 176.31 385.31 177.87 384.4 177.87 386.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "181.64 384.03 180.08 384.93 180.08 383.13 181.64 382.23 181.64 384.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "185.41 381.85 183.85 382.75 183.85 380.95 185.41 380.05 185.41 381.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.18 379.68 187.62 380.58 187.62 378.78 189.18 377.88 189.18 379.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "192.95 377.5 191.39 378.4 191.39 376.6 192.95 375.7 192.95 377.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "196.71 375.33 195.16 376.23 195.15 374.43 196.71 373.53 196.71 375.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "200.48 373.15 198.92 374.05 198.92 372.25 200.48 371.35 200.48 373.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "136.42 414.8 134.87 415.7 134.87 413.9 136.42 413 136.42 414.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "140.19 412.62 138.63 413.52 138.63 411.72 140.19 410.82 140.19 412.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "143.96 410.45 142.4 411.35 142.4 409.55 143.96 408.65 143.96 410.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "147.73 408.27 146.17 409.17 146.17 407.37 147.73 406.47 147.73 408.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "151.5 406.1 149.94 407 149.94 405.2 151.5 404.3 151.5 406.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "155.26 403.92 153.71 404.82 153.71 403.02 155.26 402.12 155.26 403.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "159.03 401.75 157.47 402.65 157.47 400.85 159.03 399.95 159.03 401.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "162.8 399.57 161.24 400.47 161.24 398.67 162.8 397.77 162.8 399.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "166.57 397.4 165.01 398.3 165.01 396.5 166.57 395.6 166.57 397.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "170.34 395.22 168.78 396.12 168.78 394.32 170.34 393.42 170.34 395.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "174.11 393.04 172.55 393.94 172.55 392.14 174.11 391.24 174.11 393.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "177.87 390.87 176.31 391.77 176.31 389.97 177.87 389.07 177.87 390.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "181.64 388.69 180.08 389.59 180.08 387.79 181.64 386.89 181.64 388.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "185.41 386.52 183.85 387.42 183.85 385.62 185.41 384.72 185.41 386.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.18 384.34 187.62 385.24 187.62 383.44 189.18 382.54 189.18 384.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "192.95 382.17 191.39 383.07 191.39 381.27 192.95 380.37 192.95 382.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "196.71 379.99 195.16 380.89 195.16 379.09 196.71 378.19 196.71 379.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "200.48 377.82 198.92 378.72 198.92 376.92 200.48 376.02 200.48 377.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "136.42 418.71 134.87 419.61 134.87 417.81 136.42 416.91 136.42 418.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "140.19 416.53 138.63 417.43 138.63 415.63 140.19 414.73 140.19 416.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "143.96 414.36 142.4 415.26 142.4 413.46 143.96 412.56 143.96 414.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "147.73 412.18 146.17 413.08 146.17 411.28 147.73 410.38 147.73 412.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "151.5 410.01 149.94 410.91 149.94 409.11 151.5 408.21 151.5 410.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "155.26 407.83 153.71 408.73 153.71 406.93 155.26 406.03 155.26 407.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "159.03 405.66 157.47 406.56 157.47 404.76 159.03 403.86 159.03 405.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "162.8 403.48 161.24 404.38 161.24 402.58 162.8 401.68 162.8 403.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "166.57 401.31 165.01 402.2 165.01 400.4 166.57 399.5 166.57 401.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "170.34 399.13 168.78 400.03 168.78 398.23 170.34 397.33 170.34 399.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "174.1 396.95 172.55 397.85 172.55 396.05 174.1 395.15 174.1 396.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "177.87 394.78 176.31 395.68 176.31 393.88 177.87 392.98 177.87 394.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "181.64 392.6 180.08 393.5 180.08 391.7 181.64 390.8 181.64 392.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "185.41 390.43 183.85 391.33 183.85 389.53 185.41 388.63 185.41 390.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.18 388.25 187.62 389.15 187.62 387.35 189.18 386.45 189.18 388.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "192.94 386.08 191.39 386.98 191.39 385.18 192.94 384.28 192.94 386.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "196.71 383.9 195.15 384.8 195.15 383 196.71 382.1 196.71 383.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "200.48 381.73 198.92 382.63 198.92 380.83 200.48 379.93 200.48 381.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "136.42 423.37 134.87 424.27 134.87 422.47 136.42 421.57 136.42 423.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "140.19 421.2 138.63 422.1 138.63 420.3 140.19 419.4 140.19 421.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "143.96 419.02 142.4 419.92 142.4 418.12 143.96 417.22 143.96 419.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "147.73 416.85 146.17 417.75 146.17 415.95 147.73 415.05 147.73 416.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "151.5 414.67 149.94 415.57 149.94 413.77 151.5 412.87 151.5 414.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "155.26 412.5 153.71 413.4 153.71 411.6 155.26 410.7 155.26 412.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "159.03 410.32 157.47 411.22 157.47 409.42 159.03 408.52 159.03 410.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "162.8 408.14 161.24 409.04 161.24 407.24 162.8 406.34 162.8 408.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "166.57 405.97 165.01 406.87 165.01 405.07 166.57 404.17 166.57 405.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "170.34 403.79 168.78 404.69 168.78 402.89 170.34 401.99 170.34 403.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "174.1 401.62 172.55 402.52 172.55 400.72 174.1 399.82 174.1 401.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "177.87 399.44 176.31 400.34 176.31 398.54 177.87 397.64 177.87 399.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "181.64 397.27 180.08 398.17 180.08 396.37 181.64 395.47 181.64 397.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "185.41 395.09 183.85 395.99 183.85 394.19 185.41 393.29 185.41 395.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.18 392.92 187.62 393.82 187.62 392.02 189.18 391.12 189.18 392.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "192.94 390.74 191.39 391.64 191.39 389.84 192.94 388.94 192.94 390.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "196.71 388.57 195.15 389.47 195.15 387.67 196.71 386.77 196.71 388.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "200.48 386.39 198.92 387.29 198.92 385.49 200.48 384.59 200.48 386.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "136.42 428.04 134.87 428.94 134.87 427.14 136.42 426.24 136.42 428.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "140.19 425.86 138.63 426.76 138.63 424.96 140.19 424.06 140.19 425.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "143.96 423.69 142.4 424.59 142.4 422.79 143.96 421.89 143.96 423.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "147.73 421.51 146.17 422.41 146.17 420.61 147.73 419.71 147.73 421.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "151.5 419.34 149.94 420.23 149.94 418.44 151.5 417.54 151.5 419.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "155.26 417.16 153.71 418.06 153.71 416.26 155.26 415.36 155.26 417.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "159.03 414.98 157.47 415.88 157.47 414.08 159.03 413.18 159.03 414.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "162.8 412.81 161.24 413.71 161.24 411.91 162.8 411.01 162.8 412.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "166.57 410.63 165.01 411.53 165.01 409.73 166.57 408.83 166.57 410.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "170.34 408.46 168.78 409.36 168.78 407.56 170.34 406.66 170.34 408.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "174.1 406.28 172.55 407.18 172.55 405.38 174.1 404.48 174.1 406.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "177.87 404.11 176.31 405.01 176.31 403.21 177.87 402.31 177.87 404.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "181.64 401.93 180.08 402.83 180.08 401.03 181.64 400.13 181.64 401.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "185.41 399.76 183.85 400.66 183.85 398.86 185.41 397.96 185.41 399.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.18 397.58 187.62 398.48 187.62 396.68 189.18 395.78 189.18 397.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "192.94 395.41 191.39 396.31 191.39 394.5 192.94 393.61 192.94 395.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "196.71 393.23 195.15 394.13 195.15 392.33 196.71 391.43 196.71 393.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "200.48 391.05 198.92 391.96 198.92 390.15 200.48 389.25 200.48 391.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "136.42 432.7 134.87 433.6 134.87 431.8 136.42 430.9 136.42 432.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "140.19 430.53 138.63 431.43 138.63 429.63 140.19 428.73 140.19 430.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "143.96 428.35 142.4 429.25 142.4 427.45 143.96 426.55 143.96 428.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "147.73 426.17 146.17 427.08 146.17 425.28 147.73 424.37 147.73 426.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "151.5 424 149.94 424.9 149.94 423.1 151.5 422.2 151.5 424"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "155.26 421.82 153.71 422.72 153.71 420.92 155.26 420.02 155.26 421.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "159.03 419.65 157.47 420.55 157.47 418.75 159.03 417.85 159.03 419.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "162.8 417.47 161.24 418.37 161.24 416.57 162.8 415.67 162.8 417.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "166.57 415.3 165.01 416.2 165.01 414.4 166.57 413.5 166.57 415.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "170.34 413.12 168.78 414.02 168.78 412.22 170.34 411.32 170.34 413.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "174.1 410.95 172.55 411.85 172.55 410.05 174.1 409.15 174.1 410.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "177.87 408.77 176.31 409.67 176.31 407.87 177.87 406.97 177.87 408.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "181.64 406.6 180.08 407.5 180.08 405.7 181.64 404.8 181.64 406.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "185.41 404.42 183.85 405.32 183.85 403.52 185.41 402.62 185.41 404.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.18 402.25 187.62 403.15 187.62 401.35 189.18 400.44 189.18 402.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "192.94 400.07 191.39 400.97 191.39 399.17 192.94 398.27 192.94 400.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "196.71 397.89 195.15 398.79 195.15 396.99 196.71 396.09 196.71 397.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "200.48 395.72 198.92 396.62 198.92 394.82 200.48 393.92 200.48 395.72"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M330.16,164.12c-.57,0-1.14-.02-1.71-.06-10.3-.77-19.81-8.54-22.62-18.48-.36-1.27.38-2.6,1.66-2.96,1.28-.36,2.6.38,2.96,1.66,2.28,8.07,10,14.38,18.36,15,8.36.62,16.93-4.47,20.38-12.11.54-1.21,1.96-1.74,3.17-1.2,1.21.54,1.75,1.97,1.2,3.17-4.01,8.89-13.66,14.99-23.39,14.99Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-40",
    cx: 352.98,
    cy: 144.92,
    r: 9.33
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M309.23,155.21l6.55-3.81c.83-.48,1.35-1.51,1.35-2.96l-6.55,3.81c0,1.45-.52,2.47-1.35,2.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-84"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M309.23,155.21l6.55-3.81c.74-.43,1.23-1.28,1.33-2.49l-6.55,3.81c-.1,1.2-.59,2.06-1.33,2.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M310.56,152.72l6.55-3.81c.01-.15.02-.31.02-.47l-6.55,3.81c0,.16,0,.32-.02.47h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M297.55,119.89l-6.55,3.81c.84-.49,2-.42,3.28.32l6.55-3.81c-1.28-.74-2.44-.8-3.28-.32Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M294.28,124.01l6.55-3.81c-1.28-.74-2.44-.8-3.28-.32l-6.55,3.81c.84-.49,2-.42,3.28.32h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "310.58 152.25 317.14 148.45 317.17 134.95 310.62 138.76 310.58 152.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "306.02 130.79 312.58 126.99 300.83 120.21 294.28 124.01 306.02 130.79"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M310.62,138.76l6.55-3.81c0-2.91-2.06-6.5-4.6-7.97l-6.55,3.81c2.54,1.46,4.61,5.05,4.6,7.97Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-263"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M310.62,138.76l6.55-3.81c0-2.52-1.53-5.53-3.59-7.25l-6.55,3.81c2.05,1.72,3.59,4.74,3.59,7.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M307.04,131.51l6.55-3.81c-.33-.27-.66-.51-1.01-.71l-6.55,3.81c.35.2.69.44,1.01.71h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M294.28,124.01c-2.54-1.47-4.62-.28-4.63,2.64l-.04,13.5c0,2.92,2.06,6.5,4.6,7.97l11.74,6.78c2.54,1.46,4.62.28,4.63-2.64l.04-13.5c0-2.92-2.06-6.5-4.6-7.97l-11.74-6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M295.92,128.35c-1.83-1.05-3.32-.2-3.33,1.89l-.03,9.7c0,2.1,1.48,4.68,3.31,5.73l8.44,4.87c1.82,1.05,3.32.2,3.33-1.9l.03-9.7c0-2.1-1.48-4.67-3.31-5.73l-8.44-4.87Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M293.85,223.08c13.87-8.58,16.91-19.76,17.02-27.62-.02,6.66-4.3,13.32-12.89,18.49-17.7,10.65-46.99,10.95-65.44.66-9.49-5.29-14.26-12.36-14.24-19.42.24,6.57,1.48,12.07,6.9,19.13,3.68,4.79,10.71,9.79,17.09,12.14,3.26,1.2,13.18,4.87,25.93,4.03,6.96-.46,17.05-2.11,25.61-7.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M310.88,195.46l.13-44.65c-.02,6.66-4.3,13.32-12.88,18.49-17.7,10.65-46.99,10.95-65.44.66-9.49-5.29-14.26-12.36-14.24-19.42l-.13,44.65c-.02,7.06,4.75,14.13,14.24,19.42,18.44,10.28,47.74,9.99,65.44-.66,8.59-5.17,12.87-11.83,12.89-18.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M231.32,132.05c-17.7,10.65-17.09,27.62,1.36,37.91,18.45,10.29,47.74,9.99,65.44-.66,17.7-10.65,17.09-27.62-1.36-37.91-18.44-10.28-47.74-9.99-65.44.66Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M292.12,158.43c12.18-7.51,14.98-16.89,16.04-20.42-1.31,4.82-5.09,9.46-11.37,13.24-16.33,9.83-43.36,10.1-60.38.61-7.04-3.92-11.26-8.9-12.64-14.09.72,2.35,2.89,9.5,8.9,15.09,4.71,4.38,9.45,7.65,18.49,10.38,13.11,3.96,29.96,1.99,40.97-4.8h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M248.54,78.06c-9.31,5.6-8.99,14.53.71,19.94,9.7,5.41,25.11,5.25,34.42-.35,9.31-5.6,8.99-14.53-.71-19.94-9.7-5.41-25.11-5.25-34.42.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M294.92,76.26c-8.91-4.84-18.88-7.22-29.63-7.08-11.09.14-21.03,2.78-29.55,7.84,3.22-1.94,7.72-1.79,12.79,1.04,9.31-5.6,24.72-5.76,34.42-.35,9.7,5.41,10.02,14.34.71,19.94-9.31,5.6-24.72,5.76-34.42.35-9.7-5.41-10.02-14.34-.71-19.94-5.07-2.83-9.57-2.98-12.79-1.04-3.98,2.57-11.38,7.37-15.83,17.28-4.47,9.95-2.69,18.14-1.84,22.07,1.59,5.99,6.39,11.65,14.38,16.11,19.33,10.78,50.03,10.47,68.57-.69,7.13-4.29,11.42-9.56,12.91-15.03.88-3.89,1.52-6.71.93-12.7-.32-3.28-1.41-6.91-3.23-10.79-1.17-2.49-5.83-11.08-16.72-16.99h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M248.42,126.91c.22,3.17,1.93,8.74,10.87,10.36,15.03,1.23,30.82-1.58,42.13-8.39,4.66-2.81,8.12-6.03,10.4-9.45,6.18-11.44-.53-23.03-7.1-20.68-.68.24-1.4.95-1.89,1.48-1.82,2.75-4.6,5.33-8.34,7.58-9.08,5.46-21.75,7.72-33.81,6.73-9.25.23-12.54,8.17-12.25,12.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M308.16,138l5.78-21.26c-1.49,5.47-5.78,10.74-12.91,15.03-18.54,11.16-49.24,11.47-68.57.69-7.99-4.46-12.79-10.11-14.35-16l5.66,21.29c1.38,5.19,5.6,10.17,12.64,14.09,17.02,9.49,44.06,9.22,60.38-.61,6.28-3.78,10.06-8.42,11.37-13.24h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M305.13,119.12c.02.08.04.17.07.25,3.2-2.49,5.56-5.25,7.1-8.13-.98-4.08-4.24-5.99-6.35-3.73-2.67,3.33-.84,11.53-.82,11.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M266.95,130.56c0,.09,0,.18.01.28,5.16,0,10.3-.52,15.22-1.51-.28-4.72-3.95-8.31-8.18-8.01-4.74.63-7.14,5.77-7.05,9.24h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M239.69,133.23c0-5.6-3.93-12.4-8.78-15.2-4.85-2.8-8.78-.53-8.78,5.07s3.93,12.4,8.78,15.2c4.85,2.8,8.78.53,8.78-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M235.81,131c0-3.13-2.2-6.93-4.9-8.49-2.71-1.56-4.9-.3-4.9,2.83s2.2,6.93,4.9,8.49c2.71,1.56,4.9.3,4.9-2.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M287.15,75.23l5.51-33-5.51,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M287.16,76.73c-.08,0-.17,0-.25-.02-.82-.14-1.37-.91-1.23-1.73l5.51-33c.14-.82.91-1.37,1.73-1.23.82.14,1.37.91,1.23,1.73l-5.51,33c-.12.73-.76,1.25-1.48,1.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M299.3,40.98c.03-3.55-2.83-6.45-6.37-6.47-3.55-.03-6.45,2.83-6.47,6.37-.03,3.55,2.83,6.45,6.37,6.47,3.55.03,6.45-2.83,6.48-6.37Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M243.71,98.69l-22.57-25.49,22.57,25.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M243.72,100.19c-.41,0-.83-.17-1.12-.51l-22.57-25.49c-.55-.62-.49-1.57.13-2.12.62-.55,1.57-.49,2.12.13l22.57,25.49c.55.62.49,1.57-.13,2.12-.28.25-.64.38-.99.38Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M227.57,73.25c.03-3.55-2.83-6.45-6.37-6.48-3.55-.03-6.45,2.83-6.48,6.37s2.83,6.45,6.37,6.47c3.55.03,6.45-2.83,6.47-6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M256.69,213.14c-5.41,0-10.82-1.21-15.72-3.62-9.41-4.64-16.46-13.5-18.86-23.72-.3-1.29.5-2.58,1.79-2.88,1.29-.3,2.58.5,2.88,1.79,2.08,8.83,8.17,16.5,16.31,20.51,8.14,4.01,17.93,4.18,26.2.45,1.21-.54,2.63,0,3.17,1.2.54,1.21,0,2.63-1.2,3.17-4.59,2.07-9.59,3.1-14.58,3.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-40",
    cx: 271.94,
    cy: 206.96,
    r: 9.57
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M230.91,190.85l6.55-3.81c.83-.48,1.35-1.51,1.35-2.96l-6.55,3.81c0,1.45-.52,2.47-1.35,2.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M230.91,190.85l6.55-3.81c.74-.43,1.23-1.28,1.33-2.49l-6.55,3.81c-.1,1.2-.59,2.06-1.33,2.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M232.24,188.36l6.55-3.81c.01-.15.02-.31.02-.47l-6.55,3.81c0,.16,0,.32-.02.47h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M219.23,155.53l-6.55,3.81c.84-.49,2-.42,3.28.32l6.55-3.81c-1.28-.74-2.44-.8-3.28-.32Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-204"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M215.96,159.65l6.55-3.81c-1.28-.74-2.44-.8-3.28-.32l-6.55,3.81c.84-.49,2-.42,3.28.32h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "232.26 187.89 238.81 184.09 238.85 170.59 232.3 174.4 232.26 187.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "227.7 166.43 234.25 162.62 222.51 155.84 215.96 159.65 227.7 166.43"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M232.3,174.4l6.55-3.81c0-2.92-2.06-6.5-4.6-7.97l-6.55,3.81c2.54,1.46,4.61,5.05,4.6,7.97Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-305"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M232.3,174.4l6.55-3.81c0-2.52-1.53-5.53-3.59-7.25l-6.55,3.81c2.05,1.72,3.59,4.74,3.59,7.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M228.71,167.15l6.55-3.81c-.33-.27-.66-.51-1.01-.71l-6.55,3.81c.35.2.69.44,1.01.71h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M215.96,159.65c-2.54-1.47-4.62-.28-4.63,2.64l-.04,13.49c0,2.92,2.06,6.5,4.6,7.97l11.74,6.78c2.54,1.46,4.62.28,4.63-2.64l.04-13.49c0-2.92-2.06-6.5-4.6-7.97l-11.74-6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M217.6,163.99c-1.83-1.05-3.32-.2-3.33,1.89l-.03,9.7c0,2.1,1.48,4.68,3.31,5.73l8.44,4.87c1.82,1.05,3.32.2,3.33-1.9l.03-9.7c0-2.1-1.48-4.67-3.31-5.73l-8.44-4.87Z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M283.35,233.16l2.1,1.22c-.64-.37-1.53-.32-2.52.25l-2.1-1.22c.98-.57,1.87-.62,2.52-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M209.17,292.28l-2.1-1.22c-.63-.37-1.03-1.15-1.03-2.26l2.1,1.22c0,1.11.4,1.9,1.03,2.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "208.14 290.01 206.03 288.79 206.01 280.67 208.11 281.9 208.14 290.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "211.63 275.8 209.53 274.57 280.83 233.41 282.93 234.63 211.63 275.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M208.11,281.9l-2.1-1.22c0-2.24,1.57-4.98,3.52-6.1l2.1,1.22c-1.95,1.12-3.53,3.86-3.52,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M282.93,234.63c1.95-1.13,3.54-.22,3.55,2.02l.02,8.12c0,2.24-1.57,4.97-3.52,6.1l-71.3,41.17c-1.95,1.12-3.54.22-3.54-2.02l-.02-8.12c0-2.24,1.57-4.98,3.52-6.1l71.3-41.17Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M238.02,272.27c-.12,0-.21-.1-.21-.21v-6.49c0-.12.1-.21.21-.21s.21.1.21.21v6.49c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M239.24,273.95c-.12,0-.21-.1-.21-.21v-11.26c0-.12.1-.21.21-.21s.21.09.21.21v11.26c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M240.46,272.56c-.12,0-.21-.1-.21-.21v-9.88c0-.12.09-.21.21-.21s.21.09.21.21v9.88c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M241.68,269.21c-.12,0-.21-.1-.21-.21v-4.6c0-.12.1-.21.21-.21s.21.1.21.21v4.6c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M242.9,268.51c-.12,0-.21-.1-.21-.21v-4.6c0-.12.1-.21.21-.21s.21.09.21.21v4.6c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M244.12,267.03c-.12,0-.21-.09-.21-.21v-3.06c0-.12.1-.21.21-.21s.21.1.21.21v3.06c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M245.34,266.32c-.12,0-.21-.1-.21-.21v-3.06c0-.12.1-.21.21-.21s.21.1.21.21v3.06c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M246.56,265.62c-.12,0-.21-.1-.21-.21v-3.06c0-.12.1-.21.21-.21s.21.1.21.21v3.06c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M247.79,268.05c-.12,0-.21-.1-.21-.21v-9.32c0-.12.09-.21.21-.21s.21.1.21.21v9.32c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M249.01,268.4c-.12,0-.21-.1-.21-.21v-11.43c0-.12.1-.21.21-.21s.21.1.21.21v11.43c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M250.23,266.64c-.12,0-.21-.09-.21-.21v-9.32c0-.12.1-.21.21-.21s.21.1.21.21v9.32c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M251.45,265.37c-.12,0-.21-.1-.21-.21v-8.19c0-.12.09-.21.21-.21s.21.1.21.21v8.19c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M252.67,264.66c-.12,0-.21-.1-.21-.21v-8.19c0-.12.1-.21.21-.21s.21.1.21.21v8.19c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M253.89,263.11c-.12,0-.21-.09-.21-.21v-6.49c0-.12.09-.21.21-.21s.21.09.21.21v6.49c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M255.11,261.92c-.12,0-.21-.1-.21-.21v-5.52c0-.12.09-.21.21-.21s.21.09.21.21v5.52c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M256.33,261.21c-.12,0-.21-.1-.21-.21v-5.52c0-.12.1-.21.21-.21s.21.1.21.21v5.52c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M257.55,259.77c-.12,0-.21-.1-.21-.21v-4.04c0-.12.09-.21.21-.21s.21.1.21.21v4.04c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M258.77,259.06c-.12,0-.21-.1-.21-.21v-4.04c0-.12.1-.21.21-.21s.21.09.21.21v4.04c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M259.99,257.65c-.12,0-.21-.1-.21-.21v-2.63c0-.12.09-.21.21-.21s.21.1.21.21v2.63c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M261.22,256.43c-.12,0-.21-.1-.21-.21v-1.59c0-.12.1-.21.21-.21s.21.1.21.21v1.59c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M262.44,256.25c-.12,0-.21-.1-.21-.21v-2.63c0-.12.1-.21.21-.21s.21.1.21.21v2.63c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M263.66,256.28c-.12,0-.21-.09-.21-.21v-4.11c0-.12.09-.21.21-.21s.21.09.21.21v4.11c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M264.88,255.57c-.12,0-.21-.09-.21-.21v-4.11c0-.12.1-.21.21-.21s.21.1.21.21v4.11c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M233.25,272.57c-.12,0-.21-.1-.21-.21v-1.59c0-.12.1-.21.21-.21s.21.09.21.21v1.59c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M234.47,272.39c-.12,0-.21-.1-.21-.21v-2.63c0-.12.1-.21.21-.21s.21.1.21.21v2.63c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M235.69,272.42c-.12,0-.21-.1-.21-.21v-4.11c0-.12.1-.21.21-.21s.21.1.21.21v4.11c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M236.91,271.72c-.12,0-.21-.1-.21-.21v-4.11c0-.12.1-.21.21-.21s.21.1.21.21v4.11c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M266.1,255.78c-.12,0-.21-.1-.21-.21v-5.94c0-.12.1-.21.21-.21s.21.09.21.21v5.94c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M267.32,255.08c-.12,0-.21-.1-.21-.21v-5.94c0-.12.1-.21.21-.21s.21.09.21.21v5.94c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M268.54,255.25c-.12,0-.21-.1-.21-.21v-7.7c0-.12.1-.21.21-.21s.21.09.21.21v7.7c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M269.76,253.94c-.12,0-.21-.1-.21-.21v-6.49c0-.12.1-.21.21-.21s.21.09.21.21v6.49c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M270.98,254.65c-.12,0-.21-.1-.21-.21v-9.32c0-.12.09-.21.21-.21s.21.09.21.21v9.32c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M272.2,254.83c-.12,0-.21-.1-.21-.21v-11.08c0-.12.1-.21.21-.21s.21.09.21.21v11.08c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M273.42,254.12c-.12,0-.21-.1-.21-.21v-11.08c0-.12.1-.21.21-.21s.21.09.21.21v11.08c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M274.65,252.71c-.12,0-.21-.1-.21-.21v-9.67c0-.12.09-.21.21-.21s.21.09.21.21v9.67c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M275.87,252.01c-.12,0-.21-.1-.21-.21v-9.67c0-.12.1-.21.21-.21s.21.09.21.21v9.67c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M277.09,250.21c-.12,0-.21-.09-.21-.21v-7.49c0-.12.1-.21.21-.21s.21.09.21.21v7.49c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M278.31,248.38c-.12,0-.21-.09-.21-.21v-5.24c0-.12.09-.21.21-.21s.21.09.21.21v5.24c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M279.53,246.61c-.12,0-.21-.09-.21-.21v-3.09c0-.12.1-.21.21-.21s.21.09.21.21v3.09c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M280.75,245.9c-.12,0-.21-.09-.21-.21v-3.09c0-.12.1-.21.21-.21s.21.09.21.21v3.09c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M281.97,246.21c-.12,0-.21-.09-.21-.21v-5.11c0-.12.09-.21.21-.21s.21.09.21.21v5.11c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M283.19,243.74c-.12,0-.21-.09-.21-.21v-1.59c0-.12.1-.21.21-.21s.21.09.21.21v1.59c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M284.41,243.04c-.12,0-.21-.09-.21-.21v-1.59c0-.12.09-.21.21-.21s.21.09.21.21v1.59c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M209.96,286.06c-.12,0-.21-.1-.21-.21v-1.67c0-.12.1-.21.21-.21s.21.09.21.21v1.67c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M211.18,285.77c-.12,0-.21-.1-.21-.21v-2.49c0-.12.1-.21.21-.21s.21.1.21.21v2.49c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M212.4,286.12c-.12,0-.21-.1-.21-.21v-4.6c0-.12.1-.21.21-.21s.21.1.21.21v4.6c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M213.62,285.41c-.12,0-.21-.1-.21-.21v-4.6c0-.12.1-.21.21-.21s.21.1.21.21v4.6c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M214.84,285.65c-.12,0-.21-.1-.21-.21v-6.49c0-.12.1-.21.21-.21s.21.1.21.21v6.49c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M216.06,284.95c-.12,0-.21-.1-.21-.21v-6.49c0-.12.1-.21.21-.21s.21.1.21.21v6.49c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M217.28,285.41c-.12,0-.21-.1-.21-.21v-8.82c0-.12.1-.21.21-.21s.21.1.21.21v8.82c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M218.5,285.71c-.12,0-.21-.1-.21-.21v-10.85c0-.12.1-.21.21-.21s.21.1.21.21v10.85c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M219.73,286.03c-.12,0-.21-.1-.21-.21v-12.89c0-.12.1-.21.21-.21s.21.1.21.21v12.89c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M220.95,285.33c-.12,0-.21-.1-.21-.21v-12.9c0-.12.1-.21.21-.21s.21.1.21.21v12.9c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M222.17,283.68c-.12,0-.21-.1-.21-.21v-11.01c0-.12.1-.21.21-.21s.21.09.21.21v11.01c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M223.39,281.95c-.12,0-.21-.1-.21-.21v-8.96c0-.12.1-.21.21-.21s.21.1.21.21v8.96c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M224.61,280.47c-.12,0-.21-.09-.21-.21v-7.4c0-.12.1-.21.21-.21s.21.1.21.21v7.4c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M225.83,279.76c-.12,0-.21-.09-.21-.21v-7.41c0-.12.1-.21.21-.21s.21.1.21.21v7.41c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M227.05,277.79c-.12,0-.21-.1-.21-.21v-4.87c0-.12.1-.21.21-.21s.21.1.21.21v4.87c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M228.27,276.39c-.12,0-.21-.1-.21-.21v-3.47c0-.12.1-.21.21-.21s.21.1.21.21v3.47c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M229.49,275.68c-.12,0-.21-.1-.21-.21v-3.47c0-.12.09-.21.21-.21s.21.1.21.21v3.47c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M230.71,274.12c-.12,0-.21-.1-.21-.21v-1.75c0-.12.1-.21.21-.21s.21.1.21.21v1.75c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M231.94,273.41c-.12,0-.21-.09-.21-.21v-1.75c0-.12.09-.21.21-.21s.21.1.21.21v1.75c0,.12-.1.21-.21.21Z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "341.78 73.43 338.07 71.27 337.61 72.1 341.32 74.25 341.78 73.43"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M371.45,19.74l-3.71-2.16c-1.17-.68-2.79-.59-4.57.44l3.71,2.16c1.78-1.03,3.4-1.12,4.57-.44Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-179"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M371.45,19.74l-3.71-2.16c-1.17-.68-2.79-.59-4.57.44l3.71,2.16c1.78-1.03,3.4-1.12,4.57-.44h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "326.73 82.68 323.02 80.52 323.55 97.51 327.26 99.66 326.73 82.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "326.72 82.13 326.73 82.68 327.26 99.66 341.32 74.25 341.78 73.43 326.72 82.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "326.72 82.13 323.01 79.97 323.02 80.52 326.73 82.68 326.72 82.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "341.78 73.43 338.07 71.27 323.01 79.97 326.72 82.13 341.78 73.43"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M316.06,82.34l3.71,2.16c-1.15-.67-1.87-2.09-1.88-4.11l-3.71-2.16c0,2.02.72,3.44,1.88,4.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-271"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M317.89,80.39l-3.71-2.16c0,2.02.72,3.44,1.88,4.11l3.71,2.16c-1.15-.67-1.87-2.09-1.88-4.11h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "317.83 55.89 314.11 53.74 314.18 78.23 317.89 80.39 317.83 55.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "366.89 20.18 363.18 18.02 320.52 42.65 324.23 44.81 366.89 20.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M324.23,44.81c-3.53,2.04-6.41,7.03-6.4,11.09l.07,24.49c.01,4.06,2.91,5.71,6.45,3.67l2.39-1.38-.02-.55,15.06-8.7-.46.82,25.67-14.82c3.53-2.04,6.41-7.03,6.4-11.09l-.07-24.49c-.01-4.06-2.91-5.71-6.45-3.67l-42.66,24.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M324.23,44.81l-3.71-2.16c-3.53,2.04-6.42,7.03-6.4,11.09l3.71,2.16c-.01-4.06,2.87-9.05,6.4-11.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-197"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M324.23,44.81l-3.71-2.16c-3.53,2.04-6.42,7.03-6.4,11.09l3.71,2.16c-.01-4.06,2.87-9.05,6.4-11.09h0Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M352.8,48.98c0,2.94,2.07,4.14,4.62,2.67,2.55-1.47,4.62-5.05,4.62-8s-2.07-4.14-4.62-2.67c-2.55,1.47-4.62,5.05-4.62,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M340.45,56.11c0,2.94,2.07,4.14,4.62,2.67,2.55-1.47,4.62-5.05,4.62-8s-2.07-4.14-4.62-2.67c-2.55,1.47-4.62,5.05-4.62,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M328.09,63.24c0,2.94,2.07,4.14,4.62,2.67,2.55-1.47,4.62-5.05,4.62-8s-2.07-4.14-4.62-2.67c-2.55,1.47-4.62,5.05-4.62,8Z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M16.86,432.04s0-.02,0-.03l-.07,6.95c0,.09.01.19.03.28,0,.03.01.06.02.09.02.06.04.13.06.19,0,.02,0,.03.02.05,0,.01.02.03.02.04.04.08.08.16.13.24.01.02.02.04.03.05.06.09.14.19.22.27.02.02.05.04.07.07.07.07.15.14.23.2.03.02.06.05.09.07.11.08.23.16.36.24l45.89,26.67c.22.13.45.24.7.33.08.03.18.05.26.08.17.06.34.11.51.15.11.02.22.04.33.06.17.03.33.06.5.08.12.01.24.01.36.02.16,0,.32.02.49.02.01,0,.03,0,.04,0,.15,0,.29-.02.44-.03.12,0,.24,0,.36-.02.16-.02.32-.05.48-.08.11-.02.22-.03.33-.06.17-.04.34-.1.5-.15.09-.03.18-.05.26-.08.24-.09.47-.2.69-.32l46.19-26.67c.87-.5,1.3-1.16,1.3-1.82l.07-6.96s0,0,0,0c0-.65-.43-1.3-1.28-1.8l-45.89-26.67c-1.72-1-4.51-1-6.24,0l-46.19,26.67c-.89.51-1.32,1.18-1.3,1.85ZM16.88,432.28s.01.06.02.09h0s-.02-.06-.02-.09c0,0,0,0,0,0ZM17.39,433.22s0,0,0,0c.02.02.05.05.07.07h0s-.05-.05-.07-.07ZM17.69,433.49h0s.04.03.07.05c-.02-.02-.04-.03-.07-.05ZM16.97,432.56s.02.04.02.06c0-.02-.02-.04-.02-.06h0ZM117.57,432.72s.03-.07.05-.11c-.02.04-.03.07-.05.11ZM117.73,432.23s0-.08.01-.12c0,.04,0,.08-.01.12ZM117.67,432.48s.02-.08.03-.11c0,.04-.02.08-.03.11ZM117.24,433.18s.05-.07.08-.1c-.03.03-.05.07-.08.1ZM117.43,432.95s.04-.07.06-.1c-.02.03-.04.07-.06.1ZM116.76,433.61s.05-.04.08-.06c-.03.02-.05.04-.08.06ZM117.02,433.4s.07-.06.1-.1c-.03.03-.06.07-.1.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M16.86,432.01l-.07,6.95c0,.65.43,1.3,1.28,1.79l.07-6.95c-.85-.5-1.28-1.15-1.28-1.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-195"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M16.86,432.01l-.07,6.95c0,.2.04.41.13.6l.07-6.96c-.08-.2-.13-.4-.13-.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M16.98,432.61l-.07,6.96c.18.44.57.85,1.16,1.19l.07-6.95c-.59-.34-.97-.76-1.16-1.19h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M117.69,438.94l.07-6.95c0,.66-.43,1.32-1.3,1.82l-.07,6.95c.87-.5,1.3-1.16,1.3-1.82Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-116"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M116.45,433.8l-.07,6.95c.87-.5,1.3-1.16,1.3-1.82l.07-6.95c0,.66-.43,1.32-1.3,1.82h0Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "18.14 433.8 18.07 440.76 63.96 467.42 64.02 460.47 18.14 433.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "70.27 460.47 70.2 467.42 116.39 440.76 116.45 433.8 70.27 460.47"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-280"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M64.02,460.47l-.07,6.95c.88.51,2.04.76,3.2.75l.07-6.95c-1.16.01-2.32-.24-3.2-.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M67.22,461.22l-.07,6.95c1.1-.01,2.2-.26,3.04-.75l.07-6.95c-.84.49-1.94.74-3.04.75h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M18.16,430.19c-1.73,1-1.74,2.62-.02,3.62l45.89,26.67c1.72,1,4.51,1,6.24,0l46.19-26.67c1.73-1,1.74-2.62.02-3.61l-45.89-26.67c-1.72-1-4.51-1-6.24,0l-46.19,26.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M67.16,458.46c-1.05,0-2.1-.23-2.9-.69l-41.27-23.98c-.8-.47-1.25-1.1-1.25-1.78,0-.69.45-1.32,1.26-1.79l41.54-23.98c1.6-.93,4.21-.93,5.8,0l41.27,23.98c.8.47,1.25,1.1,1.25,1.78,0,.69-.45,1.32-1.26,1.79l-41.54,23.98c-.8.46-1.85.69-2.9.69ZM23.2,430.53c-.69.4-1.08.92-1.08,1.47,0,.54.38,1.06,1.06,1.46l41.27,23.98c1.49.87,3.93.87,5.43,0l41.54-23.98c.69-.4,1.08-.92,1.08-1.47,0-.54-.38-1.06-1.06-1.46l-41.27-23.98c-1.49-.87-3.92-.87-5.43,0l-41.54,23.98Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.28,427.27c-.06.33-.14.66-.25.97-.09.28-.2.55-.32.81-.28.63-.63,1.23-1,1.81-.11.18-.22.36-.34.54,0,0,0,0,0,.01.06.01.13.12.19.3.12.38.19,1.09.09,1.96-.06.54-.18,1.15-.4,1.78-.13.38-.3.78-.51,1.17-.63,1.2-1.64,2.41-3.22,3.36-.54.32-1.74.48-2.93.57-.28.02-.56.03-.83.05-1.21.05-2.23.03-2.23.03,0,0-.39.17-1.02.44-.51.21-1.17.49-1.92.78-3.28,1.28-8.16,2.92-8.44,1.44-5.25,2.36-7.01-.57-6.74-2.78-1.82,2.21-5.27,1.21-5.59-1.64-5.53-.84-4.85-4.46-4.85-4.46-5.1,2.97-8.42-.77-8.14-2.55-2.1.82-4.5.34-6.24-.99-.68-.51-1.1-2.93-1.1-2.93,0,0-.55-.1-1.5-.53-1.67-.77-3.06-1.87-3.93-3.58-.98-1.93-1.12-4.33-.38-6.43-1.2-.68-2.21-1.81-2.52-3.21-.21-.95-.05-2.03.48-2.87.26-.42.85-1.02.84-1.52-.01-.47-.78-1.37-.98-1.83-.57-1.27-.94-2.64-1.12-4.02-.12-.97-.12-1.44.52-2.16.76-.84,1.57-1.6,2.16-2.58.1-.17.21-.36.21-.56,0-.18-.08-.35-.14-.52-.98-2.42.02-5.34,2.01-7.05,1.37-1.17,3.12-1.81,4.89-2.01.32-.04.8.01,1.28.03.45.01.89,0,1.14-.14,0,0,.02,0,.03-.02.5-.31.5-1.32.78-1.79.43-.73,1.03-1.35,1.71-1.86,1.13-.84,2.47-1.36,3.82-1.78.81-.25,1.65-.47,2.51-.44.38,0,.75.07,1.11.16h0c.17.04.33.09.48.15.74.26,1.43.67,2.06,1.13.07.05.13.1.2.15.12.09.25.19.39.21.01,0,.03,0,.04,0,0,0,.02,0,.02,0,.16,0,.31-.08.45-.15.05-.03.11-.06.16-.08,1.04-.53,2.2-.89,3.36-.92.24,0,.48,0,.71.03.11,0,.21.03.32.04,1.03.17,2.02.68,2.7,1.45.15.17.28.34.4.53.16.26.29.54.38.83,1.32-.65,2.99-.57,4.24.2,1.18.72,1.96,2.03,2.05,3.4,0,.06,0,.11,0,.17,0,.03,0,.06,0,.1,0,0,.31-.08.79-.1.07,0,.15,0,.24,0,.98,0,2.48.24,3.73,1.56.99,1.05,1.46,2.24,1.71,3.57.05.23.08.47.12.72.09,0,.18,0,.28,0,1,0,2.07.01,3.05.29.64.18,1.24.47,1.75.93,1.3,1.17,1.55,3.08,1.45,4.81,1.39.21,2.59,1.2,3.17,2.46.33.7.47,1.47.46,2.24,0,.37-.09.72-.12,1.08-.05.58-.16.41.28.68.56.35,1.29.4,1.86.82.53.38.98.87,1.31,1.43.22.37.39.77.51,1.18h0c.07.25.13.5.16.76.06.46-.11,1.16-.14,1.71h0c-.01.22,0,.41.05.56.04.09.09.17.15.24,0,0,0,0,0,0,.08.08.17.15.28.22.32.19.72.31.98.51.57.43,1.03,1.03,1.3,1.72.34.87.4,1.83.26,2.74-.06.36-.17.71-.25,1.05-.05.22-.08.44-.08.66,0,.17.02.35.08.53.22.66.88,1.15,1.16,1.79.36.81.44,1.75.3,2.62Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M75.07,423.73c-.1.07-.22.16-.34.25-.1.08-.21.16-.32.24-1.13.85-3.01,2.09-5.88,2.09-.16,0-.33,0-.5-.01-2.94-.14-5.29-.94-6.98-2.36-2.15-1.81-3.32-4.4-4.45-6.9-.69-1.53-1.41-3.12-2.34-4.5-1.42-2.12-3.36-3.71-5.44-4.48-1.91-.71-3.98-.72-5.74-.08-.05-.16-.12-.39-.2-.64,1.9-.69,4.12-.67,6.17.09.83.3,1.62.73,2.38,1.25.23.16.46.33.68.51,1.01.81,1.93,1.82,2.71,2.97.96,1.43,1.69,3.04,2.4,4.6,1.15,2.55,2.24,4.96,4.28,6.67,1.57,1.33,3.79,2.07,6.58,2.2,2.89.14,4.72-1.03,5.9-1.9.13-.1.25-.19.37-.28.13-.1.24-.19.35-.27.15-.11.36-.07.46.07.11.15.08.36-.07.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M65.25,384.64c-.11,2.27-1.02,4.63-2.62,6.73-.96,1.26-2.11,2.36-3.31,3.35t0,0c-.27.21-.54.42-.8.63,0,0,0,0,0,0-.98.74-1.98,1.41-2.94,2.02l-.18.12c-.67.42-1.35.86-1.94,1.39-1.41,1.27-2.26,3.17-2.32,5.07h0c-.01.4,0,.8.07,1.19.03.18-.1.35-.28.38-.02,0-.03,0-.05,0-.16,0-.31-.12-.33-.29-.06-.4-.09-.8-.08-1.2.02-2.13.94-4.22,2.54-5.66.63-.56,1.34-1.02,2.03-1.46l.18-.11c2.35-1.5,5-3.36,6.89-5.84,1.45-1.91,2.3-4.04,2.46-6.1.01,0,.03,0,.04,0,0,0,.02,0,.02,0,.16,0,.31-.08.45-.15.05-.03.11-.06.16-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M62.22,404.75c-.54,0-1.06-.37-1.4-1.03-.65-1.23-.59-2.63-.53-3.98l.02-.39c.05-1.26-.01-2.82-.94-3.79-.19-.19-.46-.34-.6-.25-.15.1-.36.05-.46-.1-.1-.15-.05-.36.1-.46.47-.3,1.06-.04,1.44.35,1.11,1.15,1.18,2.89,1.13,4.28l-.02.39c-.06,1.27-.11,2.58.45,3.64.08.16.39.68.81.68,0,0,0,0,.01,0,.18,0,.33.15.33.33,0,.18-.14.33-.33.34,0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M52.76,386.48c.23,1.01.41,2.05.41,3.11,0,1.71-.5,3.23-1.41,4.29-.32.36-.67.67-1.04.96-.17.13-.34.26-.51.39-.06.04-.13.07-.2.07-.1,0-.2-.05-.27-.14-.11-.15-.08-.36.07-.46.19-.14.38-.29.57-.44.32-.25.62-.52.87-.81.81-.93,1.25-2.3,1.25-3.85,0-.79-.11-1.58-.27-2.36l.52-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M87.43,437.52c-.06.12-.18.2-.31.2-.04,0-.09-.01-.13-.03-2.72-1.2-4.49-4.23-4.2-7.19.15-1.43.72-2.77,1.27-4.06l.22-.5c1.27-3.01,1.88-5.36,1.97-7.61.26-6.66-2.49-9.08-5.14-11.43-1.72-1.52-3.5-3.1-4.4-5.76-1.05-3.1-.06-7.68,2.26-10.42.15-.17.3-.34.45-.49,0,.06,0,.11,0,.17,0,.03,0,.06,0,.1,0,0,.31-.08.79-.11-.28.25-.53.51-.74.76-2.14,2.53-3.1,6.91-2.14,9.77.85,2.5,2.48,3.95,4.21,5.48.63.56,1.26,1.11,1.86,1.73h0c.15.16.31.32.45.49h0c1.83,2.04,3.23,4.76,3.04,9.74-.09,2.33-.71,4.75-2.02,7.84l-.22.51c-.53,1.24-1.09,2.53-1.22,3.86-.27,2.69,1.33,5.43,3.8,6.52.17.07.24.27.17.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M58.92,431.36c-.02,1.02-.12,1.85-.32,2.59-.21-.17-.4-.35-.56-.53.12-.6.19-1.27.21-2.07.08-3.43-.83-6.55-2.55-8.79-.75-.97-1.69-1.83-2.61-2.67-1.21-1.11-2.47-2.25-3.33-3.7-.27-.44-.43-.85-.5-1.23-.06-.33-.06-.64.02-.93.05-.18.23-.28.41-.24.18.05.28.23.24.41-.06.22-.06.46,0,.72.07.28.2.59.4.92.81,1.37,1.97,2.43,3.2,3.55.93.85,1.9,1.73,2.68,2.75,1.81,2.35,2.77,5.62,2.69,9.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M100.67,429.37c-.06,1.43-.44,2.95-1.17,4.64-.7,1.63-1.64,3.27-2.96,5.18-.13.18-.25.36-.38.54-.19.27-.38.54-.57.81-.28.02-.56.03-.83.05.28-.43.57-.84.85-1.24.13-.18.25-.36.38-.54,1.3-1.87,2.22-3.48,2.9-5.06.69-1.62,1.06-3.06,1.11-4.41.05-1.28-.19-2.48-.69-3.5-.13-.27-.28-.52-.44-.76-.11-.15-.07-.36.08-.46.15-.11.36-.07.46.08.19.28.37.57.51.88.53,1.1.79,2.41.74,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M91.65,433.49c-.11,0-.22-.05-.28-.15-1.75-2.68-2.38-5.65-1.73-8.15.21-.79.54-1.55.86-2.28l.15-.34c.83-1.92,1.79-4.46,1.84-7.11.04-2.67-.89-5.05-2.56-6.54-.44-.39-.87-.66-1.3-.82-.53-.19-1.12-.23-1.67-.24-.66-.01-1.44.01-2.16.25-.39.13-.74.32-1.02.56-.14.12-.35.1-.47-.04-.12-.14-.1-.35.04-.47.35-.29.77-.53,1.24-.69.81-.27,1.66-.3,2.38-.29.61,0,1.26.05,1.89.27.51.18,1.01.49,1.51.94,1.81,1.61,2.83,4.18,2.78,7.04-.04,2.77-1.03,5.4-1.89,7.37l-.15.34c-.31.71-.63,1.43-.82,2.18-.6,2.32,0,5.1,1.64,7.62.1.15.06.36-.1.46-.06.04-.12.05-.18.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M47.81,404.67c-.07.43-.31.7-.62.7-.02,0-.05,0-.08,0-.18-.03-.31-.19-.28-.38.02-.15.14-.27.29-.28.01-.03.03-.08.04-.14.31-1.96.34-3.67.09-5.23-.27-1.76-.92-3.33-1.87-4.56.1-.09.19-.17.26-.23.12-.1.2-.18.24-.21,1.04,1.33,1.73,3.01,2.03,4.89.26,1.63.23,3.4-.1,5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M72.75,385.78c-.66.56-1.27,1.34-1.81,2.33-1.24,2.28-1.8,4.83-1.56,7.18.02.18-.12.35-.3.36-.01,0-.02,0-.03,0-.17,0-.31-.13-.33-.3-.25-2.49.33-5.17,1.64-7.57.59-1.08,1.26-1.93,2-2.54.15.17.28.34.4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M79.8,426.24c-.57,2.81-2.64,5.31-5.27,6.36-1.11.44-2.33.67-3.68.67-1.37,0-2.88-.23-4.53-.68-2.23-.61-3.86-1.42-5.03-2.51-.28-.26-.54-.53-.77-.82-.11-.14-.09-.35.05-.47.14-.11.35-.09.47.05.22.28.46.53.73.78,1.1,1,2.63,1.75,4.73,2.33,3.14.86,5.69.88,7.79.04,2.43-.97,4.34-3.27,4.87-5.88.53-2.58-.27-5.41-2.07-7.39-1.35-1.48-3.18-2.46-4.96-3.41-1.84-.99-3.74-2.01-5.17-3.59-1.68-1.86-2.69-4.57-2.84-7.62-.02-.3-.02-.59-.02-.89,0-.08,0-.16,0-.24.02-2.36.47-4.71.94-6.94.84-4.03,1.86-8.29,3.58-12.3.24,0,.48,0,.71.03-1.76,4.03-2.79,8.33-3.65,12.41-.46,2.19-.9,4.5-.93,6.79,0,.26,0,.52,0,.79,0,.11,0,.22.01.33.15,2.9,1.09,5.46,2.67,7.2,1.35,1.49,3.2,2.49,4.99,3.44,1.83.98,3.71,1.99,5.14,3.55.95,1.04,1.64,2.3,2.03,3.64.07.23.13.47.18.7.25,1.2.27,2.44.03,3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M66.6,404.18c-.91,0-1.78-.28-2.42-.83-.14-.12-.16-.33-.04-.47.12-.14.33-.16.47-.04,1.09.92,2.69.79,3.79.24,1.06-.52,2-1.46,2.96-2.94,2.31-3.59,3.36-8.09,2.86-12.33-.02-.18.11-.35.29-.37.18-.02.35.11.37.29.52,4.46-.54,8.99-2.96,12.76-1.02,1.59-2.05,2.6-3.22,3.18-.67.33-1.39.5-2.09.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M79.48,422.73c-.11,0-.22-.05-.28-.15-.1-.15-.06-.36.1-.46,1.12-.74,1.86-2.14,1.92-3.66.05-1.33-.37-2.78-1.23-4.17-.82-1.33-1.93-2.48-2.92-3.46-.95-.95-2.1-2.05-3.35-2.96-.15-.11-.18-.32-.07-.46.11-.15.32-.18.46-.07,1.28.94,2.45,2.06,3.42,3.03,1.01,1,2.16,2.19,3.01,3.58.93,1.51,1.39,3.08,1.33,4.55-.07,1.73-.92,3.34-2.22,4.19-.06.04-.12.05-.18.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M83.38,440.52s-.02,0-.04,0c-.63-.07-1.26-.41-1.91-1.03-1.75-1.69-2.64-4.23-2.33-6.64.02-.18.19-.31.37-.29.18.02.31.19.29.37-.28,2.2.54,4.53,2.13,6.08.54.52,1.04.8,1.52.85.18.02.32.18.3.37-.02.17-.16.3-.33.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M67.07,422.06c-1.09,0-2.22-.31-3.25-.9-1.27-.74-2.39-1.92-3.26-3.42-.09-.16-.04-.36.12-.45.16-.09.36-.04.45.12.81,1.4,1.85,2.5,3.02,3.18,1.33.77,2.85,1.01,4.18.65.18-.05.36.05.41.23.05.18-.06.36-.23.41-.46.13-.95.19-1.44.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M53.85,427.59c-.14,0-.28-.09-.32-.24-.93-3.09-3.38-5.7-6.41-6.81-.17-.06-.26-.25-.2-.43.06-.17.25-.26.43-.2,3.22,1.18,5.83,3.96,6.81,7.24.05.18-.05.36-.22.41-.03,0-.06.01-.1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M94.79,409.93c0,.18-.15.33-.33.33h0c-.19,0-.33-.16-.33-.34,0-.31,0-.62-.05-.93h0c-.08-.62-.26-1.23-.53-1.8-.92-1.95-2.81-3.26-4.35-4.19l-.26-.15c-.76-.46-1.55-.92-2.15-1.62-.37-.43-.69-.96-.97-1.64-.36-.86-.51-1.62-.46-2.32.04-.64.24-1.23.54-1.78.05.24.08.47.12.72.09,0,.18,0,.28,0-.15.35-.24.72-.27,1.1-.04.59.1,1.25.42,2.02.25.61.53,1.08.86,1.46.53.61,1.27,1.06,1.99,1.48l.26.16c1.62.97,3.61,2.36,4.61,4.47.31.65.51,1.34.59,2.05h0c.04.32.06.65.05.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M81.91,402.29c.07-.03.13-.08.16-.15.73-1.45.91-3.18.48-4.75-.42-1.57-1.45-2.98-2.81-3.86-.66-.43-1.26-.63-1.84-.62-.18,0-.33.16-.32.34,0,.18.16.33.34.32.43-.01.91.15,1.46.51,1.23.8,2.15,2.07,2.53,3.48.38,1.41.22,2.97-.43,4.28-.08.16-.02.36.15.45.09.05.2.05.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M70.83,418.09s-.01,0-.02,0c-2.24-.13-4.45-1.1-6.06-2.67-.96-.94-1.72-2.08-2.46-3.19-1.08-1.63-2.1-3.16-3.7-4.07-.73-.42-1.6-.71-2.74-.92-.76-.14-1.74-.26-2.57.08-.7.29-1.33,1.04-1.19,1.81.03.18-.09.35-.27.39-.18.03-.35-.09-.39-.27-.21-1.14.66-2.16,1.59-2.55.99-.41,2.09-.28,2.94-.12,1.21.22,2.15.54,2.95,1,1.73.99,2.84,2.66,3.92,4.28.72,1.08,1.46,2.19,2.37,3.08,1.49,1.46,3.55,2.36,5.63,2.48.18.01.32.17.31.35,0,.18-.16.31-.33.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M90.5,441.39c-.08,0-.16-.03-.22-.09-.14-.12-.15-.33-.02-.47.6-.66.77-1.76.43-2.81-.32-1-1.01-1.87-1.71-2.66-.11-.13-.23-.26-.35-.39-.63-.7-1.28-1.42-1.76-2.27-.75-1.33-.97-2.89-.62-4.27.43-1.71,1.79-3.16,3.47-3.71.18-.06.36.04.42.21.06.17-.04.36-.21.42-1.46.48-2.65,1.75-3.03,3.24-.31,1.22-.1,2.59.56,3.78.44.78,1.06,1.48,1.67,2.15.12.13.23.26.35.39.75.85,1.49,1.78,1.85,2.89.41,1.29.19,2.61-.57,3.46-.07.07-.16.11-.25.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M102.82,421.67c-.05.22-.08.44-.08.66-1.46-.13-2.9-.62-4.12-1.41-1.74-1.13-3.08-2.91-3.68-4.9-.05-.17.05-.36.22-.41.18-.05.36.04.41.22.56,1.84,1.8,3.49,3.41,4.53.13.08.25.16.39.24.2.11.41.22.62.32.89.41,1.86.67,2.83.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M93.43,436.35c-.1,0-.2-.04-.26-.13-.11-.14-.09-.35.06-.47,1.51-1.18,2.49-3.1,2.67-5.27.16-1.88-.26-3.9-1.23-5.98,0,0,0,0,0,0-.1,0-.2-.03-.28-.11-.12-.14-.11-.35.02-.47.11-.1.25-.14.39-.11.22.04.39.24.46.41,1.02,2.19,1.46,4.32,1.29,6.32-.2,2.35-1.26,4.44-2.92,5.74-.06.05-.13.07-.2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M61.93,383.28c-.23,1.46-.58,2.69-1.05,3.79-.76,1.79-1.9,3.24-3.27,4.19-.06.04-.12.06-.19.06-.11,0-.21-.05-.27-.14-.11-.15-.07-.36.08-.47,1.27-.88,2.33-2.23,3.04-3.9.45-1.05.77-2.22,1-3.6.22.02.44.04.67.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M43.78,416.84h0c.24-.59.52-1.18.84-1.74.78-1.34,1.72-2.36,2.82-3.03.57-.35,1.15-.58,1.71-.67.18-.03.3-.2.27-.38-.03-.18-.2-.3-.38-.27-.64.11-1.3.36-1.94.76-1.19.73-2.21,1.83-3.05,3.27-.23.39-.43.79-.61,1.19l.34.88Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M75.27,435.61c.02,1.73-.87,3.55-2.43,4.91-.26.22-.52.43-.8.63-.19-.1-.37-.21-.54-.35-.02-.01-.03-.03-.06-.06.34-.22.65-.46.96-.72,1.11-.96,2.18-2.53,2.2-4.27,0-.27-.01-.54-.06-.82-.03-.18.09-.35.27-.39.18-.03.35.09.39.27.04.26.07.53.07.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M55.38,405.03c-.18,0-.33-.14-.33-.32-.05-1.65.32-3.3,1.08-4.78.17-.32.45-.76.94-.83.18-.03.35.1.37.28.02.18-.1.35-.28.37-.14.02-.28.17-.44.48-.71,1.37-1.05,2.91-1.01,4.45,0,.18-.14.34-.32.34,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M73.5,412.94c-.11,0-.22-.05-.28-.16-1.31-2.08-3.13-3.83-5.26-5.07-.16-.09-.21-.3-.12-.45s.3-.21.45-.12c2.22,1.28,4.12,3.11,5.49,5.29.1.16.05.36-.1.46-.05.03-.12.05-.18.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M74.04,408.64c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M75.01,424.37c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M60.84,430.19c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M49.6,414.99c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M50.98,406.15c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M70.89,418.83c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M94.5,411.13c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M81.69,403.01c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M90.46,442.2c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M74.76,435.76c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M94.9,425.25c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M50.9,396.18c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M94.1,437.74c-.14.23-.35.46-.52.71-.14.19-.26.39-.31.6,0,.03-.01.06-.02.1-.1.76.35,1.42.12,2.25-.23.82-.75,1.54-1.31,2.19-.28.33-.58.65-.97.85-.39.2-.87.24-1.24.01,0,.15-.02.3-.04.45h0c-.05.35-.15.68-.3.99-.39.86-1.09,1.58-1.92,2.03-.79.43-1.69.62-2.59.62-.6.01-1.31-.2-1.94-.13-.15.01-.29.04-.43.09-.16.06-.29.17-.41.29t0,0s-.02.02-.02.02c-.1.1-.2.19-.3.29-.35.34-.71.68-1.1.98-.73.58-1.53,1.04-2.44,1.12-1.32.12-2.57-.57-3.72-1.23-1.44,1.38-4.01,1.33-5.39-.11-1.01.68-2.34.84-3.49.44-.53-.19-1.02-.5-1.42-.89-.16-.16-.34-.51-.52-.81-.15-.25-.3-.48-.44-.55-.06-.03-.13-.04-.21-.04-.57.02-1.56.83-2.17.89-.62.06-1.24-.06-1.79-.35-.19-.1-.37-.21-.54-.35-.02-.01-.03-.03-.06-.06-.18-.22-.55-.88-.82-1.42h0c-.21-.42-.35-.75-.3-.75-.11-.02-.21-.04-.32-.06-5.27-1.02-4.57-4.57-4.57-4.57-3.02,1.71-5.41,1.14-6.83,0-.21-.17-.4-.35-.56-.53-.15-.16-.27-.33-.38-.5-.28-.43-.45-.86-.49-1.25-.02-.16-.01-.31,0-.44-2.14.81-4.57.28-6.33-1.1-.68-.53-1.09-3-1.09-3,0,0-.56-.11-1.51-.56-1.68-.81-3.1-1.95-3.96-3.7-.9-1.82-1.07-4.03-.5-6.02h0c.05-.19.11-.36.18-.54-.18-.1-.35-.22-.52-.34-.98-.72-1.76-1.74-2.01-2.97-.21-.97-.03-2.07.51-2.91.35-.55.95-1.44,1.15-1.74.04-.06.07-.1.07-.1,0,0-.03-.1-.07-.26-.05-.16-.12-.39-.2-.64,0-.04-.02-.08-.04-.12-.17-.53-.39-1.14-.6-1.54-1.28-2.47-1.08-5.73.5-8.08.64-.95,1.92-2.17,2.63-2.83.1-.09.19-.17.26-.23.12-.1.2-.18.24-.21.01-.01.02-.02.02-.02,0,0,.04-.2.11-.53.24-1.09.9-3.58,1.95-4.76,1.34-1.51,3.45-2.35,5.3-1.85.06.01.11.03.17.05.08.02.16.05.24.08.06-.26.14-.51.24-.74.01-.03.02-.05.03-.07v-.02c.75-1.62,2.54-2.65,4.27-3.04.99-.22,2.02-.3,3.03-.23.22.02.44.04.67.07.02,0,.04,0,.06,0,.63.09,1.74.4,2.54.64.02,0,.05.01.07.02.28.08.51.16.67.21.03.01.06.02.09.03.08.02.12.04.12.04,0,0,1.35-.78,2.02-.99.48-.14.96-.22,1.45-.24.24-.01.47-.01.71,0,.42.02.84.08,1.26.16.63.13,1.6.93,2.25,1.53.21.2.39.37.51.48.1.1.15.16.15.16,0,0,2.63-.17,4.63,1.03,1.37.82,2.19,1.99,2.57,2.65.1.18.17.32.22.41.03.06.04.1.04.1,0,0,.14-.04.37-.07.09-.01.19-.02.3-.03,1.01-.1,2.96-.03,4.42,1.56.83.9,1.42,2.01,1.66,3.21,0,.03.01.07.02.1h0c.06.3.09.6.1.9,0,.08,0,.17,0,.26.18-.02.35-.02.53-.02.96,0,1.91.23,2.76.67.58.3,1.13.69,1.59,1.16,1.19,1.22,1.57,2.66,1.84,4.33.05.31.15.56.3.78.14.22.32.41.52.58.55.48,1.24.86,1.68,1.59.63,1.05.84,2.39.55,3.62,1.56.11,3.03,1.05,3.84,2.43.35.6.57,1.29.66,1.99.08.65-.31,1.77-.11,2.32.2.54,1.01.68,1.43,1.01.58.45,1.04,1.07,1.31,1.77.4,1.05.41,2.24.13,3.36-.05.18-.1.37-.16.55-.07.2-.14.4-.23.59.11,0,.22.03.33.06,0,0,.01,0,.02,0t0,0c.29.1.56.29.79.5,1.03.93,1.71,2.28,1.85,3.72.13,1.36-.15,2.74-.85,3.91Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M62.24,431.15c-.1.07-.22.16-.34.25-.1.08-.21.16-.32.24-1.13.85-3.01,2.09-5.88,2.09-.16,0-.33,0-.5-.01-2.94-.14-5.29-.94-6.98-2.36-2.15-1.81-3.32-4.4-4.45-6.9-.69-1.53-1.41-3.12-2.34-4.5-1.42-2.12-3.36-3.71-5.44-4.48-1.91-.71-3.98-.73-5.74-.08-.05-.16-.12-.39-.2-.64,1.9-.69,4.12-.67,6.17.09.83.3,1.62.73,2.38,1.25.23.16.46.33.68.51,1.01.81,1.93,1.82,2.71,2.97.96,1.43,1.69,3.04,2.4,4.6,1.15,2.55,2.24,4.96,4.28,6.67,1.57,1.33,3.79,2.07,6.58,2.2,2.89.14,4.72-1.03,5.9-1.9.13-.1.25-.19.37-.28.13-.1.24-.19.35-.27.15-.11.36-.07.46.07.11.15.08.36-.07.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M52.43,391.57c0,2.41-.91,4.97-2.63,7.23-.96,1.26-2.11,2.37-3.32,3.35-.27.21-.54.43-.81.63-.98.74-1.98,1.41-2.94,2.02l-.18.12c-.66.42-1.35.86-1.94,1.39-1.41,1.27-2.26,3.17-2.32,5.07-.01.4,0,.79.07,1.19.03.18-.1.35-.28.38-.02,0-.03,0-.05,0-.16,0-.31-.12-.33-.29-.06-.4-.09-.8-.08-1.2.02-2.13.94-4.22,2.54-5.66.63-.56,1.34-1.02,2.03-1.46l.18-.11c2.35-1.5,5-3.36,6.89-5.84,1.67-2.2,2.55-4.7,2.49-7.03.28.08.51.16.67.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M49.39,412.17c-.54,0-1.06-.38-1.4-1.03-.65-1.23-.59-2.63-.53-3.98l.02-.39c.05-1.26-.01-2.82-.94-3.79-.19-.19-.46-.34-.6-.25-.15.1-.36.05-.46-.1-.1-.15-.05-.36.1-.46.47-.3,1.06-.04,1.44.35,1.1,1.15,1.18,2.89,1.13,4.28l-.02.39c-.06,1.27-.11,2.58.45,3.64.08.16.39.68.81.68,0,0,0,0,.01,0,.18,0,.33.15.33.33,0,.18-.14.33-.33.34,0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M41.13,393.9c.23,1.01.41,2.05.41,3.11,0,1.71-.5,3.23-1.41,4.29-.32.36-.67.67-1.04.96-.17.13-.34.26-.51.39-.06.04-.13.07-.2.07-.1,0-.2-.05-.27-.14-.11-.15-.08-.36.07-.46.19-.14.38-.29.57-.44.32-.25.62-.52.87-.81.81-.93,1.25-2.3,1.25-3.85,0-.79-.11-1.58-.27-2.36l.52-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M74.6,444.93c-.06.12-.18.2-.31.2-.04,0-.09-.01-.13-.03-2.73-1.2-4.49-4.23-4.2-7.19.14-1.43.72-2.77,1.27-4.06l.22-.5c1.27-3.01,1.88-5.36,1.97-7.61.26-6.66-2.49-9.08-5.14-11.43-1.72-1.52-3.5-3.1-4.4-5.76-1.05-3.11-.06-7.68,2.26-10.42.62-.74,1.31-1.31,2.05-1.71.1.18.17.32.22.41.03.06.04.1.04.1,0,0,.14-.04.37-.07-.93.43-1.65,1.09-2.18,1.71-2.15,2.53-3.1,6.91-2.14,9.77.85,2.5,2.48,3.95,4.21,5.48.63.56,1.27,1.12,1.86,1.73.16.16.31.32.46.49,1.83,2.04,3.23,4.75,3.04,9.73-.09,2.34-.71,4.75-2.02,7.84l-.22.51c-.53,1.24-1.09,2.53-1.22,3.86-.27,2.69,1.33,5.43,3.8,6.52.17.07.24.27.17.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M46.09,438.77c-.02,1.02-.12,1.85-.32,2.59-.21-.17-.4-.35-.56-.53.12-.6.19-1.27.21-2.07.08-3.43-.83-6.55-2.55-8.79-.75-.97-1.69-1.83-2.61-2.67-1.21-1.11-2.47-2.25-3.33-3.7-.27-.44-.43-.85-.5-1.23-.06-.33-.06-.64.02-.93.05-.18.23-.28.41-.24.18.05.28.23.24.41-.06.22-.06.46,0,.72.07.28.2.59.4.92.81,1.37,1.97,2.43,3.2,3.55.93.85,1.9,1.73,2.68,2.75,1.81,2.35,2.77,5.62,2.69,9.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M87.84,436.79c-.06,1.43-.44,2.95-1.17,4.64-.7,1.63-1.64,3.27-2.96,5.18-.13.18-.25.36-.38.54-.38.54-.76,1.08-1.11,1.65t0,0s-.02.02-.02.02c-.1.1-.2.19-.3.29-.35.34-.71.68-1.1.98.1-.25.22-.51.35-.76.47-.91,1.06-1.75,1.63-2.56.13-.18.25-.36.38-.54,1.3-1.87,2.22-3.48,2.9-5.06.69-1.62,1.06-3.06,1.11-4.41.05-1.27-.19-2.48-.69-3.5-.13-.27-.28-.52-.44-.75-.11-.15-.07-.36.08-.46.15-.11.36-.07.46.08.19.28.37.57.51.88.53,1.1.79,2.41.74,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M78.82,440.9c-.11,0-.22-.05-.28-.15-1.75-2.68-2.38-5.65-1.73-8.15.21-.79.54-1.55.86-2.28l.15-.34c.83-1.92,1.79-4.46,1.84-7.11.04-2.67-.89-5.05-2.56-6.54-.44-.39-.87-.66-1.3-.82-.53-.19-1.12-.23-1.67-.23-.66-.01-1.44.01-2.16.25-.39.13-.74.32-1.02.56-.14.12-.35.1-.47-.04-.12-.14-.1-.35.04-.47.35-.29.77-.53,1.24-.69.81-.27,1.66-.3,2.38-.29.61,0,1.26.05,1.89.27.51.18,1.01.49,1.51.95,1.81,1.61,2.83,4.18,2.78,7.04-.04,2.77-1.03,5.39-1.89,7.37l-.15.34c-.31.71-.63,1.43-.82,2.18-.6,2.32,0,5.1,1.64,7.62.1.15.06.36-.1.46-.06.04-.12.05-.18.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M34.98,412.09c-.07.43-.31.7-.62.7-.02,0-.05,0-.08,0-.18-.03-.31-.19-.28-.38.02-.15.14-.27.29-.28.01-.03.03-.08.04-.14.31-1.96.34-3.67.1-5.23-.27-1.76-.92-3.32-1.87-4.55.1-.09.19-.17.26-.23.12-.1.2-.18.24-.21,1.04,1.33,1.73,3.01,2.03,4.89.26,1.63.23,3.4-.1,5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M60.83,392.58c-1.03.51-1.94,1.5-2.73,2.94-1.24,2.28-1.8,4.83-1.56,7.18.02.18-.12.35-.3.36-.01,0-.02,0-.03,0-.17,0-.31-.13-.33-.3-.25-2.48.33-5.17,1.64-7.57.8-1.46,1.74-2.51,2.8-3.11.21.2.39.37.51.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M58.01,440.69c-1.37,0-2.88-.23-4.53-.68-2.76-.76-4.6-1.82-5.8-3.33-.11-.14-.09-.35.05-.47.14-.11.35-.09.47.05,1.11,1.4,2.84,2.38,5.45,3.1,3.14.87,5.69.88,7.79.04,2.43-.97,4.34-3.27,4.87-5.88.53-2.58-.27-5.41-2.07-7.39-1.35-1.48-3.18-2.46-4.96-3.41-1.84-.99-3.74-2.01-5.17-3.59-1.68-1.86-2.69-4.57-2.84-7.62-.14-2.73.38-5.49.92-8.07.91-4.34,2.02-8.95,4-13.23.08-.17.27-.24.44-.16.17.08.24.27.16.44-1.95,4.22-3.05,8.79-3.95,13.09-.53,2.54-1.04,5.25-.91,7.9.14,2.9,1.09,5.46,2.67,7.2,1.35,1.49,3.2,2.49,4.99,3.45,1.83.98,3.71,1.99,5.14,3.55,1.95,2.13,2.8,5.19,2.23,7.97-.57,2.81-2.64,5.31-5.27,6.36-1.11.44-2.33.67-3.68.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M53.77,411.59c-.91,0-1.78-.28-2.42-.83-.14-.12-.16-.33-.04-.47.12-.14.33-.16.47-.04,1.09.92,2.69.79,3.79.24,1.06-.52,2-1.46,2.96-2.94,2.31-3.59,3.35-8.08,2.86-12.33-.02-.18.11-.35.29-.37.18-.02.35.11.37.29.52,4.46-.54,8.99-2.96,12.76-1.02,1.59-2.05,2.6-3.22,3.18-.67.33-1.39.5-2.09.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M66.65,430.15c-.11,0-.22-.05-.28-.15-.1-.15-.06-.36.1-.46,1.12-.74,1.86-2.14,1.92-3.66.05-1.33-.37-2.78-1.23-4.17-.82-1.33-1.93-2.48-2.92-3.46-.95-.95-2.1-2.05-3.35-2.96-.15-.11-.18-.32-.07-.46.11-.15.32-.18.46-.07,1.28.94,2.45,2.06,3.42,3.03,1.01,1,2.16,2.19,3.01,3.58.93,1.51,1.39,3.08,1.33,4.55-.07,1.73-.92,3.34-2.22,4.19-.06.04-.12.05-.18.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M70.55,447.93s-.02,0-.04,0c-.63-.07-1.26-.41-1.91-1.03-1.75-1.69-2.64-4.23-2.33-6.64.02-.18.19-.31.37-.29.18.02.31.19.29.37-.28,2.2.54,4.53,2.13,6.08.54.52,1.04.8,1.52.85.18.02.32.18.3.37-.02.17-.16.3-.33.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M54.24,429.48c-1.09,0-2.22-.31-3.25-.9-1.27-.74-2.39-1.92-3.26-3.42-.09-.16-.04-.36.12-.45.16-.09.36-.04.45.12.81,1.4,1.85,2.5,3.02,3.18,1.33.77,2.85,1.01,4.18.65.18-.05.36.05.41.23.05.18-.06.36-.23.41-.46.13-.95.19-1.44.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M41.02,435c-.14,0-.28-.09-.32-.24-.93-3.09-3.38-5.7-6.41-6.81-.17-.06-.26-.25-.2-.43.06-.17.25-.26.43-.2,3.22,1.18,5.83,3.96,6.81,7.24.05.18-.05.36-.22.41-.03,0-.06.01-.1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M82.96,417.68c0,.18-.15.33-.33.33h0c-.19,0-.33-.16-.33-.34,0-.31-.01-.62-.05-.92-.08-.62-.26-1.23-.53-1.8-.92-1.95-2.81-3.26-4.35-4.19l-.26-.15c-.76-.45-1.55-.92-2.15-1.62-.37-.43-.69-.96-.97-1.64-.36-.86-.51-1.62-.46-2.32.09-1.28.8-2.34,1.7-3.34.06.3.09.6.1.9-.62.77-1.08,1.58-1.14,2.49-.04.59.1,1.25.41,2.02.25.61.53,1.08.86,1.46.53.61,1.27,1.06,1.99,1.48l.26.16c1.62.97,3.61,2.36,4.61,4.47.31.65.51,1.34.59,2.05.04.32.06.65.05.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M69.77,410.69c-.07,0-.15-.02-.21-.08-1.26-1.03-2.13-2.53-2.38-4.14-.25-1.6.1-3.31.98-4.67.43-.66.89-1.09,1.43-1.31.17-.07.36.01.43.18.07.17-.01.36-.18.43-.4.17-.77.51-1.12,1.06-.79,1.23-1.12,2.76-.89,4.21.23,1.44,1.01,2.8,2.14,3.73.14.12.16.33.05.47-.07.08-.16.12-.26.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M58,425.5s-.01,0-.02,0c-2.24-.13-4.45-1.1-6.06-2.67-.96-.94-1.72-2.08-2.46-3.19-1.08-1.63-2.1-3.16-3.7-4.07-.73-.42-1.6-.71-2.74-.92-.76-.14-1.74-.26-2.57.08-.7.29-1.33,1.04-1.19,1.81.03.18-.09.35-.27.39-.18.03-.35-.09-.39-.27-.21-1.14.66-2.16,1.59-2.55.99-.41,2.09-.28,2.94-.12,1.21.22,2.15.54,2.95.99,1.73.99,2.84,2.66,3.92,4.28.72,1.08,1.46,2.19,2.37,3.08,1.5,1.46,3.55,2.36,5.63,2.48.18.01.32.17.31.35-.01.18-.16.31-.33.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M77.67,448.81c-.08,0-.16-.03-.22-.09-.14-.12-.15-.33-.02-.47.6-.66.77-1.76.43-2.81-.32-1-1.01-1.87-1.71-2.66-.11-.13-.23-.26-.35-.39-.63-.7-1.28-1.42-1.76-2.27-.75-1.33-.97-2.89-.62-4.27.43-1.71,1.79-3.16,3.47-3.71.18-.06.36.04.42.21.06.17-.04.36-.21.42-1.46.48-2.65,1.75-3.03,3.24-.31,1.22-.1,2.59.56,3.78.44.78,1.06,1.48,1.67,2.15.12.13.23.26.35.39.75.84,1.49,1.78,1.85,2.89.41,1.29.19,2.61-.57,3.46-.07.07-.16.11-.25.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M92.3,429.63c-.18.03-.36.06-.55.09-.35.04-.7.06-1.04.06-1.73,0-3.48-.51-4.92-1.45-1.74-1.13-3.08-2.91-3.68-4.9-.05-.17.05-.36.22-.41.18-.05.36.04.42.22.56,1.84,1.8,3.49,3.41,4.53.13.08.25.16.39.24.2.11.41.22.62.32,1.4.65,3,.91,4.52.73.15-.02.32-.05.51-.09-.07.2-.14.4-.23.59.11,0,.22.03.33.06,0,0,.01,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M80.6,443.77c-.1,0-.2-.04-.26-.13-.11-.14-.09-.35.06-.47,1.51-1.18,2.49-3.1,2.67-5.27.15-1.81-.23-3.75-1.12-5.75-.03-.08-.49-.53-.33-.79.09-.14.23-.16.37-.13.22.04.39.24.46.41,1.02,2.19,1.46,4.32,1.29,6.32-.2,2.35-1.26,4.44-2.92,5.74-.06.05-.13.07-.2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M49.09,390.7c-.23,1.46-.58,2.69-1.05,3.79-.76,1.79-1.9,3.24-3.27,4.19-.06.04-.12.06-.19.06-.11,0-.21-.05-.27-.14-.11-.15-.07-.36.08-.47,1.27-.88,2.33-2.23,3.04-3.9.45-1.05.77-2.22,1-3.6.22.02.44.04.67.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M30.95,424.26h0c.24-.59.52-1.18.84-1.74.78-1.34,1.72-2.36,2.82-3.03.57-.35,1.15-.58,1.71-.67.18-.03.3-.2.27-.38-.03-.18-.2-.3-.38-.27-.64.11-1.3.36-1.95.76-1.19.73-2.21,1.83-3.05,3.27-.23.39-.43.79-.61,1.19l.34.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M93.57,438.46c-.14.19-.26.39-.31.6-1.17-.81-2.13-1.92-2.72-3.22-.4-.88-.53-1.65-.4-2.35.04-.18.21-.3.39-.26.18.04.3.21.27.39-.11.56,0,1.19.35,1.95.53,1.17,1.38,2.16,2.42,2.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M62.43,443.02c.02,1.73-.87,3.55-2.43,4.91-.26.22-.52.43-.8.63-.19-.1-.37-.21-.54-.35-.02-.01-.03-.03-.06-.06.34-.22.65-.46.96-.72,1.11-.96,2.18-2.53,2.2-4.27,0-.27-.01-.54-.06-.82-.03-.18.09-.35.27-.39.18-.03.35.09.39.27.04.26.07.53.07.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M86.72,428.63c-.1,0-.19-.04-.26-.12-.12-.14-.1-.35.04-.47.34-.28.43-.8.48-1.26.24-2.26-.21-4.61-1.27-6.62-.09-.16-.02-.36.14-.45.16-.09.36-.02.45.14,1.12,2.13,1.59,4.61,1.34,7-.06.57-.2,1.27-.72,1.71-.06.05-.14.08-.21.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M42.54,412.45c-.18,0-.33-.14-.33-.32-.05-1.65.32-3.3,1.08-4.78.17-.32.45-.76.94-.83.18-.03.35.1.37.29.02.18-.1.35-.28.37-.14.02-.28.17-.44.48-.71,1.37-1.05,2.91-1.01,4.45,0,.18-.14.34-.32.34,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M60.67,420.35c-.11,0-.22-.05-.28-.16-1.31-2.08-3.13-3.83-5.26-5.07-.16-.09-.21-.3-.12-.45.09-.16.3-.21.45-.12,2.22,1.28,4.12,3.11,5.49,5.29.1.16.05.36-.1.46-.05.03-.12.05-.18.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M89.82,444.91h0c-.05.35-.15.68-.3.99-.29-.53-.44-1.08-.53-1.48-.25-1.08-.33-2.2-.24-3.31.02-.36.07-.72.13-1.08.03-.18.2-.3.39-.27.18.03.3.21.27.39-.06.36-.11.72-.13,1.09-.07,1.01,0,2.05.24,3.03.05.24.11.45.18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M61.21,416.06c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M62.18,431.79c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M48.01,437.61c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16s1.13.44,1.16,1.05c.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M36.77,422.41c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M38.15,413.56c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M58.06,426.24c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M61.76,396.36c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M82.67,418.88c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M77.63,449.62c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M61.93,443.17c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M86.45,433.27c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16s1.13.44,1.16,1.05c.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M89.32,441.24c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M38.07,403.59c-.61.03-1.13-.44-1.16-1.05-.03-.61.44-1.13,1.05-1.16.61-.03,1.13.44,1.16,1.05.03.61-.44,1.13-1.05,1.16Z"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M380.78,146.19l2.28,1.32c-.7-.4-1.66-.35-2.72.27l-2.28-1.32c1.06-.61,2.03-.67,2.72-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M300.48,210.2l-2.28-1.32c-.69-.4-1.11-1.25-1.12-2.45l2.28,1.32c0,1.2.43,2.05,1.12,2.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "299.36 207.74 297.08 206.42 297.06 197.63 299.34 198.95 299.36 207.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "303.15 192.35 300.87 191.03 378.06 146.46 380.34 147.79 303.15 192.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M299.34,198.95l-2.28-1.32c0-2.43,1.7-5.39,3.81-6.6l2.28,1.32c-2.11,1.22-3.82,4.18-3.81,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M380.34,147.79c2.11-1.22,3.83-.24,3.84,2.19l.02,8.79c0,2.42-1.7,5.38-3.81,6.6l-77.19,44.57c-2.11,1.22-3.83.24-3.84-2.19l-.03-8.79c0-2.43,1.7-5.39,3.81-6.6l77.19-44.56Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M306.71,203.01c-.13,0-.23-.1-.23-.23v-6.99c0-.13.1-.23.23-.23s.23.1.23.23v6.99c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M307.94,204.87c-.13,0-.23-.1-.23-.23v-12.12c0-.13.1-.23.23-.23s.23.1.23.23v12.12c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M309.16,203.43c-.13,0-.23-.1-.23-.23v-10.64c0-.13.1-.23.23-.23s.23.1.23.23v10.64c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M310.38,199.88c-.13,0-.23-.1-.23-.23v-4.96c0-.13.1-.23.23-.23s.23.1.23.23v4.96c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M311.6,199.18c-.13,0-.23-.1-.23-.23v-4.96c0-.13.1-.23.23-.23s.23.1.23.23v4.96c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M312.82,197.64c-.13,0-.23-.1-.23-.23v-3.29c0-.13.1-.23.23-.23s.23.1.23.23v3.29c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M314.05,196.93c-.13,0-.23-.1-.23-.23v-3.29c0-.13.1-.23.23-.23s.23.1.23.23v3.29c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M315.27,196.23c-.13,0-.23-.1-.23-.23v-3.29c0-.13.1-.23.23-.23s.23.1.23.23v3.29c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M316.49,198.89c-.13,0-.23-.1-.23-.23v-10.03c0-.13.1-.23.23-.23s.23.1.23.23v10.03c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M317.71,199.32c-.13,0-.23-.1-.23-.23v-12.3c0-.13.1-.23.23-.23s.23.1.23.23v12.3c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M318.93,197.48c-.13,0-.23-.1-.23-.23v-10.03c0-.13.1-.23.23-.23s.23.1.23.23v10.03c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M320.16,196.17c-.13,0-.23-.1-.23-.23v-8.82c0-.13.1-.23.23-.23s.23.1.23.23v8.82c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M321.38,195.46c-.13,0-.23-.1-.23-.23v-8.82c0-.13.1-.23.23-.23s.23.1.23.23v8.82c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M322.6,193.84c-.13,0-.23-.1-.23-.23v-6.99c0-.13.1-.23.23-.23s.23.1.23.23v6.99c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M323.82,192.61c-.13,0-.23-.1-.23-.23v-5.94c0-.13.1-.23.23-.23s.23.1.23.23v5.94c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M325.05,191.91c-.13,0-.23-.1-.23-.23v-5.94c0-.13.1-.23.23-.23s.23.1.23.23v5.94c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M326.27,190.41c-.13,0-.23-.1-.23-.23v-4.35c0-.13.1-.23.23-.23s.23.1.23.23v4.35c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M327.49,189.7c-.13,0-.23-.1-.23-.23v-4.35c0-.13.1-.23.23-.23s.23.1.23.23v4.35c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M328.71,188.24c-.13,0-.23-.1-.23-.23v-2.84c0-.13.1-.23.23-.23s.23.1.23.23v2.84c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M329.93,186.97c-.13,0-.23-.1-.23-.23v-1.71c0-.13.1-.23.23-.23s.23.1.23.23v1.71c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M331.15,186.83c-.13,0-.23-.1-.23-.23v-2.84c0-.13.1-.23.23-.23s.23.1.23.23v2.84c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M332.38,186.92c-.13,0-.23-.1-.23-.23v-4.43c0-.13.1-.23.23-.23s.23.1.23.23v4.43c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M333.6,186.21c-.13,0-.23-.1-.23-.23v-4.43c0-.13.1-.23.23-.23s.23.1.23.23v4.43c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M301.94,203.13c-.13,0-.23-.1-.23-.23v-1.71c0-.13.1-.23.23-.23s.23.1.23.23v1.71c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M303.16,202.99c-.13,0-.23-.1-.23-.23v-2.84c0-.13.1-.23.23-.23s.23.1.23.23v2.84c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M304.39,203.08c-.13,0-.23-.1-.23-.23v-4.43c0-.13.1-.23.23-.23s.23.1.23.23v4.43c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M305.61,202.37c-.13,0-.23-.1-.23-.23v-4.43c0-.13.1-.23.23-.23s.23.1.23.23v4.43c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M334.82,186.49c-.13,0-.23-.1-.23-.23v-6.39c0-.13.1-.23.23-.23s.23.1.23.23v6.39c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M336.04,185.78c-.13,0-.23-.1-.23-.23v-6.39c0-.13.1-.23.23-.23s.23.1.23.23v6.39c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M337.27,186.03c-.13,0-.23-.1-.23-.23v-8.29c0-.13.1-.23.23-.23s.23.1.23.23v8.29c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M338.49,184.67c-.13,0-.23-.1-.23-.23v-6.99c0-.13.1-.23.23-.23s.23.1.23.23v6.99c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M339.71,185.49c-.13,0-.23-.1-.23-.23v-10.03c0-.13.1-.23.23-.23s.23.1.23.23v10.03c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M340.93,185.73c-.13,0-.23-.1-.23-.23v-11.92c0-.13.1-.23.23-.23s.23.1.23.23v11.92c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M342.15,185.02c-.13,0-.23-.1-.23-.23v-11.92c0-.13.1-.23.23-.23s.23.1.23.23v11.92c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M343.38,183.56c-.13,0-.23-.1-.23-.23v-10.41c0-.13.1-.23.23-.23s.23.1.23.23v10.41c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M344.6,182.85c-.13,0-.23-.1-.23-.23v-10.41c0-.13.1-.23.23-.23s.23.1.23.23v10.41c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M345.82,180.97c-.13,0-.23-.1-.23-.23v-8.06c0-.13.1-.23.23-.23s.23.1.23.23v8.06c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M347.04,179.06c-.13,0-.23-.1-.23-.23v-5.64c0-.13.1-.23.23-.23s.23.1.23.23v5.64c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M348.26,178.35c-.13,0-.23-.1-.23-.23v-5.64c0-.13.1-.23.23-.23s.23.1.23.23v5.64c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M349.49,177.65c-.13,0-.23-.1-.23-.23v-5.64c0-.13.1-.23.23-.23s.23.1.23.23v5.64c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M350.71,176.87c-.13,0-.23-.1-.23-.23v-5.5c0-.13.1-.23.23-.23s.23.1.23.23v5.5c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M351.93,175.48c-.13,0-.23-.1-.23-.23v-4.12c0-.13.1-.23.23-.23s.23.1.23.23v4.12c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M353.15,174.77c-.13,0-.23-.1-.23-.23v-4.12c0-.13.1-.23.23-.23s.23.1.23.23v4.12c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M354.37,172.9c-.13,0-.23-.1-.23-.23v-1.8c0-.13.1-.23.23-.23s.23.1.23.23v1.8c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M355.6,172.64c-.13,0-.23-.1-.23-.23v-2.68c0-.13.1-.23.23-.23s.23.1.23.23v2.68c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M356.82,173.07c-.13,0-.23-.1-.23-.23v-4.96c0-.13.1-.23.23-.23s.23.1.23.23v4.96c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M358.04,172.37c-.13,0-.23-.1-.23-.23v-4.96c0-.13.1-.23.23-.23s.23.1.23.23v4.96c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M359.26,172.68c-.13,0-.23-.1-.23-.23v-6.99c0-.13.1-.23.23-.23s.23.1.23.23v6.99c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M360.48,171.97c-.13,0-.23-.1-.23-.23v-6.99c0-.13.1-.23.23-.23s.23.1.23.23v6.99c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M361.71,172.52c-.13,0-.23-.1-.23-.23v-9.5c0-.13.1-.23.23-.23s.23.1.23.23v9.5c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M362.93,172.9c-.13,0-.23-.1-.23-.23v-11.68c0-.13.1-.23.23-.23s.23.1.23.23v11.68c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M364.15,173.3c-.13,0-.23-.1-.23-.23v-13.88c0-.13.1-.23.23-.23s.23.1.23.23v13.88c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M365.37,172.6c-.13,0-.23-.1-.23-.23v-13.88c0-.13.1-.23.23-.23s.23.1.23.23v13.88c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M366.59,170.88c-.13,0-.23-.1-.23-.23v-11.85c0-.13.1-.23.23-.23s.23.1.23.23v11.85c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M367.82,169.07c-.13,0-.23-.1-.23-.23v-9.65c0-.13.1-.23.23-.23s.23.1.23.23v9.65c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M369.04,167.52c-.13,0-.23-.1-.23-.23v-7.97c0-.13.1-.23.23-.23s.23.1.23.23v7.97c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M370.26,166.82c-.13,0-.23-.1-.23-.23v-7.97c0-.13.1-.23.23-.23s.23.1.23.23v7.97c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M371.48,164.75c-.13,0-.23-.1-.23-.23v-5.24c0-.13.1-.23.23-.23s.23.1.23.23v5.24c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M372.7,163.29c-.13,0-.23-.1-.23-.23v-3.74c0-.13.1-.23.23-.23s.23.1.23.23v3.74c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M373.93,162.58c-.13,0-.23-.1-.23-.23v-3.74c0-.13.1-.23.23-.23s.23.1.23.23v3.74c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M375.15,160.95c-.13,0-.23-.1-.23-.23v-1.89c0-.13.1-.23.23-.23s.23.1.23.23v1.89c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M376.37,160.25c-.13,0-.23-.1-.23-.23v-1.89c0-.13.1-.23.23-.23s.23.1.23.23v1.89c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M377.59,165.32c-.13,0-.23-.1-.23-.23v-13.44c0-.13.1-.23.23-.23s.23.1.23.23v13.44c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M378.82,164.61c-.13,0-.23-.1-.23-.23v-13.44c0-.13.1-.23.23-.23s.23.1.23.23v13.44c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M380.04,162.01c-.13,0-.23-.1-.23-.23v-9.65c0-.13.1-.23.23-.23s.23.1.23.23v9.65c0,.13-.1.23-.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M381.26,161.31c-.13,0-.23-.1-.23-.23v-9.65c0-.13.1-.23.23-.23s.23.1.23.23v9.65c0,.13-.1.23-.23.23Z"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M407.99,158.02l2.1,1.22c-.64-.37-1.53-.32-2.52.25l-2.1-1.22c.98-.57,1.87-.62,2.52-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M333.82,217.13l-2.1-1.22c-.63-.37-1.03-1.15-1.03-2.26l2.1,1.22c0,1.11.4,1.9,1.03,2.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "332.79 214.87 330.68 213.65 330.66 205.53 332.76 206.75 332.79 214.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "336.28 200.65 334.18 199.43 405.48 158.26 407.58 159.49 336.28 200.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M332.76,206.75l-2.1-1.22c0-2.24,1.57-4.98,3.52-6.1l2.1,1.22c-1.95,1.12-3.53,3.86-3.52,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M407.58,159.49c1.95-1.13,3.54-.22,3.55,2.02l.02,8.12c0,2.24-1.57,4.97-3.52,6.1l-71.3,41.17c-1.95,1.12-3.54.22-3.54-2.02l-.02-8.12c0-2.24,1.57-4.98,3.52-6.1l71.3-41.17Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M362.67,197.13c-.12,0-.21-.1-.21-.21v-6.49c0-.12.1-.21.21-.21s.21.1.21.21v6.49c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M363.89,198.8c-.12,0-.21-.1-.21-.21v-11.26c0-.12.1-.21.21-.21s.21.09.21.21v11.26c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M365.11,197.41c-.12,0-.21-.1-.21-.21v-9.88c0-.12.09-.21.21-.21s.21.09.21.21v9.88c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M366.33,194.07c-.12,0-.21-.1-.21-.21v-4.6c0-.12.1-.21.21-.21s.21.1.21.21v4.6c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M367.55,193.36c-.12,0-.21-.1-.21-.21v-4.6c0-.12.1-.21.21-.21s.21.09.21.21v4.6c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M368.77,191.88c-.12,0-.21-.09-.21-.21v-3.06c0-.12.1-.21.21-.21s.21.1.21.21v3.06c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M369.99,191.18c-.12,0-.21-.1-.21-.21v-3.06c0-.12.1-.21.21-.21s.21.1.21.21v3.06c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M371.21,190.48c-.12,0-.21-.1-.21-.21v-3.06c0-.12.1-.21.21-.21s.21.1.21.21v3.06c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M372.43,192.9c-.12,0-.21-.1-.21-.21v-9.32c0-.12.09-.21.21-.21s.21.1.21.21v9.32c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M373.65,193.25c-.12,0-.21-.1-.21-.21v-11.43c0-.12.1-.21.21-.21s.21.1.21.21v11.43c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M374.87,191.49c-.12,0-.21-.09-.21-.21v-9.32c0-.12.1-.21.21-.21s.21.1.21.21v9.32c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M376.1,190.22c-.12,0-.21-.1-.21-.21v-8.19c0-.12.09-.21.21-.21s.21.1.21.21v8.19c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M377.32,189.52c-.12,0-.21-.1-.21-.21v-8.19c0-.12.1-.21.21-.21s.21.1.21.21v8.19c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M378.54,187.96c-.12,0-.21-.09-.21-.21v-6.49c0-.12.09-.21.21-.21s.21.09.21.21v6.49c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M379.76,186.77c-.12,0-.21-.1-.21-.21v-5.52c0-.12.09-.21.21-.21s.21.09.21.21v5.52c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M380.98,186.07c-.12,0-.21-.1-.21-.21v-5.52c0-.12.1-.21.21-.21s.21.1.21.21v5.52c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M382.2,184.62c-.12,0-.21-.1-.21-.21v-4.04c0-.12.09-.21.21-.21s.21.1.21.21v4.04c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M383.42,183.92c-.12,0-.21-.1-.21-.21v-4.04c0-.12.1-.21.21-.21s.21.09.21.21v4.04c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M384.64,182.51c-.12,0-.21-.1-.21-.21v-2.63c0-.12.09-.21.21-.21s.21.1.21.21v2.63c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M385.86,181.28c-.12,0-.21-.1-.21-.21v-1.59c0-.12.1-.21.21-.21s.21.1.21.21v1.59c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M387.08,181.1c-.12,0-.21-.1-.21-.21v-2.63c0-.12.1-.21.21-.21s.21.1.21.21v2.63c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M388.31,181.13c-.12,0-.21-.09-.21-.21v-4.11c0-.12.09-.21.21-.21s.21.09.21.21v4.11c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M389.53,180.43c-.12,0-.21-.09-.21-.21v-4.11c0-.12.1-.21.21-.21s.21.1.21.21v4.11c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M357.9,197.43c-.12,0-.21-.1-.21-.21v-1.59c0-.12.1-.21.21-.21s.21.09.21.21v1.59c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M359.12,197.25c-.12,0-.21-.1-.21-.21v-2.63c0-.12.1-.21.21-.21s.21.1.21.21v2.63c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M360.34,197.28c-.12,0-.21-.1-.21-.21v-4.11c0-.12.1-.21.21-.21s.21.1.21.21v4.11c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M361.56,196.57c-.12,0-.21-.1-.21-.21v-4.11c0-.12.1-.21.21-.21s.21.1.21.21v4.11c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M390.75,180.64c-.12,0-.21-.1-.21-.21v-5.94c0-.12.1-.21.21-.21s.21.09.21.21v5.94c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M391.97,179.93c-.12,0-.21-.1-.21-.21v-5.94c0-.12.1-.21.21-.21s.21.09.21.21v5.94c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M393.19,180.11c-.12,0-.21-.1-.21-.21v-7.7c0-.12.1-.21.21-.21s.21.09.21.21v7.7c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M394.41,178.8c-.12,0-.21-.1-.21-.21v-6.49c0-.12.1-.21.21-.21s.21.09.21.21v6.49c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M395.63,179.51c-.12,0-.21-.1-.21-.21v-9.32c0-.12.09-.21.21-.21s.21.09.21.21v9.32c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M396.85,179.68c-.12,0-.21-.1-.21-.21v-11.08c0-.12.1-.21.21-.21s.21.09.21.21v11.08c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M398.07,178.98c-.12,0-.21-.1-.21-.21v-11.08c0-.12.1-.21.21-.21s.21.09.21.21v11.08c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M399.29,177.57c-.12,0-.21-.1-.21-.21v-9.67c0-.12.09-.21.21-.21s.21.09.21.21v9.67c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M400.51,176.86c-.12,0-.21-.1-.21-.21v-9.67c0-.12.1-.21.21-.21s.21.09.21.21v9.67c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M401.74,175.07c-.12,0-.21-.09-.21-.21v-7.49c0-.12.1-.21.21-.21s.21.09.21.21v7.49c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M402.96,173.24c-.12,0-.21-.09-.21-.21v-5.24c0-.12.09-.21.21-.21s.21.09.21.21v5.24c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M404.18,171.46c-.12,0-.21-.09-.21-.21v-3.09c0-.12.1-.21.21-.21s.21.09.21.21v3.09c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M405.4,170.76c-.12,0-.21-.09-.21-.21v-3.09c0-.12.1-.21.21-.21s.21.09.21.21v3.09c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M406.62,171.06c-.12,0-.21-.09-.21-.21v-5.11c0-.12.09-.21.21-.21s.21.09.21.21v5.11c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M407.84,168.6c-.12,0-.21-.09-.21-.21v-1.59c0-.12.1-.21.21-.21s.21.09.21.21v1.59c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M409.06,167.89c-.12,0-.21-.09-.21-.21v-1.59c0-.12.09-.21.21-.21s.21.09.21.21v1.59c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M334.61,210.92c-.12,0-.21-.1-.21-.21v-1.67c0-.12.1-.21.21-.21s.21.09.21.21v1.67c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M335.83,210.62c-.12,0-.21-.1-.21-.21v-2.49c0-.12.1-.21.21-.21s.21.1.21.21v2.49c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M337.05,210.97c-.12,0-.21-.1-.21-.21v-4.6c0-.12.1-.21.21-.21s.21.1.21.21v4.6c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M338.27,210.27c-.12,0-.21-.1-.21-.21v-4.6c0-.12.1-.21.21-.21s.21.1.21.21v4.6c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M339.49,210.51c-.12,0-.21-.1-.21-.21v-6.49c0-.12.1-.21.21-.21s.21.1.21.21v6.49c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M340.71,209.8c-.12,0-.21-.1-.21-.21v-6.49c0-.12.1-.21.21-.21s.21.1.21.21v6.49c0,.12-.09.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M341.93,210.26c-.12,0-.21-.1-.21-.21v-8.82c0-.12.1-.21.21-.21s.21.1.21.21v8.82c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M343.15,210.57c-.12,0-.21-.1-.21-.21v-10.85c0-.12.1-.21.21-.21s.21.1.21.21v10.85c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M344.37,210.89c-.12,0-.21-.1-.21-.21v-12.89c0-.12.1-.21.21-.21s.21.1.21.21v12.89c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M345.59,210.18c-.12,0-.21-.1-.21-.21v-12.9c0-.12.1-.21.21-.21s.21.1.21.21v12.9c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M346.82,208.54c-.12,0-.21-.1-.21-.21v-11.01c0-.12.1-.21.21-.21s.21.09.21.21v11.01c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M348.04,206.81c-.12,0-.21-.1-.21-.21v-8.96c0-.12.1-.21.21-.21s.21.1.21.21v8.96c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M349.26,205.32c-.12,0-.21-.09-.21-.21v-7.41c0-.12.1-.21.21-.21s.21.1.21.21v7.41c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M350.48,204.62c-.12,0-.21-.09-.21-.21v-7.4c0-.12.1-.21.21-.21s.21.1.21.21v7.4c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M351.7,202.65c-.12,0-.21-.1-.21-.21v-4.87c0-.12.1-.21.21-.21s.21.1.21.21v4.87c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M352.92,201.24c-.12,0-.21-.1-.21-.21v-3.47c0-.12.1-.21.21-.21s.21.1.21.21v3.47c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M354.14,200.54c-.12,0-.21-.1-.21-.21v-3.47c0-.12.09-.21.21-.21s.21.1.21.21v3.47c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M355.36,198.97c-.12,0-.21-.1-.21-.21v-1.75c0-.12.1-.21.21-.21s.21.1.21.21v1.75c0,.12-.1.21-.21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M356.58,198.27c-.12,0-.21-.09-.21-.21v-1.75c0-.12.09-.21.21-.21s.21.1.21.21v1.75c0,.12-.1.21-.21.21Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi2);
export default __webpack_public_path__ + "static/media/ai2.9ee3e09feb6c1f06d320e7275943d422.svg";
export { ForwardRef as ReactComponent };